// Helper function to get club ID by name
function getClubId(clubName) {
  const clubMap = {
    // Premier League
    "Manchester City": 1,
    "Manchester United": 2,
    "Liverpool": 3,
    "Chelsea": 4,
    "Arsenal": 5,
    "Tottenham": 6,
    "Tottenham Hotspur": 6,
    "Newcastle": 7,
    "Aston Villa": 8,
    "Brighton": 9,
    "Brighton & Hove Albion": 9,
    "West Ham": 10,
    "Brentford": 11,
    "Bournemouth": 12,
    "Burnley": 13,
    "Crystal Palace": 14,
    "Everton": 15,
    "Fulham": 16,
    "Leeds United": 17,
    "Nottingham Forest": 18,
    "Sunderland": 19,
    "Wolves": 20,
    "Wolverhampton Wanderers": 20,
    
    // La Liga
    "Real Madrid": 21,
    "Barcelona": 22,
    "Atlético Madrid": 23,
    "Atletico Madrid": 23,
    "Sevilla": 24,
    "Villarreal": 25,
    "Real Sociedad": 26,
    "Athletic Bilbao": 27,
    "Real Betis": 28,
    "Valencia": 29,
    "Getafe": 30,
    "Osasuna": 31,
    "Rayo Vallecano": 32,
    "Celta Vigo": 33,
    "Mallorca": 34,
    "Girona": 35,

    "Elche": 36,
    "Espanyol": 37,
    "Levante": 38,
    "Real Oviedo": 39,
    "Alaves": 40,
    "Alavés": 40,
    
    // Bundesliga
    "Bayern Munich": 41,
    "Bayer Leverkusen": 42,
    "Werder Bremen": 42,
    "RB Leipzig": 44,
    "Borussia Dortmund": 45,
    "Stuttgart": 46,
    "Eintracht Frankfurt": 47,
    "Hoffenheim": 48,
    "Freiburg": 49,
    "Heidenheim": 50,
    "Wolfsburg": 51,
    "Union Berlin": 52,
    "Augsburg": 53,
    "St Pauli": 54,
    "Cologne": 55,
    "Mainz 05": 56,
    "Hamburg": 57,
    "Hertha BSC": 58,
    
    // Serie A
    "Atalanta": 59,
    "Bologna": 60,
    "Cagliari": 61,
    "Como": 62,
    "Cremonese": 63,
    "Fiorentina": 64,
    "Genoa": 65,
    "Inter": 66,
    "Juventus": 67,
    "Lazio": 68,
    "Lecce": 69,
    "Milan": 70,
    "Napoli": 71,
    "Parma": 72,
    "Pisa": 73,
    "Roma": 74,
    "Sassuolo": 75,
    "Torino": 76,
    "Udinese": 77,
    "Verona": 78,
    
    // Ligue 1
    "Angers": 79,
    "Auxerre": 80,
    "Brest": 81,
    "Le Havre": 82,
    "Lens": 83,
    "Lille": 84,
    "Lorient": 85,
    "Lyon": 86,
    "Marseille": 87,
    "Metz": 88,
    "Monaco": 89,
    "Nantes": 90,
    "Nice": 91,
    "Paris FC": 92,
    "Paris Saint-Germain": 93,
    "Rennes": 94,
    "Strasbourg": 95,
    "Toulouse": 96,
    
    // Other clubs
    "Sporting CP": 97,
    "Feyenoord": 98,
    "PSV Eindhoven": 99,
    "Ajax": 100,
    "Galatasaray": 101,
    "Al-Nassr": 102,
    "Vancouver Whitecaps": 103,
    "Sunderland": 104,
    "AZ Alkmaar": 105,
    "River Plate": 106,
    "Atlanta United": 107,
    "Flamengo": 108,
    "Celtic": 109,
    "Cruzeiro": 110,
    "Coventry City": 111,
    "Vasco da Gama": 112,
    "Club Brugge": 113,
    "Hellas Verona": 114,
    "Olympiacos": 115,
    "Millwall": 116,
    "Karlsruher SC": 117,
    "Stuttgart": 118,
    "Ipswich Town": 119,
    "Rangers": 120,
    "Botafogo": 121,
    "Birmingham City": 122,
    "Palmeiras": 124,
    "Independiente del Valle": 125,
    "RC Strasbourg": 126,
    "Al Qadsiah": 127,
    "Châteauroux": 128,
    "Braga": 129,
    "Norwich City": 130,
    "Mirandés": 131,
    "Mirandes": 132,
    "PAOK": 133,
    "Fortaleza": 134,
    "Daejeon Hana Citizen": 135,
    "Rapid Wien": 136,
    "Le Mans": 137,
    "IFK Norrköping": 138,
    "IFK Norrkoping": 138,
    "LASK": 140,
    "Free agent": 141,
    "— released —": 141,
    "Released": 141,
    "Kasımpaşa": 142,
    "TSG Hoffenheim": 143,
    "FC Copenhagen": 144,
    "Fenerbahçe": 145,
    "Motherwell": 146,
    "Beşiktaş": 147,
    "Como 1907": 148,
    "Cercle Brugge": 150,
    "Tigres UANL": 151,
    "Girona": 152,
    
  };
  
  return clubMap[clubName] || 999; // Default ID for unknown clubs
};

// Helper function to determine transfer type
function getTransferType(amount, playerName, fromClub, toClub) {
  if (amount === 0 || amount === "" || amount === null || amount === undefined) {
    // Check if it's a loan based on club name patterns
    if (toClub.includes("(loan)") || fromClub.includes("(loan)")) {
      return "loan";
    }
    return "free";
  }
  return "paid";
};

// Helper function to clean amount
function cleanAmount(amount) {
  if (amount === "" || amount === null || amount === undefined) {
    return 0;
  }
  return parseInt(amount) || 0;
};

// Helper function to clean date
function cleanDate(date) {
  if (!date || date === "" || date === "??-05-2025"|| date === "??-06-2025" || date === "??-07-2025" || date === "??-08-2025") {
    return "2025-07-01"; // Default date
  }
  
  // Convert DD-MM-YYYY to YYYY-MM-DD format
  if (date.includes('-') && date.split('-')[0].length === 2) {
    const parts = date.split('-');
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
  }
  
  return date;
};

// Helper function to clean position
function cleanPosition(position) {
  const positionMap = {
    "GK": "Goalkeeper",
    "DF": "Defender",
    "MF": "Midfielder",
    "FW": "Forward",
    "Centre-back": "Defender",
    "Left-back": "Defender",
    "Right-back": "Defender",
    "Defensive midfielder": "Midfielder",
    "Attacking midfielder": "Midfielder",
    "Winger": "Forward",
    "Striker": "Forward",
    "Winger/Forward": "Forward",
    "Centre-back/DM": "Defender",
    "DM": "Midfielder"
  };
  
  return positionMap[position] || position;
};

export const transfers = [
  // Premier League Transfers 2025/26
  {
    date: cleanDate("12-06-2025"),
    country: "ENG",
    amount: cleanAmount(10000000),
    toClubId: getClubId("Real Madrid"),
    fromClubId: getClubId("Liverpool"),
    id: 1,
    position: "Defender",
    type: "Paid",
    player: "Trent Alexander-Arnold"
},
{
    date: cleanDate("17-05-2025"),
    country: "ESP",
    amount: cleanAmount(50000000),
    toClubId: getClubId("Real Madrid"),
    fromClubId: getClubId("Bournemouth"),
    id: 2,
    position: "Defender",
    type: "Paid",
    player: "Dean Huijsen"
},
{
    date: cleanDate("21-05-2025"),
    country: "MLI",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Everton"),
    id: 3,
    position: "Midfielder",
    type: "Released",
    player: "Abdoulaye Doucouré"
},
{
    date: cleanDate("18-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Brentford"),
    id: 4,
    position: "Defender",
    type: "Released",
    player: "Ben Mee"
},
{
    date: cleanDate("01-05-2025"),
    country: "TUR",
    amount: cleanAmount(0),
    toClubId: getClubId("Aston Villa"),
    fromClubId: getClubId("Kasimpasa"),
    id: 5,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Yasin Ozcan"
},
{
    date: cleanDate("25-05-2025"),
    country: "SWE",
    amount: cleanAmount(0),
    toClubId: getClubId("Malmö"),
    fromClubId: getClubId("Aston Villa"),
    id: 6,
    position: "Goalkeeper",
    type: "Released",
    player: "Robin Olsen"
},
{
    date: cleanDate("01-05-2025"),
    country: "ENG",
    amount: cleanAmount(10000000),
    toClubId: getClubId("Brighton"),
    fromClubId: getClubId("Sunderland"),
    id: 7,
    position: "Winger",
    type: "Paid",
    player: "Tom Watson"
},
{
    date: cleanDate("01-05-2025"),
    country: "BRA",
    amount: cleanAmount(28560000),
    toClubId: getClubId("Chelsea"),
    fromClubId: getClubId("Palmeiras"),
    id: 8,
    position: "Winger",
    type: "Paid",
    player: "Estêvão"
},
{
    date: cleanDate("21-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Chelsea"),
    id: 9,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Bashir Humphreys"
},
{
    date: cleanDate("01-05-2025"),
    country: "GEO",
    amount: cleanAmount(25000000),
    toClubId: getClubId("Liverpool"),
    fromClubId: getClubId("Valencia"),
    id: 10,
    position: "Goalkeeper",
    type: "Paid",
    player: "Giorgi Mamardashvili"
},
{
    date: cleanDate("12-06-2025"),
    country: "BEL",
    amount: cleanAmount(0),
    toClubId: getClubId("Napoli"),
    fromClubId: getClubId("Manchester City"),
    id: 11,
    position: "Midfielder",
    type: "Free ",
    player: "Kevin De Bruyne"
},
{
    date: cleanDate("22-05-2025"),
    country: "SVK",
    amount: cleanAmount(0),
    toClubId: getClubId("Toulouse"),
    fromClubId: getClubId("Zilina"),
    id: 12,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Mario Sauer"
},
{
    date: cleanDate("21-05-2025"),
    country: "GER",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Freiburg"),
    fromClubId: getClubId("Hertha BSC"),
    id: 13,
    position: "Forward",
    type: "Paid",
    player: "Derry Scherhant"
},
{
    date: cleanDate("21-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Bournemouth"),
    id: 14,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Jaidon Anthony"
},
{
    date: cleanDate("21-05-2025"),
    country: "ENG",
    amount: cleanAmount(8400000),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Sporting CP"),
    id: 15,
    position: "Winger",
    type: "Paid",
    player: "Marcus Edwards"
},
{
    date: cleanDate("29-05-2025"),
    country: "NED",
    amount: cleanAmount(0),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Millwall"),
    id: 16,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Zian Flemming"
},
{
    date: cleanDate("21-05-2025"),
    country: "ECU",
    amount: cleanAmount(0),
    toClubId: getClubId("Brighton"),
    fromClubId: getClubId("Burnley"),
    id: 17,
    position: "Winger",
    type: "Return",
    player: "Jeremy Sarmiento"
},
{
    date: cleanDate("21-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Burnley"),
    id: 18,
    position: "Winger",
    type: "Released",
    player: "Nathan Redmond"
},
{
    date: cleanDate("21-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Burnley"),
    id: 19,
    position: "Midfielder",
    type: "Released",
    player: "Jonjo Shelvey"
},
{
    date: cleanDate("20-05-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Olympiacos"),
    fromClubId: getClubId("Lille"),
    id: 20,
    position: "Midfielder",
    type: "Free",
    player: "Rémy Cabella"
},
{
    date: cleanDate("20-05-2025"),
    country: "JPN",
    amount: cleanAmount(6700000),
    toClubId: getClubId("Freiburg"),
    fromClubId: getClubId("Brøndby"),
    id: 21,
    position: "Midfielder",
    type: "Paid",
    player: "Yuito Suzuki"
},
{
    date: cleanDate("26-05-2025"),
    country: "SWE",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Manchester United"),
    id: 22,
    position: "Defender",
    type: "Released",
    player: "Victor Lindelöf"
},
{
    date: cleanDate("30-06-2025"),
    country: "NIR",
    amount: cleanAmount(0),
    toClubId: getClubId("Retired"),
    fromClubId: getClubId("Manchester United"),
    id: 23,
    position: "Defender",
    type: "Retired",
    player: "Jonny Evans"
},
{
    date: cleanDate("26-05-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Manchester United"),
    id: 24,
    position: "Midfielder",
    type: "Released",
    player: "Christian Eriksen"
},
{
    date: cleanDate("26-05-2025"),
    country: "SCO",
    amount: cleanAmount(0),
    toClubId: getClubId("Union Berlin"),
    fromClubId: getClubId("Werder Bremen"),
    id: 25,
    position: "Forward",
    type: "Free",
    player: "Oliver Burke"
},
{
    date: cleanDate("23-05-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Hoffenheim"),
    fromClubId: getClubId("Nuremberg"),
    id: 26,
    position: "Defender",
    type: "Return",
    player: "Tim Drexler"
},
{
    date: cleanDate("26-05-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Freiburg"),
    fromClubId: getClubId("Werder Bremen"),
    id: 27,
    position: "Defender",
    type: "Free",
    player: "Anthony Jung"
},
{
    date: cleanDate("24-05-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Montpellier"),
    fromClubId: getClubId("Lorient"),
    id: 28,
    position: "Defender",
    type: "Free",
    player: "Julien Laporte"
},
{
    date: cleanDate("23-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Crystal Palace"),
    id: 29,
    position: "Defender",
    type: "Released",
    player: "Joel Ward"
},
{
    date: cleanDate("23-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Ipswich Town"),
    fromClubId: getClubId("Everton"),
    id: 30,
    position: "Defender",
    type: "Free",
    player: "Ashley Young"
},
{
    date: cleanDate("09-05-2025"),
    country: "POL",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("West Ham"),
    id: 31,
    position: "Goalkeeper",
    type: "Released",
    player: "Lukasz Fabianski"
},
{
    date: cleanDate("01-05-2025"),
    country: "CRO",
    amount: cleanAmount(12000000),
    toClubId: getClubId("Tottenham"),
    fromClubId: getClubId("Hajduk Split"),
    id: 32,
    position: "Defender",
    type: "Paid",
    player: "Luka Vuskovic"
},
{
    date: cleanDate("19-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Northampton"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 33,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Jack Perkins"
},
{
    date: cleanDate("26-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Leeds United"),
    fromClubId: getClubId("Everton"),
    id: 34,
    position: "Winger",
    type: "Return",
    player: "Jack Harrison"
},
{
    date: cleanDate("25-05-2025"),
    country: "BEL",
    amount: cleanAmount(0),
    toClubId: getClubId("Lyon"),
    fromClubId: getClubId("Everton"),
    id: 35,
    position: "Midfielder",
    type: "Return",
    player: "Orel Mangala"
},
{
    date: cleanDate("26-05-2025"),
    country: "ALB",
    amount: cleanAmount(0),
    toClubId: getClubId("Chelsea"),
    fromClubId: getClubId("Everton"),
    id: 36,
    position: "Forward",
    type: "Return",
    player: "Armando Broja"
},
{
    date: cleanDate("25-05-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Napoli"),
    fromClubId: getClubId("Everton"),
    id: 37,
    position: "Winger",
    type: "Return",
    player: "Jesper Lindstrøm"
},
{
    date: cleanDate("09-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("West Ham"),
    id: 38,
    position: "Forward",
    type: "Released",
    player: "Danny Ings"
},
{
    date: cleanDate("17-05-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Leeds United"),
    id: 39,
    position: "Midfielder",
    type: "Released",
    player: "Josuha Guilavogui"
},
{
    date: cleanDate("29-07-2025"),
    country: "BIH",
    amount: cleanAmount(0),
    toClubId: getClubId("Leicester City"),
    fromClubId: getClubId("Everton"),
    id: 40,
    position: "Goalkeeper",
    type: "Free ",
    player: "Asmir Begovic"
},
{
    date: cleanDate("25-07-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Sporting CP"),
    fromClubId: getClubId("Everton"),
    id: 41,
    position: "Goalkeeper",
    type: "Free",
    player: "João Virginia"
},
{
    date: cleanDate("26-05-2025"),
    country: "ITA",
    amount: cleanAmount(11330000),
    toClubId: getClubId("Fiorentina"),
    fromClubId: getClubId("Juventus"),
    id: 42,
    position: "Midfielder",
    type: "Paid",
    player: "Nicolò Fagioli"
},
{
    date: cleanDate("01-05-2025"),
    country: "ALG",
    amount: cleanAmount(10070000),
    toClubId: getClubId("Bayer Leverkusen"),
    fromClubId: getClubId("Hertha BSC"),
    id: 43,
    position: "Midfielder",
    type: "Paid",
    player: "Ibrahim Maza"
},
{
    date: cleanDate("14-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Monaco"),
    fromClubId: getClubId("Bayern Munich"),
    id: 44,
    position: "Defender",
    type: "Free",
    player: "Eric Dier"
},
{
    date: cleanDate("06-08-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Vancouver Whitecaps"),
    fromClubId: getClubId("Bayern Munich"),
    id: 45,
    position: "Forward",
    type: "Free",
    player: "Thomas Müller"
},
{
    date: cleanDate("27-05-2025"),
    country: "SUI",
    amount: cleanAmount(3770000),
    toClubId: getClubId("Augsburg"),
    fromClubId: getClubId("Wolfsburg"),
    id: 46,
    position: "Defender",
    type: "Paid",
    player: "Cédric Zesiger"
},
{
    date: cleanDate("19-05-2025"),
    country: "BUR",
    amount: cleanAmount(8380000),
    toClubId: getClubId("Freiburg"),
    fromClubId: getClubId("Troyes"),
    id: 47,
    position: "Forward",
    type: "Paid",
    player: "Cyriaque Irié"
},
{
    date: cleanDate("26-05-2025"),
    country: "MAR",
    amount: cleanAmount(0),
    toClubId: getClubId("Bayern Munich"),
    fromClubId: getClubId("Real Valladolid"),
    id: 48,
    position: "Defender",
    type: "Return",
    player: "Adam Aznou"
},
{
    date: cleanDate("01-05-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Bayern Munich"),
    fromClubId: getClubId("Hoffenheim"),
    id: 49,
    position: "Midfielder",
    type: "Free",
    player: "Tom Bischof"
},
{
    date: cleanDate("09-04-2025"),
    country: "NED",
    amount: cleanAmount(13400000),
    toClubId: getClubId("RB Leipzig"),
    fromClubId: getClubId("OH Leuven"),
    id: 50,
    position: "Midfielder",
    type: "Paid",
    player: "Ezechiel Banzuzi"
},
{
    date: cleanDate("21-03-2025"),
    country: "KOR",
    amount: cleanAmount(0),
    toClubId: getClubId("Brighton"),
    fromClubId: getClubId("Daejon Hana Citizen"),
    id: 51,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Yoon Do-young"
},
{
    date: cleanDate("02-06-2025"),
    country: "POR",
    amount: cleanAmount(18500000),
    toClubId: getClubId("Chelsea"),
    fromClubId: getClubId("Sporting CP"),
    id: 52,
    position: "Midfielder",
    type: "Paid",
    player: "Dário Essugo"
},
{
    date: cleanDate("28-05-2025"),
    country: "ITA",
    amount: cleanAmount(13500000),
    toClubId: getClubId("Brentford"),
    fromClubId: getClubId("Fiorentina"),
    id: 53,
    position: "Defender",
    type: "Paid",
    player: "Michael Kayode"
},
{
    date: cleanDate("28-05-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Al-Arabi"),
    fromClubId: getClubId("Wolves"),
    id: 54,
    position: "Winger",
    type: "Free",
    player: "Pablo Sarabia"
},
{
    date: cleanDate("28-05-2025"),
    country: "GER",
    amount: cleanAmount(335000),
    toClubId: getClubId("Elversberg"),
    fromClubId: getClubId("Stuttgart"),
    id: 55,
    position: "Forward",
    type: "Paid",
    player: "Luca Pfeiffer"
},
{
    date: cleanDate("28-05-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Holstein Kiel"),
    fromClubId: getClubId("Freiburg"),
    id: 56,
    position: "Midfielder",
    type: "Loan",
    player: "Robert Wagner"
},
{
    date: cleanDate("28-05-2025"),
    country: "KOR",
    amount: cleanAmount(3360000),
    toClubId: getClubId("Union Berlin"),
    fromClubId: getClubId("Stuttgart"),
    id: 57,
    position: "Midfielder",
    type: "Paid",
    player: "Jeong Woo-yeong"
},
{
    date: cleanDate("27-05-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Krasnodar"),
    fromClubId: getClubId("Auxerre"),
    id: 58,
    position: "Defender",
    type: "Free",
    player: "Jubal"
},
{
    date: cleanDate("28-05-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Red Bull Salzburg"),
    fromClubId: getClubId("Bayern Munich"),
    id: 59,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Frans Krätzig"
},
{
    date: cleanDate("01-05-2025"),
    country: "ARG",
    amount: cleanAmount(23560000),
    toClubId: getClubId("Juventus"),
    fromClubId: getClubId("Fiorentina"),
    id: 60,
    position: "Winger",
    type: "Paid",
    player: "Nicolás González"
},
{
    date: cleanDate("01-05-2025"),
    country: "BRA",
    amount: cleanAmount(25150000),
    toClubId: getClubId("Borussia Dortmund"),
    fromClubId: getClubId("Manchester City"),
    id: 61,
    position: "Defender",
    type: "Paid",
    player: "Yan Couto"
},
{
    date: cleanDate("24-05-2025"),
    country: "AUT",
    amount: cleanAmount(21000000),
    toClubId: getClubId("Tottenham"),
    fromClubId: getClubId("Lens"),
    id: 62,
    position: "Defender",
    type: "Paid",
    player: "Kevin Danso"
},
{
    date: cleanDate("29-05-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Bayern Munich"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 63,
    position: "Defender",
    type: "Free",
    player: "Jonathan Tah"
},
{
    date: cleanDate("29-05-2025"),
    country: "GER",
    amount: cleanAmount(1680000),
    toClubId: getClubId("Bayer Leverkusen"),
    fromClubId: getClubId("Bochum"),
    id: 64,
    position: "Defender",
    type: "Paid",
    player: "Tim Oermann"
},
{
    date: cleanDate("29-05-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Osasuna"),
    fromClubId: getClubId("Leganés"),
    id: 65,
    position: "Defender",
    type: "Free",
    player: "Valentin Rosier"
},
{
    date: cleanDate("29-05-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Fortuna Düsseldorf"),
    fromClubId: getClubId("Hoffenheim"),
    id: 66,
    position: "Defender",
    type: "Free",
    player: "Christopher Lenz"
},
{
    date: cleanDate("30-05-2025"),
    country: "NED",
    amount: cleanAmount(29500000),
    toClubId: getClubId("Liverpool"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 67,
    position: "Defender",
    type: "Paid",
    player: "Jeremie Frimpong"
},
{
    date: cleanDate("30-05-2025"),
    country: "GER",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Southampton"),
    fromClubId: getClubId("Hoffenheim"),
    id: 68,
    position: "Defender",
    type: "Paid",
    player: "Joshua Quarshie"
},
{
    date: cleanDate("30-05-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Paderborn"),
    fromClubId: getClubId("Stuttgart"),
    id: 69,
    position: "Goalkeeper",
    type: "Loan",
    player: "Dennis Seimen"
},
{
    date: cleanDate("30-05-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Karlsruher SC"),
    fromClubId: getClubId("Bayern Munich"),
    id: 70,
    position: "Defender",
    type: "Loan",
    player: "Paul Scholl"
},
{
    date: cleanDate("30-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Northampton"),
    fromClubId: getClubId("West Ham"),
    id: 71,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Kamarai Swyer"
},
{
    date: cleanDate("12-06-2025"),
    country: "BRA",
    amount: cleanAmount(62500000),
    toClubId: getClubId("Manchester United"),
    fromClubId: getClubId("Wolves"),
    id: 72,
    position: "Forward",
    type: "Paid",
    player: "Matheus Cunha"
},
{
    date: cleanDate("01-06-2025"),
    country: "GER",
    amount: cleanAmount(8430000),
    toClubId: getClubId("Mainz 05"),
    fromClubId: getClubId("Union Berlin"),
    id: 73,
    position: "Forward",
    type: "Paid",
    player: "Benedict Hollerbach"
},
{
    date: cleanDate("31-05-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Tottenham"),
    id: 74,
    position: "Defender",
    type: "Released",
    player: "Sergio Reguilón"
},
{
    date: cleanDate("31-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Tottenham"),
    id: 75,
    position: "Goalkeeper",
    type: "Released",
    player: "Fraser Forster"
},
{
    date: cleanDate("31-05-2025"),
    country: "ARG",
    amount: cleanAmount(13000000),
    toClubId: getClubId("Everton"),
    fromClubId: getClubId("Flamengo"),
    id: 76,
    position: "Midfielder",
    type: "Paid",
    player: "Carlos Alcaraz"
},
{
    date: cleanDate("02-06-2025"),
    country: "GER",
    amount: cleanAmount(2110000),
    toClubId: getClubId("Hamburg"),
    fromClubId: getClubId("Holstein Kiel"),
    id: 77,
    position: "Midfielder",
    type: "Paid",
    player: "Nicolai Remberg"
},
{
    date: cleanDate("28-05-2025"),
    country: "ENG",
    amount: cleanAmount(2300000),
    toClubId: getClubId("Norwich City"),
    fromClubId: getClubId("Manchester City"),
    id: 78,
    position: "Midfielder",
    type: "Paid",
    player: "Jacob Wright"
},
{
    date: cleanDate("06-06-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Flamengo"),
    fromClubId: getClubId("Arsenal"),
    id: 79,
    position: "Midfielder",
    type: "Free",
    player: "Jorginho"
},
{
    date: cleanDate("30-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Brentford"),
    id: 80,
    position: "Goalkeeper",
    type: "Released",
    player: "Ben Winterbottom"
},
{
    date: cleanDate("02-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Brentford"),
    fromClubId: getClubId("Birmingham City"),
    id: 81,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Romelle Donovan"
},
{
    date: cleanDate("01-06-2025"),
    country: "ISL",
    amount: cleanAmount(4600000),
    toClubId: getClubId("Cologne"),
    fromClubId: getClubId("Fortuna Düsseldorf"),
    id: 82,
    position: "Midfielder",
    type: "Paid",
    player: "Isak Johannesson"
},
{
    date: cleanDate("01-06-2025"),
    country: "ROU",
    amount: cleanAmount(0),
    toClubId: getClubId("Genoa"),
    fromClubId: getClubId("Damac"),
    id: 83,
    position: "Midfielder",
    type: "Free",
    player: "Nicolae Stanciu"
},
{
    date: cleanDate("31-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Tottenham"),
    id: 84,
    position: "Goalkeeper",
    type: "Released",
    player: "Alfie Whiteman"
},
{
    date: cleanDate("03-06-2025"),
    country: "NED",
    amount: cleanAmount(8420000),
    toClubId: getClubId("Bayer Leverkusen"),
    fromClubId: getClubId("Brentford"),
    id: 85,
    position: "Goalkeeper",
    type: "Paid",
    player: "Mark Flekken"
},
{
    date: cleanDate("03-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Bochum"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 86,
    position: "Midfielder",
    type: "Loan",
    player: "Francis Onyeka"
},
{
    date: cleanDate("02-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Hoffenheim"),
    fromClubId: getClubId("Cologne"),
    id: 87,
    position: "Forward",
    type: "Free",
    player: "Tim Lemperle"
},
{
    date: cleanDate("02-06-2025"),
    country: "SRB",
    amount: cleanAmount(4210000),
    toClubId: getClubId("Union Berlin"),
    fromClubId: getClubId("Lille"),
    id: 88,
    position: "Forward",
    type: "Paid",
    player: "Andrej Ilic"
},
{
    date: cleanDate("03-06-2025"),
    country: "ESP",
    amount: cleanAmount(5050000),
    toClubId: getClubId("Como"),
    fromClubId: getClubId("Barcelona"),
    id: 89,
    position: "Defender",
    type: "Paid",
    player: "Àlex Valle"
},
{
    date: cleanDate("02-06-2025"),
    country: "FRA",
    amount: cleanAmount(2110000),
    toClubId: getClubId("Saint-Etienne"),
    fromClubId: getClubId("Augsburg"),
    id: 90,
    position: "Forward",
    type: "Paid",
    player: "Irvin Cardona"
},
{
    date: cleanDate("03-06-2025"),
    country: "IRL",
    amount: cleanAmount(12500000),
    toClubId: getClubId("Brentford"),
    fromClubId: getClubId("Liverpool"),
    id: 91,
    position: "Goalkeeper",
    type: "Paid",
    player: "Caoimhín Kelleher"
},
{
    date: cleanDate("03-06-2025"),
    country: "FRA",
    amount: cleanAmount(20000000),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("Roma"),
    id: 92,
    position: "Midfielder",
    type: "Paid",
    player: "Enzo Le Fée"
},
{
    date: cleanDate("23-07-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Grêmio"),
    fromClubId: getClubId("Fulham"),
    id: 93,
    position: "Forward",
    type: "Free",
    player: "Carlos Vinícius"
},
{
    date: cleanDate("04-06-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Fulham"),
    id: 94,
    position: "Winger",
    type: "Released",
    player: "Willian"
},
{
    date: cleanDate("04-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Chelsea"),
    fromClubId: getClubId("Arsenal"),
    id: 95,
    position: "Winger",
    type: "Return",
    player: "Raheem Sterling"
},
{
    date: cleanDate("04-06-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Bournemouth"),
    fromClubId: getClubId("Arsenal"),
    id: 96,
    position: "Goalkeeper",
    type: "Return",
    player: "Neto"
},
{
    date: cleanDate("10-06-2025"),
    country: "SCO",
    amount: cleanAmount(0),
    toClubId: getClubId("Celtic"),
    fromClubId: getClubId("Arsenal"),
    id: 97,
    position: "Defender",
    type: "Free ",
    player: "Kieran Tierney"
},
{
    date: cleanDate("04-06-2025"),
    country: "CRO",
    amount: cleanAmount(14000000),
    toClubId: getClubId("Inter"),
    fromClubId: getClubId("Dinamo Zagreb"),
    id: 98,
    position: "Midfielder",
    type: "Paid",
    player: "Petar Sucic"
},
{
    date: cleanDate("31-05-2025"),
    country: "DEN",
    amount: cleanAmount(17000000),
    toClubId: getClubId("Marseille"),
    fromClubId: getClubId("Tottenham"),
    id: 99,
    position: "Midfielder",
    type: "Paid",
    player: "Pierre-Émile Højbjerg"
},
{
    date: cleanDate("04-06-2025"),
    country: "GER",
    amount: cleanAmount(337000),
    toClubId: getClubId("Fortuna Düsseldorf"),
    fromClubId: getClubId("Freiburg"),
    id: 100,
    position: "Defender",
    type: "Paid",
    player: "Kenneth Schmidt"
},
{
    date: cleanDate("04-06-2025"),
    country: "ENG",
    amount: cleanAmount(30000000),
    toClubId: getClubId("Chelsea"),
    fromClubId: getClubId("Ipswich Town"),
    id: 101,
    position: "Forward",
    type: "Paid",
    player: "Liam Delap"
},
{
    date: cleanDate("05-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Newcastle"),
    fromClubId: getClubId("Málaga"),
    id: 102,
    position: "Winger",
    type: "Released",
    player: "Antonio Cordero"
},
{
    date: cleanDate("05-06-2025"),
    country: "POR",
    amount: cleanAmount(6500000),
    toClubId: getClubId("Lazio"),
    fromClubId: getClubId("Arsenal"),
    id: 103,
    position: "Defender",
    type: "Paid",
    player: "Nuno Tavares"
},
{
    date: cleanDate("05-06-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Hoffenheim"),
    fromClubId: getClubId("Bochum"),
    id: 104,
    position: "Defender",
    type: "Free",
    player: "Bernardo"
},
{
    date: cleanDate("05-06-2025"),
    country: "COD",
    amount: cleanAmount(0),
    toClubId: getClubId("Stuttgart"),
    fromClubId: getClubId("Red Star Belgrade"),
    id: 105,
    position: "Forward",
    type: "Return",
    player: "Silas"
},
{
    date: cleanDate("05-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Sandhausen"),
    fromClubId: getClubId("Cologne"),
    id: 106,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Teoman Akmestanli"
},
{
    date: cleanDate("05-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Valencia"),
    fromClubId: getClubId("Leganés"),
    id: 107,
    position: "Winger",
    type: "Free",
    player: "Dani Raba"
},
{
    date: cleanDate("01-06-2025"),
    country: "POR",
    amount: cleanAmount(4000000),
    toClubId: getClubId("Sporting CP"),
    fromClubId: getClubId("Real Betis"),
    id: 108,
    position: "Goalkeeper",
    type: "Paid",
    player: "Rui Silva"
},
{
    date: cleanDate("30-05-2025"),
    country: "URU",
    amount: cleanAmount(0),
    toClubId: getClubId("Sint-Truiden"),
    fromClubId: getClubId("Villarreal"),
    id: 109,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Andrés Ferrari"
},
{
    date: cleanDate("01-05-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Rayo Vallecano"),
    fromClubId: getClubId("River Plate"),
    id: 110,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Augusto Batalla"
},
{
    date: cleanDate("06-06-2025"),
    country: "FRA",
    amount: cleanAmount(10100000),
    toClubId: getClubId("Stuttgart"),
    fromClubId: getClubId("Rennes"),
    id: 111,
    position: "Defender",
    type: "Paid",
    player: "Lorenz Assignon"
},
{
    date: cleanDate("06-06-2025"),
    country: "GER",
    amount: cleanAmount(3360000),
    toClubId: getClubId("Union Berlin"),
    fromClubId: getClubId("Paderborn"),
    id: 112,
    position: "Forward",
    type: "Paid",
    player: "Ilyas Ansah"
},
{
    date: cleanDate("06-06-2025"),
    country: "AUT",
    amount: cleanAmount(0),
    toClubId: getClubId("St Pauli"),
    fromClubId: getClubId("Austria Klagenfurt"),
    id: 113,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Jannik Robatsch"
},
{
    date: cleanDate("06-06-2025"),
    country: "ENG",
    amount: cleanAmount(20000000),
    toClubId: getClubId("Juventus"),
    fromClubId: getClubId("Newcastle"),
    id: 114,
    position: "Defender",
    type: "Paid",
    player: "Lloyd Kelly"
},
{
    date: cleanDate("06-06-2025"),
    country: "FRA",
    amount: cleanAmount(32800000),
    toClubId: getClubId("West Ham"),
    fromClubId: getClubId("Nice"),
    id: 115,
    position: "Defender",
    type: "Paid",
    player: "Jean-Clair Todibo"
},
{
    date: cleanDate("07-06-2025"),
    country: "BRA",
    amount: cleanAmount(21000000),
    toClubId: getClubId("Inter"),
    fromClubId: getClubId("Marseille"),
    id: 116,
    position: "Winger",
    type: "Paid",
    player: "Luis Henrique"
},
{
    date: cleanDate("07-06-2025"),
    country: "HUN",
    amount: cleanAmount(1500000),
    toClubId: getClubId("Liverpool"),
    fromClubId: getClubId("Puskás Akadémia"),
    id: 117,
    position: "Goalkeeper",
    type: "Paid",
    player: "Armin Pecsi"
},
{
    date: cleanDate("07-06-2025"),
    country: "ARG",
    amount: cleanAmount(6720000),
    toClubId: getClubId("Parma"),
    fromClubId: getClubId("Vélez Sarsfield"),
    id: 118,
    position: "Midfielder",
    type: "Paid",
    player: "Christian Ordóñez"
},
{
    date: cleanDate("06-06-2025"),
    country: "NIR",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Newcastle"),
    id: 119,
    position: "Defender",
    type: "Released",
    player: "Jamal Lewis"
},
{
    date: cleanDate("06-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Paris Saint-Germain"),
    fromClubId: getClubId("West Ham"),
    id: 120,
    position: "Midfielder",
    type: "Return",
    player: "Carlos Soler"
},
{
    date: cleanDate("06-06-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Brighton"),
    fromClubId: getClubId("West Ham"),
    id: 121,
    position: "Forward",
    type: "Return",
    player: "Evan Ferguson"
},
{
    date: cleanDate("31-05-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("RB Leipzig"),
    fromClubId: getClubId("Tottenham"),
    id: 122,
    position: "Winger",
    type: "Return",
    player: "Timo Werner"
},
{
    date: cleanDate("06-06-2025"),
    country: "GUD",
    amount: cleanAmount(0),
    toClubId: getClubId("Auxerre"),
    fromClubId: getClubId("Le Havre"),
    id: 123,
    position: "Winger",
    type: "Free",
    player: "Josué Casimir"
},
{
    date: cleanDate("06-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Nice"),
    fromClubId: getClubId("Le Mans"),
    id: 124,
    position: "Midfielder",
    type: "Free",
    player: "Gabin Bernardeau"
},
{
    date: cleanDate("09-06-2025"),
    country: "FRA",
    amount: cleanAmount(12000000),
    toClubId: getClubId("Chelsea"),
    fromClubId: getClubId("Strasbourg"),
    id: 125,
    position: "Defender",
    type: "Paid",
    player: "Mamadou Sarr"
},
{
    date: cleanDate("09-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Manchester City"),
    id: 126,
    position: "Goalkeeper",
    type: "Released",
    player: "Scott Carson"
},
{
    date: cleanDate("02-06-2025"),
    country: "INA",
    amount: cleanAmount(0),
    toClubId: getClubId("Borussia Mönchengladbach"),
    fromClubId: getClubId("FC Copenhagen"),
    id: 127,
    position: "Defender",
    type: "Free",
    player: "Kevin Diks"
},
{
    date: cleanDate("08-06-2025"),
    country: "AUT",
    amount: cleanAmount(0),
    toClubId: getClubId("Red Bull Salzburg"),
    fromClubId: getClubId("Borussia Mönchengladbach"),
    id: 128,
    position: "Defender",
    type: "Free",
    player: "Stefan Lainer"
},
{
    date: cleanDate("09-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Darmstadt"),
    fromClubId: getClubId("Wolfsburg"),
    id: 129,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Benedikt Börner"
},
{
    date: cleanDate("09-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("SSV Ulm"),
    fromClubId: getClubId("Hoffenheim"),
    id: 130,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Lukas Mazagg"
},
{
    date: cleanDate("01-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Manchester United"),
    fromClubId: getClubId("Chelsea"),
    id: 131,
    position: "Winger",
    type: "Return",
    player: "Jadon Sancho"
},
{
    date: cleanDate("09-06-2025"),
    country: "BRA",
    amount: cleanAmount(7600000),
    toClubId: getClubId("Real Betis"),
    fromClubId: getClubId("Napoli"),
    id: 132,
    position: "Defender",
    type: "Paid",
    player: "Natan"
},
{
    date: cleanDate("02-06-2025"),
    country: "ENG",
    amount: cleanAmount(5900000),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Southampton"),
    id: 133,
    position: "Winger",
    type: "Paid",
    player: "Samuel Amo-Ameyaw"
},
{
    date: cleanDate("03-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Paderborn"),
    fromClubId: getClubId("Wolfsburg"),
    id: 134,
    position: "Midfielder",
    type: "Free",
    player: "Bennit Bröger"
},
{
    date: cleanDate("01-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("QPR"),
    fromClubId: getClubId("Brest"),
    id: 135,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Karamoko Dembélé"
},
{
    date: cleanDate("01-06-2025"),
    country: "BEL",
    amount: cleanAmount(0),
    toClubId: getClubId("Paris FC"),
    fromClubId: getClubId("Reims"),
    id: 136,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Thibault De Smet"
},
{
    date: cleanDate("05-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Valenciennes"),
    fromClubId: getClubId("Toulouse"),
    id: 137,
    position: "Goalkeeper",
    type: "Free",
    player: "Justin Lacombe"
},
{
    date: cleanDate("09-06-2025"),
    country: "ALG",
    amount: cleanAmount(31000000),
    toClubId: getClubId("Manchester City"),
    fromClubId: getClubId("Wolves"),
    id: 138,
    position: "Defender",
    type: "Paid",
    player: "Rayan Aït-Nouri"
},
{
    date: cleanDate("09-06-2025"),
    country: "BRA",
    amount: cleanAmount(2500000),
    toClubId: getClubId("Cruzeiro"),
    fromClubId: getClubId("Arsenal"),
    id: 139,
    position: "Winger",
    type: "Paid",
    player: "Marquinhos"
},
{
    date: cleanDate("10-06-2025"),
    country: "ENG",
    amount: cleanAmount(27000000),
    toClubId: getClubId("Borussia Dortmund"),
    fromClubId: getClubId("Sunderland"),
    id: 140,
    position: "Midfielder",
    type: "Paid",
    player: "Jobe Bellingham"
},
{
    date: cleanDate("10-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Manchester City"),
    fromClubId: getClubId("Chelsea"),
    id: 141,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Marcus Bettinelli"
},
{
    date: cleanDate("10-06-2025"),
    country: "WAL",
    amount: cleanAmount(0),
    toClubId: getClubId("Stevenage"),
    fromClubId: getClubId("Wolves"),
    id: 142,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Chem Campbell"
},
{
    date: cleanDate("10-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Port Vale"),
    fromClubId: getClubId("Aston Villa"),
    id: 143,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Rico Richards"
},
{
    date: cleanDate("10-06-2025"),
    country: "FRA",
    amount: cleanAmount(30500000),
    toClubId: getClubId("Manchester City"),
    fromClubId: getClubId("Lyon"),
    id: 144,
    position: "Midfielder",
    type: "Paid",
    player: "Rayan Cherki"
},
{
    date: cleanDate("11-06-2025"),
    country: "NED",
    amount: cleanAmount(46600000),
    toClubId: getClubId("Manchester City"),
    fromClubId: getClubId("Milan"),
    id: 145,
    position: "Midfielder",
    type: "Paid",
    player: "Tijjani Reijnders"
},
{
    date: cleanDate("11-06-2025"),
    country: "CRO",
    amount: cleanAmount(850000),
    toClubId: getClubId("Kaiserslautern"),
    fromClubId: getClubId("Union Berlin"),
    id: 146,
    position: "Forward",
    type: "Paid",
    player: "Ivan Prtajin"
},
{
    date: cleanDate("11-06-2025"),
    country: "GUI",
    amount: cleanAmount(3800000),
    toClubId: getClubId("Lens"),
    fromClubId: getClubId("St Pauli"),
    id: 147,
    position: "Forward",
    type: "Paid",
    player: "Morgan Guilavogui"
},
{
    date: cleanDate("11-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Bayer Leverkusen"),
    fromClubId: getClubId("Paris Saint-Germain"),
    id: 148,
    position: "Midfielder",
    type: "Free",
    player: "Axel Tape"
},
{
    date: cleanDate("09-06-2025"),
    country: "ROU",
    amount: cleanAmount(0),
    toClubId: getClubId("Celta Vigo"),
    fromClubId: getClubId("Venezia"),
    id: 149,
    position: "Goalkeeper",
    type: "Free",
    player: "Ionut Radu"
},
{
    date: cleanDate("11-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Espanyol"),
    fromClubId: getClubId("Granada"),
    id: 150,
    position: "Defender",
    type: "Free",
    player: "Miguel Rubio"
},
{
    date: cleanDate("10-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Espanyol"),
    fromClubId: getClubId("Real Betis"),
    id: 151,
    position: "Forward",
    type: "Free",
    player: "Marcos Fernández"
},
{
    date: cleanDate("10-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Espanyol"),
    fromClubId: getClubId("Villarreal"),
    id: 152,
    position: "Defender",
    type: "Free",
    player: "Hugo Pérez"
},
{
    date: cleanDate("11-06-2025"),
    country: "NGR",
    amount: cleanAmount(0),
    toClubId: getClubId("Hamburg"),
    fromClubId: getClubId("KAA Gent"),
    id: 153,
    position: "Defender",
    type: "Free",
    player: "Jordan Torunarigha"
},
{
    date: cleanDate("10-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Swindon Town"),
    fromClubId: getClubId("Wolves"),
    id: 154,
    position: "Defender",
    type: "Free",
    player: "Filozofe Mabete"
},
{
    date: cleanDate("10-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Swindon Town"),
    fromClubId: getClubId("Leeds United"),
    id: 155,
    position: "Midfielder",
    type: "Free",
    player: "Joe Snowdon"
},
{
    date: cleanDate("11-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Marseille"),
    fromClubId: getClubId("Lille"),
    id: 156,
    position: "Midfielder",
    type: "Free",
    player: "Angel Gomes"
},
{
    date: cleanDate("11-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Galatasaray"),
    fromClubId: getClubId("Bayern Munich"),
    id: 157,
    position: "Winger",
    type: "Free",
    player: "Leroy Sané"
},
{
    date: cleanDate("12-06-2025"),
    country: "SUI",
    amount: cleanAmount(6800000),
    toClubId: getClubId("Hoffenheim"),
    fromClubId: getClubId("Basel"),
    id: 158,
    position: "Midfielder",
    type: "Paid",
    player: "Leon Avdullahu"
},
{
    date: cleanDate("12-06-2025"),
    country: "GBS",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Venezia"),
    fromClubId: getClubId("Metz"),
    id: 159,
    position: "Defender",
    type: "Paid",
    player: "Fali Candé"
},
{
    date: cleanDate("12-06-2025"),
    country: "SEN",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Al-Duhail"),
    fromClubId: getClubId("Real Betis"),
    id: 160,
    position: "Defender",
    type: "Paid",
    player: "Youssouf Sabaly"
},
{
    date: cleanDate("12-06-2025"),
    country: "SWE",
    amount: cleanAmount(7700000),
    toClubId: getClubId("Benfica"),
    fromClubId: getClubId("Roma"),
    id: 161,
    position: "Defender",
    type: "Paid",
    player: "Samuel Dahl"
},
{
    date: cleanDate("12-06-2025"),
    country: "GRE",
    amount: cleanAmount(29800000),
    toClubId: getClubId("Brighton"),
    fromClubId: getClubId("Olympiacos"),
    id: 162,
    position: "Forward",
    type: "Paid",
    player: "Charalampos Kostoulas"
},
{
    date: cleanDate("14-08-2025"),
    country: "ARG",
    amount: cleanAmount(38500000),
    toClubId: getClubId("Real Madrid"),
    fromClubId: getClubId("River Plate"),
    id: 163,
    position: "Midfielder",
    type: "Paid",
    player: "Franco Mastantuono"
},
{
    date: cleanDate("13-06-2025"),
    country: "AUS",
    amount: cleanAmount(0),
    toClubId: getClubId("Mainz 05"),
    fromClubId: getClubId("Melbourne Victory"),
    id: 164,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Kasey Bos"
},
{
    date: cleanDate("26-05-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Retired"),
    fromClubId: getClubId("Roma"),
    id: 165,
    position: "Defender",
    type: "Retired",
    player: "Mats Hummels"
},
{
    date: cleanDate("14-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("St Pauli"),
    fromClubId: getClubId("Peterborough"),
    id: 166,
    position: "Forward",
    type: "Free",
    player: "Ricky-Jade Jones"
},
{
    date: cleanDate("14-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Marseille"),
    fromClubId: getClubId("Burnley"),
    id: 167,
    position: "Defender",
    type: "Free",
    player: "CJ Egan-Riley"
},
{
    date: cleanDate("15-06-2025"),
    country: "FRA",
    amount: cleanAmount(30000000),
    toClubId: getClubId("Tottenham"),
    fromClubId: getClubId("Bayern Munich"),
    id: 168,
    position: "Forward",
    type: "Paid",
    player: "Mathys Tel"
},
{
    date: cleanDate("13-06-2025"),
    country: "CIV",
    amount: cleanAmount(17000000),
    toClubId: getClubId("Atalanta"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 169,
    position: "Defender",
    type: "Paid",
    player: "Odilon Kossounou"
},
{
    date: cleanDate("15-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Leeds United"),
    fromClubId: getClubId("Wolfsburg"),
    id: 170,
    position: "Forward",
    type: "Free",
    player: "Lukas Nmecha"
},
{
    date: cleanDate("16-06-2025"),
    country: "FRA",
    amount: cleanAmount(11400000),
    toClubId: getClubId("Bournemouth"),
    fromClubId: getClubId("Rennes"),
    id: 171,
    position: "Defender",
    type: "Paid",
    player: "Adrien Truffert"
},
{
    date: cleanDate("16-06-2025"),
    country: "CRO",
    amount: cleanAmount(14400000),
    toClubId: getClubId("Como"),
    fromClubId: getClubId("Dinamo Zagreb"),
    id: 172,
    position: "Midfielder",
    type: "Paid",
    player: "Martin Baturina"
},
{
    date: cleanDate("15-06-2025"),
    country: "GUI",
    amount: cleanAmount(5100000),
    toClubId: getClubId("Celta Vigo"),
    fromClubId: getClubId("RB Leipzig"),
    id: 173,
    position: "Midfielder",
    type: "Paid",
    player: "Ilaix Moriba"
},
{
    date: cleanDate("13-06-2025"),
    country: "ITA",
    amount: cleanAmount(7700000),
    toClubId: getClubId("Napoli"),
    fromClubId: getClubId("Empoli"),
    id: 174,
    position: "Defender",
    type: "Paid",
    player: "Luca Marianucci"
},
{
    date: cleanDate("13-06-2025"),
    country: "TUR",
    amount: cleanAmount(0),
    toClubId: getClubId("FC Utrecht"),
    fromClubId: getClubId("Bayern Munich"),
    id: 175,
    position: "Winger",
    type: "Free",
    player: "Emirhan Demircan"
},
{
    date: cleanDate("16-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Koper"),
    fromClubId: getClubId("Metz"),
    id: 176,
    position: "Defender",
    type: "Free",
    player: "Charles Divialle"
},
{
    date: cleanDate("13-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Monaco"),
    fromClubId: getClubId("Metz"),
    id: 177,
    position: "Midfielder",
    type: "Free",
    player: "Anis Soubeir"
},
{
    date: cleanDate("16-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Huddersfield"),
    fromClubId: getClubId("Aston Villa"),
    id: 178,
    position: "Defender",
    type: "Loan",
    player: "Josh Paidney"
},
{
    date: cleanDate("16-06-2025"),
    country: "CRO",
    amount: cleanAmount(1000000),
    toClubId: getClubId("Dinamo Zagreb"),
    fromClubId: getClubId("Bayern Munich"),
    id: 179,
    position: "Forward",
    type: "Paid",
    player: "Gabriel Vidovic"
},
{
    date: cleanDate("24-05-2025"),
    country: "BEL",
    amount: cleanAmount(0),
    toClubId: getClubId("RWDM Brussels"),
    fromClubId: getClubId("Lecce"),
    id: 180,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Mats Lemmens"
},
{
    date: cleanDate("01-05-2025"),
    country: "MAR",
    amount: cleanAmount(10220000),
    toClubId: getClubId("Fenerbahçe"),
    fromClubId: getClubId("Fiorentina"),
    id: 181,
    position: "Midfielder",
    type: "Paid",
    player: "Sofyan Amrabat"
},
{
    date: cleanDate("01-06-2025"),
    country: "ITA",
    amount: cleanAmount(14700000),
    toClubId: getClubId("Juventus"),
    fromClubId: getClubId("Monza"),
    id: 182,
    position: "Goalkeeper",
    type: "Paid",
    player: "Michele Di Gregorio"
},
{
    date: cleanDate("02-06-2025"),
    country: "FRA",
    amount: cleanAmount(4200000),
    toClubId: getClubId("Augsburg"),
    fromClubId: getClubId("Monaco"),
    id: 183,
    position: "Defender",
    type: "Paid",
    player: "Chrislain Matsima"
},
{
    date: cleanDate("14-05-2025"),
    country: "ENG",
    amount: cleanAmount(12600000),
    toClubId: getClubId("Marseille"),
    fromClubId: getClubId("Norwich City"),
    id: 184,
    position: "Forward",
    type: "Paid",
    player: "Jonathan Rowe"
},
{
    date: cleanDate("06-05-2025"),
    country: "ARG",
    amount: cleanAmount(11172000),
    toClubId: getClubId("Porto"),
    fromClubId: getClubId("Udinese"),
    id: 185,
    position: "Defender",
    type: "Paid",
    player: "Nehuén Pérez"
},
{
    date: cleanDate("09-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Aston Villa"),
    id: 186,
    position: "Defender",
    type: "Released",
    player: "Kortney Hause"
},
{
    date: cleanDate("10-06-2025"),
    country: "ARG",
    amount: cleanAmount(3000000),
    toClubId: getClubId("Boca Juniors"),
    fromClubId: getClubId("Milan"),
    id: 187,
    position: "Defender",
    type: "Paid",
    player: "Marco Pellegrino"
},
{
    date: cleanDate("12-06-2025"),
    country: "ESP",
    amount: cleanAmount(1000000),
    toClubId: getClubId("Getafe"),
    fromClubId: getClubId("Real Betis"),
    id: 188,
    position: "Forward",
    type: "Paid",
    player: "Juanmi"
},
{
    date: cleanDate("08-05-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Toluca"),
    fromClubId: getClubId("Marseille"),
    id: 189,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Pau López"
},
{
    date: cleanDate("17-06-2025"),
    country: "ITA",
    amount: cleanAmount(9660000),
    toClubId: getClubId("Brighton"),
    fromClubId: getClubId("Verona"),
    id: 190,
    position: "Defender",
    type: "Paid",
    player: "Diego Coppola"
},
{
    date: cleanDate("17-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Elversberg"),
    fromClubId: getClubId("Hoffenheim"),
    id: 191,
    position: "Winger",
    type: "Loan",
    player: "Bambasé Conté"
},
{
    date: cleanDate("17-06-2025"),
    country: "POL",
    amount: cleanAmount(0),
    toClubId: getClubId("Nuremberg"),
    fromClubId: getClubId("Borussia Dortmund"),
    id: 192,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Robin Lisewski"
},
{
    date: cleanDate("17-06-2025"),
    country: "ESP",
    amount: cleanAmount(13650000),
    toClubId: getClubId("Villarreal"),
    fromClubId: getClubId("Las Palmas"),
    id: 193,
    position: "Winger",
    type: "Paid",
    player: "Alberto Moleiro"
},
{
    date: cleanDate("17-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Betis"),
    fromClubId: getClubId("Las Palmas"),
    id: 194,
    position: "Goalkeeper",
    type: "Free",
    player: "Álvaro Valles"
},
{
    date: cleanDate("18-06-2025"),
    country: "ESP",
    amount: cleanAmount(21300000),
    toClubId: getClubId("Barcelona"),
    fromClubId: getClubId("Espanyol"),
    id: 195,
    position: "Goalkeeper",
    type: "Paid",
    player: "Joan García"
},
{
    date: cleanDate("18-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Auxerre"),
    fromClubId: getClubId("Caen"),
    id: 196,
    position: "Defender",
    type: "Free",
    player: "Lamine Sy"
},
{
    date: cleanDate("18-06-2025"),
    country: "ESP",
    amount: cleanAmount(2100000),
    toClubId: getClubId("Al-Shamal"),
    fromClubId: getClubId("Real Betis"),
    id: 197,
    position: "Winger",
    type: "Paid",
    player: "Álex Collado"
},
{
    date: cleanDate("17-06-2025"),
    country: "MRT",
    amount: cleanAmount(0),
    toClubId: getClubId("Bastia"),
    fromClubId: getClubId("Strasbourg"),
    id: 198,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Jérémy Sebas"
},
{
    date: cleanDate("18-06-2025"),
    country: "CZE",
    amount: cleanAmount(0),
    toClubId: getClubId("Ajax"),
    fromClubId: getClubId("Liverpool"),
    id: 199,
    position: "Goalkeeper",
    type: "Loan",
    player: "Vitezslav Jaros"
},
{
    date: cleanDate("18-06-2025"),
    country: "AND",
    amount: cleanAmount(0),
    toClubId: getClubId("Córdoba"),
    fromClubId: getClubId("Villarreal"),
    id: 200,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Iker Álvarez"
},
{
    date: cleanDate("18-06-2025"),
    country: "NOR",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Lille"),
    fromClubId: getClubId("Rosenborg"),
    id: 201,
    position: "Winger",
    type: "Paid",
    player: "Marius Broholm"
},
{
    date: cleanDate("17-06-2025"),
    country: "AUT",
    amount: cleanAmount(0),
    toClubId: getClubId("Dinamo Zagreb"),
    fromClubId: getClubId("Cologne"),
    id: 202,
    position: "Midfielder",
    type: "Free",
    player: "Dejan Ljubicic"
},
{
    date: cleanDate("18-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Blau-Weiss Linz"),
    fromClubId: getClubId("Cologne"),
    id: 203,
    position: "Defender",
    type: "Loan extended",
    player: "Elias Bakatukanda"
},
{
    date: cleanDate("18-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Metz"),
    fromClubId: getClubId("Strasbourg"),
    id: 204,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Jessy Deminguet"
},
{
    date: cleanDate("18-06-2025"),
    country: "SUI",
    amount: cleanAmount(0),
    toClubId: getClubId("Sion"),
    fromClubId: getClubId("Paris FC"),
    id: 205,
    position: "Winger",
    type: "Free",
    player: "Josias Lukembila"
},
{
    date: cleanDate("16-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Havre"),
    fromClubId: getClubId("Paris Saint-Germain"),
    id: 206,
    position: "Winger",
    type: "Free",
    player: "Lenny Lankoso"
},
{
    date: cleanDate("16-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Havre"),
    fromClubId: getClubId("Nice"),
    id: 207,
    position: "Forward",
    type: "Free",
    player: "Ebroni Gnoan"
},
{
    date: cleanDate("16-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Havre"),
    fromClubId: getClubId("Lille"),
    id: 208,
    position: "Forward",
    type: "Free",
    player: "Yanis Beau Djellel"
},
{
    date: cleanDate("18-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Norwich City"),
    fromClubId: getClubId("Crystal Palace"),
    id: 209,
    position: "Goalkeeper",
    type: "Free",
    player: "Louie Moulden"
},
{
    date: cleanDate("19-06-2025"),
    country: "CHI",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Auxerre"),
    fromClubId: getClubId("Watford"),
    id: 210,
    position: "Defender",
    type: "Paid",
    player: "Francisco Sierralta"
},
{
    date: cleanDate("19-06-2025"),
    country: "GAB",
    amount: cleanAmount(200000),
    toClubId: getClubId("Metz"),
    fromClubId: getClubId("Sanliurfaspor"),
    id: 211,
    position: "Defender",
    type: "Paid",
    player: "Michel Mboula"
},
{
    date: cleanDate("19-06-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Westerlo"),
    fromClubId: getClubId("Cremonese"),
    id: 212,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Andreas Jungdal"
},
{
    date: cleanDate("19-06-2025"),
    country: "AUT",
    amount: cleanAmount(0),
    toClubId: getClubId("St Pauli"),
    fromClubId: getClubId("Austria Klagenfurt"),
    id: 213,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Simon Spari"
},
{
    date: cleanDate("19-06-2025"),
    country: "SRB",
    amount: cleanAmount(0),
    toClubId: getClubId("Espanyol"),
    fromClubId: getClubId("Leganés"),
    id: 214,
    position: "Goalkeeper",
    type: "Free",
    player: "Marko Dmitrovic"
},
{
    date: cleanDate("19-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Castellón"),
    fromClubId: getClubId("Athletic Club"),
    id: 215,
    position: "Midfielder",
    type: "Loan",
    player: "Beñat Gerenabarrena"
},
{
    date: cleanDate("19-06-2025"),
    country: "BIH",
    amount: cleanAmount(0),
    toClubId: getClubId("Fiorentina"),
    fromClubId: getClubId("Fenerbahçe"),
    id: 216,
    position: "Forward",
    type: "Free",
    player: "Edin Dzeko"
},
{
    date: cleanDate("20-06-2025"),
    country: "GER",
    amount: cleanAmount(116000000),
    toClubId: getClubId("Liverpool"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 217,
    position: "Midfielder",
    type: "Paid",
    player: "Florian Wirtz"
},
{
    date: cleanDate("20-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Angers"),
    fromClubId: getClubId("Saint-Etienne"),
    id: 218,
    position: "Midfielder",
    type: "Free",
    player: "Louis Mouton"
},
{
    date: cleanDate("21-06-2025"),
    country: "CAN",
    amount: cleanAmount(0),
    toClubId: getClubId("Preston"),
    fromClubId: getClubId("Bournemouth"),
    id: 219,
    position: "Forward",
    type: "Loan",
    player: "Daniel Jebbison"
},
{
    date: cleanDate("20-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("SSV Ulm"),
    fromClubId: getClubId("Bayern Munich"),
    id: 220,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Max Scholze"
},
{
    date: cleanDate("20-06-2025"),
    country: "ITA",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Como"),
    fromClubId: getClubId("Palmeiras"),
    id: 221,
    position: "Defender",
    type: "Paid",
    player: "Fellipe Jack"
},
{
    date: cleanDate("20-06-2025"),
    country: "ESP",
    amount: cleanAmount(19000000),
    toClubId: getClubId("Wolves"),
    fromClubId: getClubId("Celta Vigo"),
    id: 222,
    position: "Forward",
    type: "Paid",
    player: "Fer López"
},
{
    date: cleanDate("20-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Bolton"),
    fromClubId: getClubId("Chelsea"),
    id: 223,
    position: "Goalkeeper",
    type: "Loan",
    player: "Teddy Sharman-Lowe "
},
{
    date: cleanDate("20-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Eibar"),
    fromClubId: getClubId("Barcelona"),
    id: 224,
    position: "Midfielder",
    type: "Free",
    player: "Aleix Garrido"
},
{
    date: cleanDate("20-06-2025"),
    country: "NOR",
    amount: cleanAmount(1300000),
    toClubId: getClubId("Rosenborg"),
    fromClubId: getClubId("Sassuolo"),
    id: 225,
    position: "Winger",
    type: "Paid",
    player: "Emil Ceïde"
},
{
    date: cleanDate("20-06-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("St Pauli"),
    fromClubId: getClubId("Brest"),
    id: 226,
    position: "Midfielder",
    type: "Free",
    player: "Mathias Pereira Lage"
},
{
    date: cleanDate("20-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Colchester"),
    fromClubId: getClubId("Tottenham"),
    id: 227,
    position: "Forward",
    type: "Free",
    player: "Jaden Williams"
},
{
    date: cleanDate("23-06-2025"),
    country: "SRB",
    amount: cleanAmount(1260000),
    toClubId: getClubId("Venezia"),
    fromClubId: getClubId("Inter"),
    id: 228,
    position: "Goalkeeper",
    type: "Paid",
    player: "Filip Stankovic"
},
{
    date: cleanDate("18-06-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Monza"),
    fromClubId: getClubId("Milan"),
    id: 229,
    position: "Midfielder",
    type: "Loan",
    player: "Kevin Zeroli"
},
{
    date: cleanDate("23-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Athletic Club"),
    fromClubId: getClubId("Mallorca"),
    id: 230,
    position: "Winger",
    type: "Free",
    player: "Robert Navarro"
},
{
    date: cleanDate("22-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Hamburg"),
    fromClubId: getClubId("RB Leipzig"),
    id: 231,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Fernando Dickes"
},
{
    date: cleanDate("22-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Greuther Fürth"),
    fromClubId: getClubId("RB Leipzig"),
    id: 232,
    position: "Goalkeeper",
    type: "Loan",
    player: "Timo Schlieck"
},
{
    date: cleanDate("23-06-2025"),
    country: "NOR",
    amount: cleanAmount(0),
    toClubId: getClubId("Arminia Bielefeld"),
    fromClubId: getClubId("RB Leipzig"),
    id: 233,
    position: "Defender",
    type: "Loan",
    player: "Jonathan Norbye"
},
{
    date: cleanDate("18-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Stuttgart"),
    fromClubId: getClubId("Werder Bremen"),
    id: 234,
    position: "Winger",
    type: "Free",
    player: "Abdenego Nankishi"
},
{
    date: cleanDate("19-05-2025"),
    country: "COL",
    amount: cleanAmount(2940000),
    toClubId: getClubId("Hull City"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 235,
    position: "Midfielder",
    type: "Paid",
    player: "Gustavo Puerta"
},
{
    date: cleanDate("09-05-2025"),
    country: "UKR",
    amount: cleanAmount(0),
    toClubId: getClubId("Nuremberg"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 236,
    position: "Forward",
    type: "Loan",
    player: "Artem Stepanov"
},
{
    date: cleanDate("16-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Sturm Graz"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 237,
    position: "Defender",
    type: "Loan",
    player: "Tim Oermann"
},
{
    date: cleanDate("05-05-2025"),
    country: "DEN",
    amount: cleanAmount(5160000),
    toClubId: getClubId("Eintracht Frankfurt"),
    fromClubId: getClubId("Leeds United"),
    id: 238,
    position: "Defender",
    type: "Paid",
    player: "Rasmus Kristensen"
},
{
    date: cleanDate("19-04-2025"),
    country: "SWE",
    amount: cleanAmount(5160000),
    toClubId: getClubId("Borussia Dortmund"),
    fromClubId: getClubId("Nordsjælland"),
    id: 239,
    position: "Defender",
    type: "Paid",
    player: "Daniel Svensson"
},
{
    date: cleanDate("09-06-2025"),
    country: "GER",
    amount: cleanAmount(3870000),
    toClubId: getClubId("Borussia Mönchengladbach"),
    fromClubId: getClubId("Nuremberg"),
    id: 240,
    position: "Midfielder",
    type: "Paid",
    player: "Jens Castrop"
},
{
    date: cleanDate("20-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Espanyol"),
    fromClubId: getClubId("Alavés"),
    id: 241,
    position: "Forward",
    type: "Free",
    player: "Kike García"
},
{
    date: cleanDate("23-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Mansfield Town"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 242,
    position: "Midfielder",
    type: "Loan",
    player: "Kyle McAdam"
},
{
    date: cleanDate("23-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Alavés"),
    fromClubId: getClubId("Osasuna"),
    id: 243,
    position: "Midfielder",
    type: "Free",
    player: "Pablo Ibáñez"
},
{
    date: cleanDate("16-05-2025"),
    country: "SWE",
    amount: cleanAmount(5590000),
    toClubId: getClubId("Lens"),
    fromClubId: getClubId("Häcken"),
    id: 244,
    position: "Winger",
    type: "Paid",
    player: "Jeremy Agbonifo"
},
{
    date: cleanDate("31-05-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Al-Ain"),
    fromClubId: getClubId("Atalanta"),
    id: 245,
    position: "Goalkeeper",
    type: "Free",
    player: "Rui Patrício"
},
{
    date: cleanDate("19-05-2025"),
    country: "SVK",
    amount: cleanAmount(0),
    toClubId: getClubId("Wolfsburg"),
    fromClubId: getClubId("FC Copenhagen"),
    id: 246,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Denis Vavro"
},
{
    date: cleanDate("27-05-2025"),
    country: "GER",
    amount: cleanAmount(4000000),
    toClubId: getClubId("Cologne"),
    fromClubId: getClubId("Kaiserslautern"),
    id: 247,
    position: "Forward",
    type: "Paid",
    player: "Ragnar Ache"
},
{
    date: cleanDate("01-06-2025"),
    country: "GER",
    amount: cleanAmount(6450000),
    toClubId: getClubId("Beşiktaş"),
    fromClubId: getClubId("Augsburg"),
    id: 248,
    position: "Defender",
    type: "Paid",
    player: "Feliz Uduokhai"
},
{
    date: cleanDate("21-04-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("1860 Munich"),
    fromClubId: getClubId("Union Berlin"),
    id: 249,
    position: "Forward",
    type: "Free",
    player: "Kevin Volland"
},
{
    date: cleanDate("23-06-2025"),
    country: "SLO",
    amount: cleanAmount(15000000),
    toClubId: getClubId("Leeds United"),
    fromClubId: getClubId("Udinese"),
    id: 250,
    position: "Defender",
    type: "Paid",
    player: "Jaka Bijol"
},
{
    date: cleanDate("23-06-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Crystal Palace"),
    fromClubId: getClubId("PSV Eindhoven"),
    id: 251,
    position: "Goalkeeper",
    type: "Free",
    player: "Walter Benítez"
},
{
    date: cleanDate("23-06-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Genoa"),
    fromClubId: getClubId("Rennes"),
    id: 252,
    position: "Midfielder",
    type: "Loan",
    player: "Albert Grønbaek"
},
{
    date: cleanDate("23-06-2025"),
    country: "SWE",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Dinamo Zagreb"),
    fromClubId: getClubId("Bayern Munich"),
    id: 253,
    position: "Defender",
    type: "Paid",
    player: "Matteo Pérez Vinlöf"
},
{
    date: cleanDate("23-06-2025"),
    country: "ENG",
    amount: cleanAmount(3000000),
    toClubId: getClubId("West Bromwich Albion"),
    fromClubId: getClubId("Liverpool"),
    id: 254,
    position: "Defender",
    type: "Paid",
    player: "Nat Phillips"
},
{
    date: cleanDate("23-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("RW Essen"),
    fromClubId: getClubId("Cologne"),
    id: 255,
    position: "Winger",
    type: "Free",
    player: "Marvin Obuz"
},
{
    date: cleanDate("18-08-2025"),
    country: "POL",
    amount: cleanAmount(14700000),
    toClubId: getClubId("Atalanta"),
    fromClubId: getClubId("Inter"),
    id: 256,
    position: "Defender",
    type: "Paid",
    player: "Nicola Zalewski"
},
{
    date: cleanDate("24-06-2025"),
    country: "IRL",
    amount: cleanAmount(6800000),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 257,
    position: "Defender",
    type: "Paid",
    player: "Andrew Omobamidele"
},
{
    date: cleanDate("24-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Bochum"),
    fromClubId: getClubId("Borussia Dortmund"),
    id: 258,
    position: "Midfielder",
    type: "Loan",
    player: "Kjell Wätjen"
},
{
    date: cleanDate("24-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cagliari"),
    fromClubId: getClubId("Atalanta"),
    id: 259,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Michel Adopo"
},
{
    date: cleanDate("24-06-2025"),
    country: "ESP",
    amount: cleanAmount(4675000),
    toClubId: getClubId("Celta Vigo"),
    fromClubId: getClubId("Club Brugge"),
    id: 260,
    position: "Forward",
    type: "Paid",
    player: "Ferran Jutglà"
},
{
    date: cleanDate("24-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("FC Copenhagen"),
    fromClubId: getClubId("Paris Saint-Germain"),
    id: 261,
    position: "Defender",
    type: "Loan",
    player: "Yoram Zague"
},
{
    date: cleanDate("24-06-2025"),
    country: "ITA",
    amount: cleanAmount(6820000),
    toClubId: getClubId("Cagliari"),
    fromClubId: getClubId("Napoli"),
    id: 262,
    position: "Goalkeeper",
    type: "Paid",
    player: "Elia Caprile"
},
{
    date: cleanDate("07-05-2025"),
    country: "GER",
    amount: cleanAmount(6400000),
    toClubId: getClubId("Fiorentina"),
    fromClubId: getClubId("Union Berlin"),
    id: 263,
    position: "Defender",
    type: "Paid",
    player: "Robin Gosens"
},
{
    date: cleanDate("24-06-2025"),
    country: "ITA",
    amount: cleanAmount(10200000),
    toClubId: getClubId("Cagliari"),
    fromClubId: getClubId("Atalanta"),
    id: 264,
    position: "Forward",
    type: "Paid",
    player: "Roberto Piccoli"
},
{
    date: cleanDate("24-06-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Leyton Orient"),
    fromClubId: getClubId("Brighton"),
    id: 265,
    position: "Goalkeeper",
    type: "Free",
    player: "Killian Cahill"
},
{
    date: cleanDate("24-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Doncaster"),
    fromClubId: getClubId("Tottenham"),
    id: 266,
    position: "Forward",
    type: "Loan",
    player: "Damola Ajayi"
},
{
    date: cleanDate("21-05-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("St Gallen"),
    fromClubId: getClubId("Inter"),
    id: 267,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Enoch Owusu"
},
{
    date: cleanDate("10-06-2025"),
    country: "ARG",
    amount: cleanAmount(5950000),
    toClubId: getClubId("Atlético Madrid"),
    fromClubId: getClubId("Atalanta"),
    id: 268,
    position: "Goalkeeper",
    type: "Paid",
    player: "Juan Musso"
},
{
    date: cleanDate("06-06-2025"),
    country: "FRA",
    amount: cleanAmount(11900000),
    toClubId: getClubId("Juventus"),
    fromClubId: getClubId("Milan"),
    id: 269,
    position: "Defender",
    type: "Paid",
    player: "Pierre Kalulu"
},
{
    date: cleanDate("21-05-2025"),
    country: "ITA",
    amount: cleanAmount(5525000),
    toClubId: getClubId("Bologna"),
    fromClubId: getClubId("Lazio"),
    id: 270,
    position: "Defender",
    type: "Paid",
    player: "Nicolò Casale"
},
{
    date: cleanDate("01-06-2025"),
    country: "SRB",
    amount: cleanAmount(0),
    toClubId: getClubId("Red Star Belgrade"),
    fromClubId: getClubId("Werder Bremen"),
    id: 271,
    position: "Defender",
    type: "Free",
    player: "Milos Veljkovic"
},
{
    date: cleanDate("10-05-2025"),
    country: "BIH",
    amount: cleanAmount(4250000),
    toClubId: getClubId("Sassuolo"),
    fromClubId: getClubId("Juventus"),
    id: 272,
    position: "Defender",
    type: "Paid",
    player: "Tarik Muharemovic"
},
{
    date: cleanDate("24-06-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Doncaster"),
    fromClubId: getClubId("Crystal Palace"),
    id: 273,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Seán Grehan"
},
{
    date: cleanDate("25-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Espanyol"),
    fromClubId: getClubId("Elche"),
    id: 274,
    position: "Defender",
    type: "Free",
    player: "José Salinas"
},
{
    date: cleanDate("25-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Rodez"),
    fromClubId: getClubId("Real Oviedo"),
    id: 275,
    position: "Goalkeeper",
    type: "Free",
    player: "Quentin Braat"
},
{
    date: cleanDate("25-06-2025"),
    country: "NGR",
    amount: cleanAmount(6000000),
    toClubId: getClubId("Paris FC"),
    fromClubId: getClubId("Nantes"),
    id: 276,
    position: "Winger",
    type: "Paid",
    player: "Moses Simon"
},
{
    date: cleanDate("24-06-2025"),
    country: "FRA",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Paris FC"),
    fromClubId: getClubId("Reims"),
    id: 277,
    position: "Defender",
    type: "Paid",
    player: "Nhoa Sangui"
},
{
    date: cleanDate("25-06-2025"),
    country: "HUN",
    amount: cleanAmount(380000),
    toClubId: getClubId("Puskas Akademia"),
    fromClubId: getClubId("Hamburg"),
    id: 278,
    position: "Forward",
    type: "Paid",
    player: "Andras Nemeth"
},
{
    date: cleanDate("25-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Rangers"),
    fromClubId: getClubId("Bournemouth"),
    id: 279,
    position: "Defender",
    type: "Loan",
    player: "Max Aarons"
},
{
    date: cleanDate("25-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Heidenheim"),
    fromClubId: getClubId("Bayern Munich"),
    id: 280,
    position: "Midfielder",
    type: "Loan",
    player: "Arijon Ibrahimovic"
},
{
    date: cleanDate("24-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Oviedo"),
    fromClubId: getClubId("Debrecen"),
    id: 281,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Brandon Domingues"
},
{
    date: cleanDate("24-06-2025"),
    country: "ISL",
    amount: cleanAmount(11100000),
    toClubId: getClubId("Fiorentina"),
    fromClubId: getClubId("Genoa"),
    id: 282,
    position: "Midfielder",
    type: "Paid",
    player: "Albert Gudmundsson"
},
{
    date: cleanDate("24-06-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Udinese"),
    fromClubId: getClubId("Spezia"),
    id: 283,
    position: "Defender",
    type: "Free",
    player: "Nicolò Bertola"
},
{
    date: cleanDate("24-06-2025"),
    country: "ITA",
    amount: cleanAmount(200000),
    toClubId: getClubId("Torino"),
    fromClubId: getClubId("Fiorentina"),
    id: 284,
    position: "Defender",
    type: "Paid",
    player: "Cristiano Biraghi"
},
{
    date: cleanDate("23-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Mans"),
    fromClubId: getClubId("Nantes"),
    id: 285,
    position: "Midfielder",
    type: "Loan",
    player: "Malang Gomes"
},
{
    date: cleanDate("25-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Bastia"),
    fromClubId: getClubId("Lille"),
    id: 286,
    position: "Goalkeeper",
    type: "Loan",
    player: "Lisandru Olmeta"
},
{
    date: cleanDate("25-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Oviedo"),
    fromClubId: getClubId("Salamanca"),
    id: 287,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Curro Muñoz"
},
{
    date: cleanDate("24-06-2025"),
    country: "POL",
    amount: cleanAmount(800000),
    toClubId: getClubId("Wolfsburg"),
    fromClubId: getClubId("Legia Warsaw"),
    id: 288,
    position: "Goalkeeper",
    type: "Paid",
    player: "Jakub Zielinski"
},
{
    date: cleanDate("25-06-2025"),
    country: "GER",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Karlsruher SC"),
    id: 289,
    position: "Goalkeeper",
    type: "Paid",
    player: "Max Weiss"
},
{
    date: cleanDate("25-06-2025"),
    country: "ITA",
    amount: cleanAmount(8500000),
    toClubId: getClubId("Fiorentina"),
    fromClubId: getClubId("Empoli"),
    id: 290,
    position: "Midfielder",
    type: "Paid",
    player: "Jacopo Fazzini"
},
{
    date: cleanDate("25-06-2025"),
    country: "SLE",
    amount: cleanAmount(0),
    toClubId: getClubId("Nice"),
    fromClubId: getClubId("Manchester City"),
    id: 291,
    position: "Defender",
    type: "Loan",
    player: "Juma Bah"
},
{
    date: cleanDate("23-06-2025"),
    country: "AUT",
    amount: cleanAmount(0),
    toClubId: getClubId("Augsburg"),
    fromClubId: getClubId("Sturm Graz"),
    id: 292,
    position: "Defender",
    type: "Free",
    player: "Oliver Sorg"
},
{
    date: cleanDate("25-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Hércules"),
    fromClubId: getClubId("Alavés"),
    id: 293,
    position: "Winger",
    type: "Loan",
    player: "Unai Ropero"
},
{
    date: cleanDate("25-06-2025"),
    country: "NED",
    amount: cleanAmount(6000000),
    toClubId: getClubId("Club Brugge"),
    fromClubId: getClubId("Hamburg"),
    id: 294,
    position: "Midfielder",
    type: "Paid",
    player: "Ludovit Reis"
},
{
    date: cleanDate("26-06-2025"),
    country: "HUN",
    amount: cleanAmount(40000000),
    toClubId: getClubId("Liverpool"),
    fromClubId: getClubId("Bournemouth"),
    id: 295,
    position: "Defender",
    type: "Paid",
    player: "Milos Kerkez"
},
{
    date: cleanDate("26-06-2025"),
    country: "NED",
    amount: cleanAmount(10200000),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Feyenoord"),
    id: 296,
    position: "Defender",
    type: "Paid",
    player: "Quilindschy Hartman"
},
{
    date: cleanDate("26-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Crawley Town"),
    fromClubId: getClubId("Liverpool"),
    id: 297,
    position: "Goalkeeper",
    type: "Loan",
    player: "Harvey Davies"
},
{
    date: cleanDate("26-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Borussia Dortmund"),
    fromClubId: getClubId("Bochum"),
    id: 298,
    position: "Goalkeeper",
    type: "Free",
    player: "Patrick Drewes"
},
{
    date: cleanDate("26-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Exeter City"),
    fromClubId: getClubId("Brentford"),
    id: 299,
    position: "Midfielder",
    type: "Loan",
    player: "Ethan Brierley"
},
{
    date: cleanDate("26-06-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Wigan Athletic"),
    fromClubId: getClubId("Burnley"),
    id: 300,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Dara Costelloe"
},
{
    date: cleanDate("26-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Dynamo Dresden"),
    fromClubId: getClubId("Wolfsburg"),
    id: 301,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Kofi Amoako"
},
{
    date: cleanDate("26-06-2025"),
    country: "TUN",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Augsburg"),
    fromClubId: getClubId("St Pauli"),
    id: 302,
    position: "Winger",
    type: "Paid",
    player: "Elias Saad"
},
{
    date: cleanDate("26-06-2025"),
    country: "GRE",
    amount: cleanAmount(1300000),
    toClubId: getClubId("FC Copenhagen"),
    fromClubId: getClubId("Cagliari"),
    id: 303,
    position: "Defender",
    type: "Paid",
    player: "Pantelis Hatzidiakos"
},
{
    date: cleanDate("26-06-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Grasshopper"),
    fromClubId: getClubId("Bayern Munich"),
    id: 304,
    position: "Midfielder",
    type: "Loan",
    player: "Jonathan Asp Jensen"
},
{
    date: cleanDate("25-06-2025"),
    country: "ZAM",
    amount: cleanAmount(0),
    toClubId: getClubId("SV Ried"),
    fromClubId: getClubId("Cagliari"),
    id: 305,
    position: "Forward",
    type: "Loan",
    player: "Kingstone Mutandwa"
},
{
    date: cleanDate("26-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Gil Vicente"),
    fromClubId: getClubId("Villarreal"),
    id: 306,
    position: "Defender",
    type: "Free",
    player: "Antonio Espigares"
},
{
    date: cleanDate("26-06-2025"),
    country: "ARG",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Toluca"),
    fromClubId: getClubId("Elche"),
    id: 307,
    position: "Midfielder",
    type: "Paid",
    player: "Nicolás Castro"
},
{
    date: cleanDate("27-06-2025"),
    country: "COD",
    amount: cleanAmount(0),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Ipswich Town"),
    id: 308,
    position: "Defender",
    type: "Free",
    player: "Axel Tuanzebe"
},
{
    date: cleanDate("27-06-2025"),
    country: "GHA",
    amount: cleanAmount(0),
    toClubId: getClubId("Darmstadt"),
    fromClubId: getClubId("Augsburg"),
    id: 309,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Patric Pfeiffer"
},
{
    date: cleanDate("27-06-2025"),
    country: "SEN",
    amount: cleanAmount(2550000),
    toClubId: getClubId("Bayer Leverkusen"),
    fromClubId: getClubId("Häcken"),
    id: 310,
    position: "Defender",
    type: "Paid",
    player: "Abdoulaye Faye"
},
{
    date: cleanDate("27-06-2025"),
    country: "JPN",
    amount: cleanAmount(2550000),
    toClubId: getClubId("St Pauli"),
    fromClubId: getClubId("Sint-Truiden"),
    id: 311,
    position: "Midfielder",
    type: "Paid",
    player: "Joel Fujita"
},
{
    date: cleanDate("27-06-2025"),
    country: "ESP",
    amount: cleanAmount(5570000),
    toClubId: getClubId("Espanyol"),
    fromClubId: getClubId("Braga"),
    id: 312,
    position: "Forward",
    type: "Paid",
    player: "Roberto Fernández"
},
{
    date: cleanDate("27-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Eibar"),
    fromClubId: getClubId("Real Sociedad"),
    id: 313,
    position: "Forward",
    type: "Free",
    player: "Jon Magunazelaia"
},
{
    date: cleanDate("26-06-2025"),
    country: "MAR",
    amount: cleanAmount(255000),
    toClubId: getClubId("Braga"),
    fromClubId: getClubId("Strasbourg"),
    id: 314,
    position: "Goalkeeper",
    type: "Paid",
    player: "Alaa Bellaarouch"
},
{
    date: cleanDate("27-06-2025"),
    country: "JPN",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Hoffenheim"),
    fromClubId: getClubId("Union St-Gilloise"),
    id: 315,
    position: "Defender",
    type: "Paid",
    player: "Koki Machida"
},
{
    date: cleanDate("27-06-2025"),
    country: "SEN",
    amount: cleanAmount(6400000),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Zulte Waregem"),
    id: 316,
    position: "Midfielder",
    type: "Paid",
    player: "Pape Diop"
},
{
    date: cleanDate("28-06-2025"),
    country: "ESP",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Panathinaikos"),
    fromClubId: getClubId("Nantes"),
    id: 317,
    position: "Midfielder",
    type: "Paid",
    player: "Pedro Chirivella"
},
{
    date: cleanDate("28-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Augsburg"),
    fromClubId: getClubId("Elversberg"),
    id: 318,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Robin Fellhauer"
},
{
    date: cleanDate("27-06-2025"),
    country: "SEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Partizan Belgrade"),
    fromClubId: getClubId("Torino"),
    id: 319,
    position: "Winger",
    type: "Loan",
    player: "Demba Seck"
},
{
    date: cleanDate("28-06-2025"),
    country: "GER",
    amount: cleanAmount(4250000),
    toClubId: getClubId("FC Copenhagen"),
    fromClubId: getClubId("Borussia Dortmund"),
    id: 320,
    position: "Forward",
    type: "Paid",
    player: "Youssoufa Moukoko"
},
{
    date: cleanDate("27-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Liverpool"),
    fromClubId: getClubId("Preston"),
    id: 321,
    position: "Goalkeeper",
    type: "Free",
    player: "Freddie Woodman"
},
{
    date: cleanDate("28-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Monaco"),
    fromClubId: getClubId("Free agent"),
    id: 322,
    position: "Midfielder",
    type: "Free",
    player: "Paul Pogba"
},
{
    date: cleanDate("15-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Leeds United"),
    fromClubId: getClubId("Everton"),
    id: 323,
    position: "Forward",
    type: "Free ",
    player: "Dominic Calvert-Lewin"
},
{
    date: cleanDate("29-06-2025"),
    country: "CIV",
    amount: cleanAmount(0),
    toClubId: getClubId("Lecce"),
    fromClubId: getClubId("Laval"),
    id: 324,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Christ-Owen Kouassi"
},
{
    date: cleanDate("30-06-2025"),
    country: "CZE",
    amount: cleanAmount(0),
    toClubId: getClubId("Sparta Prague"),
    fromClubId: getClubId("Hoffenheim"),
    id: 325,
    position: "Defender",
    type: "Free",
    player: "Pavel Kaderabek"
},
{
    date: cleanDate("29-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Lille"),
    fromClubId: getClubId("Los Angeles FC"),
    id: 326,
    position: "Forward",
    type: "Free",
    player: "Olivier Giroud"
},
{
    date: cleanDate("30-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Saarbrücken"),
    fromClubId: getClubId("Cologne"),
    id: 327,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Jonas Nickisch"
},
{
    date: cleanDate("30-06-2025"),
    country: "WAL",
    amount: cleanAmount(0),
    toClubId: getClubId("Celtic"),
    fromClubId: getClubId("Fulham"),
    id: 328,
    position: "Forward",
    type: "Free",
    player: "Callum Osmand"
},
{
    date: cleanDate("30-06-2025"),
    country: "GER",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Freiburg"),
    fromClubId: getClubId("St Pauli"),
    id: 329,
    position: "Defender",
    type: "Paid",
    player: "Philipp Treu"
},
{
    date: cleanDate("30-06-2025"),
    country: "BUR",
    amount: cleanAmount(0),
    toClubId: getClubId("Angers"),
    fromClubId: getClubId("Lens"),
    id: 330,
    position: "Goalkeeper",
    type: "Loan",
    player: "Hervé Koffi"
},
{
    date: cleanDate("30-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Hertha BSC"),
    fromClubId: getClubId("Bayern Munich"),
    id: 331,
    position: "Midfielder",
    type: "Loan",
    player: "Maurice Krattenmacher"
},
{
    date: cleanDate("30-06-2025"),
    country: "ESP",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Sporting Gijón"),
    fromClubId: getClubId("Toulouse"),
    id: 332,
    position: "Midfielder",
    type: "Paid",
    player: "César Gelabert"
},
{
    date: cleanDate("30-06-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Watford"),
    fromClubId: getClubId("Udinese"),
    id: 333,
    position: "Defender",
    type: "Loan",
    player: "James Abankwah"
},
{
    date: cleanDate("01-07-2025"),
    country: "NOR",
    amount: cleanAmount(23000000),
    toClubId: getClubId("Wolves"),
    fromClubId: getClubId("Celta Vigo"),
    id: 334,
    position: "Forward",
    type: "Paid",
    player: "Jørgen Strand Larsen"
},
{
    date: cleanDate("01-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Monaco"),
    fromClubId: getClubId("Barcelona"),
    id: 335,
    position: "Forward",
    type: "Loan",
    player: "Ansu Fati"
},
{
    date: cleanDate("01-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Wimbledon"),
    fromClubId: getClubId("Sunderland"),
    id: 336,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Nathan Bishop"
},
{
    date: cleanDate("01-07-2025"),
    country: "ENG",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Coventry City"),
    fromClubId: getClubId("Aston Villa"),
    id: 337,
    position: "Defender",
    type: "Paid",
    player: "Kaine Kesler-Hayden"
},
{
    date: cleanDate("01-07-2025"),
    country: "ESP",
    amount: cleanAmount(5000000),
    toClubId: getClubId("Arsenal"),
    fromClubId: getClubId("Chelsea"),
    id: 338,
    position: "Goalkeeper",
    type: "Paid",
    player: "Kepa Arrizabalaga"
},
{
    date: cleanDate("01-07-2025"),
    country: "NED",
    amount: cleanAmount(0),
    toClubId: getClubId("Aston Villa"),
    fromClubId: getClubId("Feyenoord"),
    id: 339,
    position: "Forward",
    type: "Free",
    player: "Zepiqueno Redmond"
},
{
    date: cleanDate("01-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Elversberg"),
    fromClubId: getClubId("Augsburg"),
    id: 340,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Lasse Günther"
},
{
    date: cleanDate("01-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Stuttgart"),
    fromClubId: getClubId("Barcelona"),
    id: 341,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Noah Darvich"
},
{
    date: cleanDate("30-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Manchester United"),
    fromClubId: getClubId("Aston Villa"),
    id: 342,
    position: "Forward",
    type: "Return",
    player: "Marcus Rashford"
},
{
    date: cleanDate("27-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Espanyol"),
    fromClubId: getClubId("Villarreal"),
    id: 343,
    position: "Defender",
    type: "Loan extended",
    player: "Carlos Romero"
},
{
    date: cleanDate("01-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Sevilla"),
    fromClubId: getClubId("Celta Vigo"),
    id: 344,
    position: "Winger",
    type: "Free",
    player: "Alfon González"
},
{
    date: cleanDate("01-07-2025"),
    country: "BEL",
    amount: cleanAmount(5100000),
    toClubId: getClubId("Leeds United"),
    fromClubId: getClubId("Wolfsburg"),
    id: 345,
    position: "Defender",
    type: "Paid",
    player: "Sebastiaan Bornauw"
},
{
    date: cleanDate("01-07-2025"),
    country: "SEN",
    amount: cleanAmount(30000000),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("Strasbourg"),
    id: 346,
    position: "Midfielder",
    type: "Paid",
    player: "Habib Diarra"
},
{
    date: cleanDate("01-07-2025"),
    country: "GAM",
    amount: cleanAmount(0),
    toClubId: getClubId("Servette"),
    fromClubId: getClubId("Metz"),
    id: 347,
    position: "Winger",
    type: "Free",
    player: "Ablie Jallow"
},
{
    date: cleanDate("01-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Walsall"),
    fromClubId: getClubId("Bournemouth"),
    id: 348,
    position: "Forward",
    type: "Loan",
    player: "Jonny Stuttle"
},
{
    date: cleanDate("01-07-2025"),
    country: "JAM",
    amount: cleanAmount(0),
    toClubId: getClubId("Wimbledon"),
    fromClubId: getClubId("Fulham"),
    id: 349,
    position: "Midfielder",
    type: "Free",
    player: "Delano McCoy-Splatt"
},
{
    date: cleanDate("01-07-2025"),
    country: "ITA",
    amount: cleanAmount(14600000),
    toClubId: getClubId("Atlético Madrid"),
    fromClubId: getClubId("Atalanta"),
    id: 350,
    position: "Defender",
    type: "Paid",
    player: "Matteo Ruggeri"
},
{
    date: cleanDate("01-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Fiorentina"),
    fromClubId: getClubId("Nice"),
    id: 351,
    position: "Defender",
    type: "Loan",
    player: "Mattia Viti"
},
{
    date: cleanDate("02-07-2025"),
    country: "BRA",
    amount: cleanAmount(60000000),
    toClubId: getClubId("Chelsea"),
    fromClubId: getClubId("Brighton"),
    id: 352,
    position: "Forward",
    type: "Paid",
    player: "João Pedro"
},
{
    date: cleanDate("02-07-2025"),
    country: "ESP",
    amount: cleanAmount(38960000),
    toClubId: getClubId("Atlético Madrid"),
    fromClubId: getClubId("Villarreal"),
    id: 353,
    position: "Winger",
    type: "Paid",
    player: "Álex Baena"
},
{
    date: cleanDate("01-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Birmingham City"),
    fromClubId: getClubId("Brighton"),
    id: 354,
    position: "Goalkeeper",
    type: "Loan",
    player: "James Beadle"
},
{
    date: cleanDate("02-07-2025"),
    country: "ENG",
    amount: cleanAmount(30000000),
    toClubId: getClubId("Bayer Leverkusen"),
    fromClubId: getClubId("Liverpool"),
    id: 355,
    position: "Defender",
    type: "Paid",
    player: "Jarell Quansah"
},
{
    date: cleanDate("02-07-2025"),
    country: "GER",
    amount: cleanAmount(2125000),
    toClubId: getClubId("Hamburg"),
    fromClubId: getClubId("Eintracht Braunschweig"),
    id: 356,
    position: "Forward",
    type: "Paid",
    player: "Rayan Philippe"
},
{
    date: cleanDate("02-07-2025"),
    country: "HON",
    amount: cleanAmount(0),
    toClubId: getClubId("Levante"),
    fromClubId: getClubId("Partizan Belgrade"),
    id: 357,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Kervin Arriaga"
},
{
    date: cleanDate("02-07-2025"),
    country: "FRA",
    amount: cleanAmount(13000000),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Lazio"),
    id: 358,
    position: "Winger",
    type: "Paid",
    player: "Loum Tchaouna"
},
{
    date: cleanDate("02-07-2025"),
    country: "ARG",
    amount: cleanAmount(10000000),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Brighton"),
    id: 359,
    position: "Midfielder",
    type: "Paid",
    player: "Valentín Barco"
},
{
    date: cleanDate("30-06-2025"),
    country: "ESP",
    amount: cleanAmount(1000000),
    toClubId: getClubId("Dinamo Zagreb"),
    fromClubId: getClubId("Barcelona"),
    id: 360,
    position: "Defender",
    type: "Paid",
    player: "Sergi Domínguez"
},
{
    date: cleanDate("30-06-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Bahia"),
    fromClubId: getClubId("Manchester City"),
    id: 361,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Kayky"
},
{
    date: cleanDate("01-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Beşiktaş"),
    fromClubId: getClubId("Roma"),
    id: 362,
    position: "Forward",
    type: "Loan",
    player: "Tammy Abraham"
},
{
    date: cleanDate("01-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Auxerre"),
    fromClubId: getClubId("Strasbourg"),
    id: 363,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Marvin Senaya"
},
{
    date: cleanDate("01-07-2025"),
    country: "SRB",
    amount: cleanAmount(0),
    toClubId: getClubId("Nantes"),
    fromClubId: getClubId("Sivasspor"),
    id: 364,
    position: "Defender",
    type: "Free",
    player: "Uros Radakovic"
},
{
    date: cleanDate("01-07-2025"),
    country: "CMR",
    amount: cleanAmount(0),
    toClubId: getClubId("Getafe"),
    fromClubId: getClubId("Leganés"),
    id: 365,
    position: "Midfielder",
    type: "Free",
    player: "Yvan Neyou"
},
{
    date: cleanDate("01-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Getafe"),
    fromClubId: getClubId("Villarreal"),
    id: 366,
    position: "Defender",
    type: "Free",
    player: "Kiko Femenía"
},
{
    date: cleanDate("02-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Getafe"),
    fromClubId: getClubId("Real Zaragoza"),
    id: 367,
    position: "Winger",
    type: "Loan",
    player: "Adrián Liso"
},
{
    date: cleanDate("02-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Getafe"),
    fromClubId: getClubId("Burgos"),
    id: 368,
    position: "Winger",
    type: "Free",
    player: "Álex Sancris"
},
{
    date: cleanDate("01-07-2025"),
    country: "SUI",
    amount: cleanAmount(0),
    toClubId: getClubId("Sion"),
    fromClubId: getClubId("Borussia Mönchengladbach"),
    id: 369,
    position: "Forward",
    type: "Loan",
    player: "Winsley Boteli"
},
{
    date: cleanDate("01-07-2025"),
    country: "GHA",
    amount: cleanAmount(0),
    toClubId: getClubId("Maribor"),
    fromClubId: getClubId("Metz"),
    id: 370,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Benjamin Tetteh"
},
{
    date: cleanDate("01-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("SSV Ulm"),
    fromClubId: getClubId("Bayern Munich"),
    id: 371,
    position: "Goalkeeper",
    type: "Loan",
    player: "Max Schmitt"
},
{
    date: cleanDate("01-07-2025"),
    country: "BEL",
    amount: cleanAmount(0),
    toClubId: getClubId("Lille"),
    fromClubId: getClubId("Metz"),
    id: 372,
    position: "Goalkeeper",
    type: "Free",
    player: "Arnaud Bodart"
},
{
    date: cleanDate("01-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("St Gallen"),
    fromClubId: getClubId("St Pauli"),
    id: 373,
    position: "Midfielder",
    type: "Free",
    player: "Carlo Boukhalfa"
},
{
    date: cleanDate("02-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Marseille"),
    fromClubId: getClubId("Lens"),
    id: 374,
    position: "Defender",
    type: "Loan",
    player: "Facundo Medina"
},
{
    date: cleanDate("01-07-2025"),
    country: "SCO",
    amount: cleanAmount(0),
    toClubId: getClubId("West Ham"),
    fromClubId: getClubId("Celtic"),
    id: 375,
    position: "Forward",
    type: "Free",
    player: "Daniel Cummings"
},
{
    date: cleanDate("02-07-2025"),
    country: "CHI",
    amount: cleanAmount(0),
    toClubId: getClubId("Bologna"),
    fromClubId: getClubId("Universidad Católica"),
    id: 376,
    position: "Goalkeeper",
    type: "Free",
    player: "Thomas Gillier"
},
{
    date: cleanDate("30-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Nantes"),
    fromClubId: getClubId("Metz"),
    id: 377,
    position: "Goalkeeper",
    type: "Free",
    player: "Alexis Mirbach"
},
{
    date: cleanDate("02-07-2025"),
    country: "FRA",
    amount: cleanAmount(2200000),
    toClubId: getClubId("Nantes"),
    fromClubId: getClubId("Lyon"),
    id: 378,
    position: "Midfielder",
    type: "Paid",
    player: "Johann Lepenant"
},
{
    date: cleanDate("02-07-2025"),
    country: "ALG",
    amount: cleanAmount(12900000),
    toClubId: getClubId("Neom SC"),
    fromClubId: getClubId("Lyon"),
    id: 379,
    position: "Winger",
    type: "Paid",
    player: "Saïd Benrahma"
},
{
    date: cleanDate("02-07-2025"),
    country: "GHA",
    amount: cleanAmount(18000000),
    toClubId: getClubId("Atalanta"),
    fromClubId: getClubId("Southampton"),
    id: 380,
    position: "Forward",
    type: "Paid",
    player: "Kamaldeen Sulemana"
},
{
    date: cleanDate("02-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Huddersfield"),
    fromClubId: getClubId("Crystal Palace"),
    id: 381,
    position: "Goalkeeper",
    type: "Loan",
    player: "Owen Goodman"
},
{
    date: cleanDate("02-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Birmingham City"),
    fromClubId: getClubId("Wolves"),
    id: 382,
    position: "Midfielder",
    type: "Loan",
    player: "Tommy Doyle"
},
{
    date: cleanDate("01-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Espanyol"),
    fromClubId: getClubId("Villarreal"),
    id: 383,
    position: "Midfielder",
    type: "Loan",
    player: "Ramón Terrats"
},
{
    date: cleanDate("02-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Lausanne"),
    fromClubId: getClubId("Arsenal"),
    id: 384,
    position: "Forward",
    type: "Free",
    player: "Nathan Butler-Oyedeji"
},
{
    date: cleanDate("02-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Atlético Madrid"),
    fromClubId: getClubId("Real Madrid"),
    id: 385,
    position: "Goalkeeper",
    type: "Free",
    player: "Mario de Luis"
},
{
    date: cleanDate("29-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Granada"),
    fromClubId: getClubId("Barcelona"),
    id: 386,
    position: "Goalkeeper",
    type: "Loan",
    player: "Ander Astralaga"
},
{
    date: cleanDate("02-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Alavés"),
    fromClubId: getClubId("PAOK"),
    id: 387,
    position: "Defender",
    type: "Free",
    player: "Jonny Otto"
},
{
    date: cleanDate("01-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Mirandés"),
    fromClubId: getClubId("Alavés"),
    id: 388,
    position: "Defender",
    type: "Loan",
    player: "Adrián Pica"
},
{
    date: cleanDate("02-07-2025"),
    country: "ESP",
    amount: cleanAmount(300000),
    toClubId: getClubId("Widzew Lodz"),
    fromClubId: getClubId("Real Betis"),
    id: 389,
    position: "Defender",
    type: "Paid",
    player: "Ricardo Visus"
},
{
    date: cleanDate("02-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("OFI Crete"),
    fromClubId: getClubId("Inter"),
    id: 390,
    position: "Forward",
    type: "Free",
    player: "Eddie Salcedo"
},
{
    date: cleanDate("03-07-2025"),
    country: "SEN",
    amount: cleanAmount(5950000),
    toClubId: getClubId("Nice"),
    fromClubId: getClubId("Reims"),
    id: 391,
    position: "Goalkeeper",
    type: "Paid",
    player: "Yehvann Diouf"
},
{
    date: cleanDate("02-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Brighton"),
    fromClubId: getClubId("PSV Eindhoven"),
    id: 392,
    position: "Defender",
    type: "Free",
    player: "Olivier Boscagli"
},
{
    date: cleanDate("03-07-2025"),
    country: "GER",
    amount: cleanAmount(3400000),
    toClubId: getClubId("RB Leipzig"),
    fromClubId: getClubId("Cologne"),
    id: 393,
    position: "Defender",
    type: "Paid",
    player: "Max Finkgräfe"
},
{
    date: cleanDate("02-07-2025"),
    country: "ESP",
    amount: cleanAmount(18700000),
    toClubId: getClubId("Como"),
    fromClubId: getClubId("Real Betis"),
    id: 394,
    position: "Winger",
    type: "Paid",
    player: "Jesús Rodríguez"
},
{
    date: cleanDate("03-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Standard Liège"),
    fromClubId: getClubId("Verona"),
    id: 395,
    position: "Forward",
    type: "Free",
    player: "Thomas Henry"
},
{
    date: cleanDate("03-07-2025"),
    country: "VEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Oviedo"),
    fromClubId: getClubId("Pachuca"),
    id: 396,
    position: "Forward",
    type: "Free",
    player: "Salomón Rondón"
},
{
    date: cleanDate("03-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Villarreal"),
    fromClubId: getClubId("Napoli"),
    id: 397,
    position: "Defender",
    type: "Loan",
    player: "Rafa Marín"
},
{
    date: cleanDate("02-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Neom SC"),
    fromClubId: getClubId("Lyon"),
    id: 398,
    position: "Forward",
    type: "Free",
    player: "Alexandre Lacazette"
},
{
    date: cleanDate("02-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Rangers"),
    fromClubId: getClubId("Bournemouth"),
    id: 399,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Joe Rothwell"
},
{
    date: cleanDate("03-07-2025"),
    country: "NED",
    amount: cleanAmount(16000000),
    toClubId: getClubId("Brentford"),
    fromClubId: getClubId("Feyenoord"),
    id: 400,
    position: "Midfielder",
    type: "Paid",
    player: "Antoni Milambo"
},
{
    date: cleanDate("03-07-2025"),
    country: "BEL",
    amount: cleanAmount(0),
    toClubId: getClubId("Metz"),
    fromClubId: getClubId("Seraing"),
    id: 401,
    position: "Defender",
    type: "Free",
    player: "Yannis Lawson"
},
{
    date: cleanDate("03-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Jahn Regensburg"),
    fromClubId: getClubId("Hamburg"),
    id: 402,
    position: "Defender",
    type: "Free",
    player: "Nicolas Oliveira"
},
{
    date: cleanDate("03-07-2025"),
    country: "NZL",
    amount: cleanAmount(0),
    toClubId: getClubId("Chesterfield"),
    fromClubId: getClubId("Fulham"),
    id: 403,
    position: "Midfielder",
    type: "Loan",
    player: "Matt Dibley-Dias"
},
{
    date: cleanDate("02-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Benevento"),
    fromClubId: getClubId("Fiorentina"),
    id: 404,
    position: "Defender",
    type: "Free",
    player: "Edoardo Pierozzi"
},
{
    date: cleanDate("03-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Leganés"),
    fromClubId: getClubId("Levante"),
    id: 405,
    position: "Defender",
    type: "Free",
    player: "Ignasi Miquel"
},
{
    date: cleanDate("03-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Levante"),
    fromClubId: getClubId("Eldense"),
    id: 406,
    position: "Defender",
    type: "Free",
    player: "Víctor García"
},
{
    date: cleanDate("02-07-2025"),
    country: "CZE",
    amount: cleanAmount(300000),
    toClubId: getClubId("Artis Brno"),
    fromClubId: getClubId("Lecce"),
    id: 407,
    position: "Midfielder",
    type: "Paid",
    player: "Daniel Samek"
},
{
    date: cleanDate("02-07-2025"),
    country: "CGO",
    amount: cleanAmount(0),
    toClubId: getClubId("Samsunspor"),
    fromClubId: getClubId("Cagliari"),
    id: 408,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Antoine Makoumbou"
},
{
    date: cleanDate("02-07-2025"),
    country: "NGR",
    amount: cleanAmount(0),
    toClubId: getClubId("Alverca"),
    fromClubId: getClubId("Lorient"),
    id: 409,
    position: "Defender",
    type: "Free",
    player: "Isaac James"
},
{
    date: cleanDate("03-07-2025"),
    country: "ITA",
    amount: cleanAmount(21500000),
    toClubId: getClubId("Milan"),
    fromClubId: getClubId("Torino"),
    id: 410,
    position: "Midfielder",
    type: "Paid",
    player: "Samuele Ricci"
},
{
    date: cleanDate("03-07-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Padova"),
    fromClubId: getClubId("Torino"),
    id: 411,
    position: "Midfielder",
    type: "Loan",
    player: "Jonathan Silva"
},
{
    date: cleanDate("03-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Elche"),
    fromClubId: getClubId("Valencia"),
    id: 412,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Germán Valera"
},
{
    date: cleanDate("04-07-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Vasco da Gama"),
    fromClubId: getClubId("Aston Villa"),
    id: 413,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Philippe Coutinho"
},
{
    date: cleanDate("04-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Crawley Town"),
    fromClubId: getClubId("Brighton"),
    id: 414,
    position: "Forward",
    type: "Free",
    player: "Louis Flower"
},
{
    date: cleanDate("04-07-2025"),
    country: "GER",
    amount: cleanAmount(17000000),
    toClubId: getClubId("Eintracht Frankfurt"),
    fromClubId: getClubId("Mainz 05"),
    id: 415,
    position: "Forward",
    type: "Paid",
    player: "Jonathan Burkardt"
},
{
    date: cleanDate("04-07-2025"),
    country: "AUT",
    amount: cleanAmount(0),
    toClubId: getClubId("Werder Bremen"),
    fromClubId: getClubId("Leeds United"),
    id: 416,
    position: "Defender",
    type: "Loan",
    player: "Maximilian Wöber"
},
{
    date: cleanDate("04-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Valenciennes"),
    fromClubId: getClubId("Marseille"),
    id: 417,
    position: "Defender",
    type: "Loan",
    player: "Alexi Koum"
},
{
    date: cleanDate("04-07-2025"),
    country: "COD",
    amount: cleanAmount(15000000),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("Union St-Gilloise"),
    id: 418,
    position: "Midfielder",
    type: "Paid",
    player: "Noah Sadiki"
},
{
    date: cleanDate("04-07-2025"),
    country: "POL",
    amount: cleanAmount(0),
    toClubId: getClubId("Cologne"),
    fromClubId: getClubId("Wolfsburg"),
    id: 419,
    position: "Winger",
    type: "Loan",
    player: "Jakub Kaminski"
},
{
    date: cleanDate("04-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Eintracht Braunschweig"),
    fromClubId: getClubId("RB Leipzig"),
    id: 420,
    position: "Defender",
    type: "Loan",
    player: "Frederik Jäkel"
},
{
    date: cleanDate("04-07-2025"),
    country: "ITA",
    amount: cleanAmount(13600000),
    toClubId: getClubId("Atalanta"),
    fromClubId: getClubId("Genoa"),
    id: 421,
    position: "Winger",
    type: "Paid",
    player: "Honest Ahanor"
},
{
    date: cleanDate("04-07-2025"),
    country: "ESP",
    amount: cleanAmount(7770000),
    toClubId: getClubId("Real Betis"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 422,
    position: "Winger",
    type: "Paid",
    player: "Rodrigo Riquelme"
},
{
    date: cleanDate("05-07-2025"),
    country: "ENG",
    amount: cleanAmount(5000000),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Manchester City"),
    id: 423,
    position: "Defender",
    type: "Paid",
    player: "Kyle Walker"
},
{
    date: cleanDate("05-07-2025"),
    country: "PAR",
    amount: cleanAmount(3300000),
    toClubId: getClubId("Manchester United"),
    fromClubId: getClubId("Cerro Porteño"),
    id: 424,
    position: "Defender",
    type: "Paid",
    player: "Diego Léon"
},
{
    date: cleanDate("04-07-2025"),
    country: "CAN",
    amount: cleanAmount(0),
    toClubId: getClubId("Juventus"),
    fromClubId: getClubId("Lille"),
    id: 425,
    position: "Forward",
    type: "Free",
    player: "Jonathan David"
},
{
    date: cleanDate("05-07-2025"),
    country: "FRA",
    amount: cleanAmount(345000),
    toClubId: getClubId("Alverca"),
    fromClubId: getClubId("Strasbourg"),
    id: 426,
    position: "Defender",
    type: "Paid",
    player: "Steven Baseya"
},
{
    date: cleanDate("04-07-2025"),
    country: "FRA",
    amount: cleanAmount(2550000),
    toClubId: getClubId("Lens"),
    fromClubId: getClubId("Strasbourg"),
    id: 427,
    position: "Goalkeeper",
    type: "Paid",
    player: "Robin Risser"
},
{
    date: cleanDate("04-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Torino"),
    fromClubId: getClubId("Empoli"),
    id: 428,
    position: "Midfielder",
    type: "Loan",
    player: "Tino Anjorin"
},
{
    date: cleanDate("04-07-2025"),
    country: "GUD",
    amount: cleanAmount(0),
    toClubId: getClubId("Lorient"),
    fromClubId: getClubId("Rodez"),
    id: 429,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Noah Cadiou"
},
{
    date: cleanDate("04-07-2025"),
    country: "NED",
    amount: cleanAmount(11900000),
    toClubId: getClubId("Como"),
    fromClubId: getClubId("AZ Alkmaar"),
    id: 430,
    position: "Forward",
    type: "Paid",
    player: "Jayden Addai"
},
{
    date: cleanDate("05-07-2025"),
    country: "FRA",
    amount: cleanAmount(19550000),
    toClubId: getClubId("Inter"),
    fromClubId: getClubId("Parma"),
    id: 431,
    position: "Forward",
    type: "Paid",
    player: "Ange-Yoan Bonny"
},
{
    date: cleanDate("05-07-2025"),
    country: "BRA",
    amount: cleanAmount(12950000),
    toClubId: getClubId("Wolfsburg"),
    fromClubId: getClubId("Sheffield United"),
    id: 432,
    position: "Midfielder",
    type: "Paid",
    player: "Vinícius Souza"
},
{
    date: cleanDate("05-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Stoke City"),
    fromClubId: getClubId("Manchester City"),
    id: 433,
    position: "Forward",
    type: "Loan",
    player: "Divin Mubama"
},
{
    date: cleanDate("05-07-2025"),
    country: "ENG",
    amount: cleanAmount(1500000),
    toClubId: getClubId("Preston"),
    fromClubId: getClubId("Brighton"),
    id: 434,
    position: "Defender",
    type: "Paid",
    player: "Odeluga Offiah"
},
{
    date: cleanDate("05-07-2025"),
    country: "BRA",
    amount: cleanAmount(10000000),
    toClubId: getClubId("Nottingham Forest"),
    fromClubId: getClubId("Botafogo"),
    id: 435,
    position: "Forward",
    type: "Paid",
    player: "Igor Jesus"
},
{
    date: cleanDate("05-07-2025"),
    country: "ENG",
    amount: cleanAmount(48500000),
    toClubId: getClubId("Chelsea"),
    fromClubId: getClubId("Borussia Dortmund"),
    id: 436,
    position: "Forward",
    type: "Paid",
    player: "Jamie Gittens"
},
{
    date: cleanDate("05-07-2025"),
    country: "BEL",
    amount: cleanAmount(17500000),
    toClubId: getClubId("Brighton"),
    fromClubId: getClubId("Club Brugge"),
    id: 437,
    position: "Defender",
    type: "Paid",
    player: "Maxim De Cuyper"
},
{
    date: cleanDate("05-07-2025"),
    country: "JPN",
    amount: cleanAmount(10000000),
    toClubId: getClubId("Birmingham City"),
    fromClubId: getClubId("Rennes"),
    id: 438,
    position: "Forward",
    type: "Paid",
    player: "Kyogo Furuhashi"
},
{
    date: cleanDate("05-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Bolton"),
    fromClubId: getClubId("Brighton"),
    id: 439,
    position: "Winger",
    type: "Loan",
    player: "Amario Cozier-Duberry"
},
{
    date: cleanDate("05-07-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Watford"),
    fromClubId: getClubId("Udinese"),
    id: 440,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Vivaldo Semedo"
},
{
    date: cleanDate("06-07-2025"),
    country: "ESP",
    amount: cleanAmount(56000000),
    toClubId: getClubId("Arsenal"),
    fromClubId: getClubId("Real Sociedad"),
    id: 441,
    position: "Midfielder",
    type: "Paid",
    player: "Martín Zubimendi"
},
{
    date: cleanDate("06-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Aberdeen"),
    fromClubId: getClubId("Sunderland"),
    id: 442,
    position: "Midfielder",
    type: "Loan",
    player: "Adil Aouchiche"
},
{
    date: cleanDate("06-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Torres"),
    fromClubId: getClubId("Fiorentina"),
    id: 443,
    position: "Defender",
    type: "Free",
    player: "Christian Biagetti"
},
{
    date: cleanDate("06-07-2025"),
    country: "CZE",
    amount: cleanAmount(9350000),
    toClubId: getClubId("Bologna"),
    fromClubId: getClubId("Sparta Prague"),
    id: 444,
    position: "Defender",
    type: "Paid",
    player: "Martin Vitik"
},
{
    date: cleanDate("05-07-2025"),
    country: "POL",
    amount: cleanAmount(12750000),
    toClubId: getClubId("Neom SC"),
    fromClubId: getClubId("Nice"),
    id: 445,
    position: "Goalkeeper",
    type: "Paid",
    player: "Marcin Bulka"
},
{
    date: cleanDate("07-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Sporting Gijón"),
    fromClubId: getClubId("Hamburg"),
    id: 446,
    position: "Defender",
    type: "Free",
    player: "Lucas Perrin"
},
{
    date: cleanDate("07-07-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("AGF"),
    fromClubId: getClubId("Cologne"),
    id: 447,
    position: "Defender",
    type: "Loan",
    player: "Rasmus Carstensen"
},
{
    date: cleanDate("05-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Cologne"),
    fromClubId: getClubId("Mainz 05"),
    id: 448,
    position: "Midfielder",
    type: "Loan",
    player: "Tom Krauss"
},
{
    date: cleanDate("07-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Rayo Vallecano"),
    fromClubId: getClubId("Marseille"),
    id: 449,
    position: "Defender",
    type: "Free",
    player: "Luiz Felipe"
},
{
    date: cleanDate("06-07-2025"),
    country: "GEO",
    amount: cleanAmount(4675000),
    toClubId: getClubId("Sporting CP"),
    fromClubId: getClubId("Levante"),
    id: 450,
    position: "Midfielder",
    type: "Paid",
    player: "Giorgi Kochorashvili"
},
{
    date: cleanDate("02-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("West Ham"),
    fromClubId: getClubId("Newcastle"),
    id: 451,
    position: "Forward",
    type: "Free ",
    player: "Callum Wilson"
},
{
    date: cleanDate("07-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Bochum"),
    fromClubId: getClubId("Union Berlin"),
    id: 452,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Kevin Vogt"
},
{
    date: cleanDate("07-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Mantova"),
    fromClubId: getClubId("Genoa"),
    id: 453,
    position: "Defender",
    type: "Loan",
    player: "Tommaso Pittino"
},
{
    date: cleanDate("07-07-2025"),
    country: "COM",
    amount: cleanAmount(0),
    toClubId: getClubId("Francs Borains"),
    fromClubId: getClubId("Lens"),
    id: 454,
    position: "Goalkeeper",
    type: "Loan",
    player: "Yannick Pandor"
},
{
    date: cleanDate("06-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Johor Darul Ta'zim"),
    fromClubId: getClubId("Getafe"),
    id: 455,
    position: "Defender",
    type: "Loan",
    player: "Jonathan Silva"
},
{
    date: cleanDate("05-07-2025"),
    country: "BEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Bandirmaspor"),
    fromClubId: getClubId("Angers"),
    id: 456,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Cédric Hountondji"
},
{
    date: cleanDate("06-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Oviedo"),
    fromClubId: getClubId("Mirandés"),
    id: 457,
    position: "Midfielder",
    type: "Free",
    player: "Alberto Reina"
},
{
    date: cleanDate("06-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Zaragoza"),
    fromClubId: getClubId("Real Oviedo"),
    id: 458,
    position: "Winger",
    type: "Free",
    player: "Sebas Moyano"
},
{
    date: cleanDate("05-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Pergolettese"),
    fromClubId: getClubId("Genoa"),
    id: 459,
    position: "Forward",
    type: "Loan",
    player: "Gabriele Pessolani"
},
{
    date: cleanDate("07-07-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Reading"),
    fromClubId: getClubId("Brighton"),
    id: 460,
    position: "Forward",
    type: "Loan",
    player: "Mark O\u2019Mahony"
},
{
    date: cleanDate("05-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Ceuta"),
    fromClubId: getClubId("Levante"),
    id: 461,
    position: "Defender",
    type: "Loan",
    player: "Manu Sánchez"
},
{
    date: cleanDate("07-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Reading"),
    fromClubId: getClubId("Manchester City"),
    id: 462,
    position: "Defender",
    type: "Loan",
    player: "Finley Burns"
},
{
    date: cleanDate("05-07-2025"),
    country: "BEL",
    amount: cleanAmount(0),
    toClubId: getClubId("Kocaelispor"),
    fromClubId: getClubId("Juventus"),
    id: 463,
    position: "Midfielder",
    type: "Free",
    player: "Joseph Nonge"
},
{
    date: cleanDate("31-05-2025"),
    country: "AUT",
    amount: cleanAmount(0),
    toClubId: getClubId("Mainz 05"),
    fromClubId: getClubId("Sturm Graz"),
    id: 464,
    position: "Defender",
    type: "Free",
    player: "Konstantin Schopp"
},
{
    date: cleanDate("05-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Monza"),
    fromClubId: getClubId("Milan"),
    id: 465,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Adam Bakoune"
},
{
    date: cleanDate("01-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Hannover 96"),
    fromClubId: getClubId("Wolfsburg"),
    id: 466,
    position: "Defender",
    type: "Free",
    player: "Manuel Braun"
},
{
    date: cleanDate("07-07-2025"),
    country: "FRA",
    amount: cleanAmount(6500000),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Borussia Dortmund"),
    id: 467,
    position: "Defender",
    type: "Paid",
    player: "Soumaïla Coulibaly"
},
{
    date: cleanDate("07-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Cologne"),
    fromClubId: getClubId("Hannover 96"),
    id: 468,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Ron-Robert Zieler"
},
{
    date: cleanDate("10-06-2025"),
    country: "LUX",
    amount: cleanAmount(0),
    toClubId: getClubId("Greuther Fürth"),
    fromClubId: getClubId("Cologne"),
    id: 469,
    position: "Midfielder",
    type: "Free",
    player: "Mathias Olesen"
},
{
    date: cleanDate("04-07-2025"),
    country: "NZL",
    amount: cleanAmount(0),
    toClubId: getClubId("Sheffield United"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 470,
    position: "Defender",
    type: "Loan",
    player: "Tyler Bindon"
},
{
    date: cleanDate("24-05-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Augsburg"),
    fromClubId: getClubId("Troyes"),
    id: 471,
    position: "Forward",
    type: "Free",
    player: "Kyliane Dong"
},
{
    date: cleanDate("05-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Lens"),
    fromClubId: getClubId("Padova"),
    id: 472,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Mattia Fortin"
},
{
    date: cleanDate("07-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Lecce"),
    fromClubId: getClubId("Milan"),
    id: 473,
    position: "Forward",
    type: "Loan",
    player: "Francesco Camarda"
},
{
    date: cleanDate("04-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Getafe"),
    fromClubId: getClubId("Las Palmas"),
    id: 474,
    position: "Midfielder",
    type: "Free",
    player: "Javi Muñoz"
},
{
    date: cleanDate("03-07-2025"),
    country: "ESP",
    amount: cleanAmount(600000),
    toClubId: getClubId("Getafe"),
    fromClubId: getClubId("Recreativo de Huelva"),
    id: 475,
    position: "Defender",
    type: "Paid",
    player: "Davinchi"
},
{
    date: cleanDate("08-07-2025"),
    country: "JPN",
    amount: cleanAmount(5000000),
    toClubId: getClubId("Tottenham"),
    fromClubId: getClubId("Kawasaki Frontale"),
    id: 476,
    position: "Defender",
    type: "Paid",
    player: "Kota Takai"
},
{
    date: cleanDate("08-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Nantes"),
    fromClubId: getClubId("Wolfsburg"),
    id: 477,
    position: "Defender",
    type: "Loan",
    player: "Nicolas Cozza"
},
{
    date: cleanDate("08-07-2025"),
    country: "BEN",
    amount: cleanAmount(0),
    toClubId: getClubId("St Pauli"),
    fromClubId: getClubId("Burnley"),
    id: 478,
    position: "Forward",
    type: "Loan",
    player: "Andréas Hountondji"
},
{
    date: cleanDate("08-07-2025"),
    country: "SRB",
    amount: cleanAmount(4250000),
    toClubId: getClubId("Stuttgart"),
    fromClubId: getClubId("Red Star Belgrade"),
    id: 479,
    position: "Winger",
    type: "Paid",
    player: "Lazar Jovanovic"
},
{
    date: cleanDate("08-07-2025"),
    country: "MOZ",
    amount: cleanAmount(0),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 480,
    position: "Defender",
    type: "Free",
    player: "Reinildo Mandava"
},
{
    date: cleanDate("08-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Rosario Central"),
    fromClubId: getClubId("Tottenham"),
    id: 481,
    position: "Forward",
    type: "Loan",
    player: "Alejo Véliz"
},
{
    date: cleanDate("08-07-2025"),
    country: "SWE",
    amount: cleanAmount(10000000),
    toClubId: getClubId("Leeds United"),
    fromClubId: getClubId("Lille"),
    id: 482,
    position: "Defender",
    type: "Paid",
    player: "Gabriel Gudmundsson "
},
{
    date: cleanDate("08-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Málaga"),
    fromClubId: getClubId("Celta Vigo"),
    id: 483,
    position: "Midfielder",
    type: "Loan",
    player: "Carlos Dotor"
},
{
    date: cleanDate("08-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Palermo"),
    fromClubId: getClubId("Cagliari"),
    id: 484,
    position: "Defender",
    type: "Free",
    player: "Tommaso Augello"
},
{
    date: cleanDate("08-07-2025"),
    country: "GHA",
    amount: cleanAmount(0),
    toClubId: getClubId("Auxerre"),
    fromClubId: getClubId("Brighton"),
    id: 485,
    position: "Winger",
    type: "Loan",
    player: "Ibrahim Osman"
},
{
    date: cleanDate("08-07-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Verona"),
    fromClubId: getClubId("Corinthians"),
    id: 486,
    position: "Forward",
    type: "Free",
    player: "Giovane"
},
{
    date: cleanDate("08-07-2025"),
    country: "COD",
    amount: cleanAmount(0),
    toClubId: getClubId("Montpellier"),
    fromClubId: getClubId("Augsburg"),
    id: 487,
    position: "Forward",
    type: "Loan",
    player: "Nathanaël Mbuku"
},
{
    date: cleanDate("08-07-2025"),
    country: "ESP",
    amount: cleanAmount(1720000),
    toClubId: getClubId("Westerlo"),
    fromClubId: getClubId("Eintracht Frankfurt"),
    id: 488,
    position: "Forward",
    type: "Paid",
    player: "Nacho Ferri"
},
{
    date: cleanDate("08-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Levante"),
    fromClubId: getClubId("Sassuolo"),
    id: 489,
    position: "Defender",
    type: "Free",
    player: "Jeremy Toljan"
},
{
    date: cleanDate("09-07-2025"),
    country: "MAR",
    amount: cleanAmount(19500000),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("Club Brugge"),
    id: 490,
    position: "Winger",
    type: "Paid",
    player: "Chemsdine Talbi"
},
{
    date: cleanDate("08-07-2025"),
    country: "ALB",
    amount: cleanAmount(0),
    toClubId: getClubId("Hajduk Split"),
    fromClubId: getClubId("Fulham"),
    id: 491,
    position: "Midfielder",
    type: "Free",
    player: "Adrion Pajaziti"
},
{
    date: cleanDate("09-07-2025"),
    country: "FRA",
    amount: cleanAmount(27000000),
    toClubId: getClubId("Everton"),
    fromClubId: getClubId("Villarreal"),
    id: 492,
    position: "Forward",
    type: "Paid",
    player: "Thierno Barry"
},
{
    date: cleanDate("09-07-2025"),
    country: "USA",
    amount: cleanAmount(7000000),
    toClubId: getClubId("Southampton"),
    fromClubId: getClubId("Cologne"),
    id: 493,
    position: "Forward",
    type: "Paid",
    player: "Damion Downs"
},
{
    date: cleanDate("09-07-2025"),
    country: "PAR",
    amount: cleanAmount(10000000),
    toClubId: getClubId("Palmeiras"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 494,
    position: "Winger",
    type: "Paid",
    player: "Ramón Sosa"
},
{
    date: cleanDate("08-07-2025"),
    country: "COL",
    amount: cleanAmount(0),
    toClubId: getClubId("Chesterfield"),
    fromClubId: getClubId("Fulham"),
    id: 495,
    position: "Defender",
    type: "Loan",
    player: "Devan Tanton"
},
{
    date: cleanDate("09-07-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Alverca"),
    fromClubId: getClubId("Wolves"),
    id: 496,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Chiquinho"
},
{
    date: cleanDate("09-07-2025"),
    country: "BUR",
    amount: cleanAmount(0),
    toClubId: getClubId("Rangers"),
    fromClubId: getClubId("Wolves"),
    id: 497,
    position: "Defender",
    type: "Loan",
    player: "Nasser Djiga"
},
{
    date: cleanDate("10-07-2025"),
    country: "DEN",
    amount: cleanAmount(9000000),
    toClubId: getClubId("Arsenal"),
    fromClubId: getClubId("Brentford"),
    id: 498,
    position: "Midfielder",
    type: "Paid",
    player: "Christian Nørgaard"
},
{
    date: cleanDate("10-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Bologna"),
    fromClubId: getClubId("Beşiktaş"),
    id: 499,
    position: "Forward",
    type: "Free",
    player: "Ciro Immobile"
},
{
    date: cleanDate("10-07-2025"),
    country: "CIV",
    amount: cleanAmount(21000000),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("Brighton"),
    id: 500,
    position: "Forward",
    type: "Paid",
    player: "Simon Adingra"
},
{
    date: cleanDate("10-07-2025"),
    country: "FRA",
    amount: cleanAmount(21250000),
    toClubId: getClubId("Al-Hilal"),
    fromClubId: getClubId("Milan"),
    id: 501,
    position: "Defender",
    type: "Paid",
    player: "Théo Hernandez"
},
{
    date: cleanDate("10-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Stoke City"),
    fromClubId: getClubId("West Ham"),
    id: 502,
    position: "Defender",
    type: "Free",
    player: "Aaron Cresswell"
},
{
    date: cleanDate("10-07-2025"),
    country: "GHA",
    amount: cleanAmount(54500000),
    toClubId: getClubId("Tottenham"),
    fromClubId: getClubId("West Ham"),
    id: 503,
    position: "Winger",
    type: "Paid",
    player: "Mohammed Kudus"
},
{
    date: cleanDate("10-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Notts County"),
    fromClubId: getClubId("Manchester United"),
    id: 504,
    position: "Defender",
    type: "Loan",
    player: "Sonny Aljofree"
},
{
    date: cleanDate("10-07-2025"),
    country: "NED",
    amount: cleanAmount(0),
    toClubId: getClubId("Luton Town"),
    fromClubId: getClubId("Wolves"),
    id: 505,
    position: "Defender",
    type: "Loan",
    player: "Nigel Lonwijk"
},
{
    date: cleanDate("10-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Exeter City"),
    fromClubId: getClubId("Crystal Palace"),
    id: 506,
    position: "Goalkeeper",
    type: "Loan",
    player: "Joe Whitworth"
},
{
    date: cleanDate("11-07-2025"),
    country: "CRO",
    amount: cleanAmount(3000000),
    toClubId: getClubId("Crystal Palace"),
    fromClubId: getClubId("Ajax"),
    id: 507,
    position: "Defender",
    type: "Paid",
    player: "Borna Sosa"
},
{
    date: cleanDate("10-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Boca Juniors"),
    fromClubId: getClubId("Roma"),
    id: 508,
    position: "Midfielder",
    type: "Free",
    player: "Leandro Paredes"
},
{
    date: cleanDate("10-07-2025"),
    country: "UZB",
    amount: cleanAmount(0),
    toClubId: getClubId("Istanbul Basaksehir"),
    fromClubId: getClubId("Roma"),
    id: 509,
    position: "Forward",
    type: "Loan",
    player: "Eldor Shomurodov"
},
{
    date: cleanDate("11-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("St Pauli"),
    fromClubId: getClubId("Arminia Bielefeld"),
    id: 510,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Louis Oppie"
},
{
    date: cleanDate("11-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Union Berlin"),
    fromClubId: getClubId("Hamburg"),
    id: 511,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Matheo Raab"
},
{
    date: cleanDate("11-07-2025"),
    country: "GER",
    amount: cleanAmount(16500000),
    toClubId: getClubId("Como"),
    fromClubId: getClubId("Celtic"),
    id: 512,
    position: "Winger",
    type: "Paid",
    player: "Nicolas Kühn"
},
{
    date: cleanDate("11-07-2025"),
    country: "BRA",
    amount: cleanAmount(10200000),
    toClubId: getClubId("Nottingham Forest"),
    fromClubId: getClubId("Botafogo"),
    id: 513,
    position: "Defender",
    type: "Paid",
    player: "Jair Cunha"
},
{
    date: cleanDate("11-07-2025"),
    country: "GEO",
    amount: cleanAmount(0),
    toClubId: getClubId("Metz"),
    fromClubId: getClubId("Dynamo Kyiv"),
    id: 514,
    position: "Winger",
    type: "Loan",
    player: "Giorgi Tsitaishvili"
},
{
    date: cleanDate("11-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Frosinone"),
    fromClubId: getClubId("Genoa"),
    id: 515,
    position: "Defender",
    type: "Loan",
    player: "Gabriele Calvani"
},
{
    date: cleanDate("11-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Padova"),
    fromClubId: getClubId("Juventus"),
    id: 516,
    position: "Defender",
    type: "Loan",
    player: "Lorenzo Villa"
},
{
    date: cleanDate("11-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Padova"),
    fromClubId: getClubId("Fiorentina"),
    id: 517,
    position: "Midfielder",
    type: "Loan",
    player: "Jonas Harder"
},
{
    date: cleanDate("11-07-2025"),
    country: "ESP",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Osasuna"),
    fromClubId: getClubId("Real Madrid"),
    id: 518,
    position: "Forward",
    type: "Paid",
    player: "Víctor Muñoz"
},
{
    date: cleanDate("11-07-2025"),
    country: "ESP",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Benfica"),
    fromClubId: getClubId("Real Madrid"),
    id: 519,
    position: "Defender",
    type: "Paid",
    player: "Rafael Obrador"
},
{
    date: cleanDate("11-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Elche"),
    fromClubId: getClubId("Saint-Etienne"),
    id: 520,
    position: "Defender",
    type: "Free",
    player: "Léo Pétrot"
},
{
    date: cleanDate("11-07-2025"),
    country: "ARG",
    amount: cleanAmount(7400000),
    toClubId: getClubId("New York City"),
    fromClubId: getClubId("Elche"),
    id: 521,
    position: "Midfielder",
    type: "Paid",
    player: "Nico Fernández"
},
{
    date: cleanDate("11-07-2025"),
    country: "SWE",
    amount: cleanAmount(55000000),
    toClubId: getClubId("Newcastle"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 522,
    position: "Forward",
    type: "Paid",
    player: "Anthony Elanga"
},
{
    date: cleanDate("11-07-2025"),
    country: "HUN",
    amount: cleanAmount(0),
    toClubId: getClubId("Kasimpasa"),
    fromClubId: getClubId("Hoffenheim"),
    id: 523,
    position: "Defender",
    type: "Loan",
    player: "Attila Szalai"
},
{
    date: cleanDate("11-07-2025"),
    country: "FIN",
    amount: cleanAmount(0),
    toClubId: getClubId("Aris Saloniki"),
    fromClubId: getClubId("Augsburg"),
    id: 524,
    position: "Midfielder",
    type: "Free",
    player: "Fredrik Jensen"
},
{
    date: cleanDate("11-07-2025"),
    country: "DEN",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Stuttgart"),
    id: 525,
    position: "Winger",
    type: "Paid",
    player: "Jacob Bruun Larsen"
},
{
    date: cleanDate("11-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Valencia"),
    fromClubId: getClubId("Athletic Club"),
    id: 526,
    position: "Goalkeeper",
    type: "Loan",
    player: "Julen Agirrezabala"
},
{
    date: cleanDate("11-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Racing Club"),
    fromClubId: getClubId("Alavés"),
    id: 527,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Tomás Conechny"
},
{
    date: cleanDate("11-07-2025"),
    country: "CMR",
    amount: cleanAmount(0),
    toClubId: getClubId("Bayer Leverkusen"),
    fromClubId: getClubId("Albacete"),
    id: 528,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Christian Kofane"
},
{
    date: cleanDate("11-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Marítimo"),
    fromClubId: getClubId("Levante"),
    id: 529,
    position: "Defender",
    type: "Loan",
    player: "Xavi Grande"
},
{
    date: cleanDate("11-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Levante"),
    fromClubId: getClubId("Fiorentina"),
    id: 530,
    position: "Defender",
    type: "Loan",
    player: "Matías Moreno"
},
{
    date: cleanDate("11-07-2025"),
    country: "MAR",
    amount: cleanAmount(1300000),
    toClubId: getClubId("Real Oviedo"),
    fromClubId: getClubId("Girona"),
    id: 531,
    position: "Winger",
    type: "Paid",
    player: "Ilyas Chaira"
},
{
    date: cleanDate("11-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Istanbul Basaksehir"),
    fromClubId: getClubId("Hamburg"),
    id: 532,
    position: "Forward",
    type: "Free",
    player: "Davie Selke"
},
{
    date: cleanDate("10-07-2025"),
    country: "ARG",
    amount: cleanAmount(3000000),
    toClubId: getClubId("Hamburg"),
    fromClubId: getClubId("Red Bull Salzburg"),
    id: 533,
    position: "Midfielder",
    type: "Paid",
    player: "Nicolás Capaldo"
},
{
    date: cleanDate("10-07-2025"),
    country: "ESP",
    amount: cleanAmount(8700000),
    toClubId: getClubId("PSV Eindhoven"),
    fromClubId: getClubId("Valencia"),
    id: 534,
    position: "Defender",
    type: "Paid",
    player: "Yarek Gasiorowski"
},
{
    date: cleanDate("12-07-2025"),
    country: "USA",
    amount: cleanAmount(30000000),
    toClubId: getClubId("Bayer Leverkusen"),
    fromClubId: getClubId("PSV Eindhoven"),
    id: 535,
    position: "Midfielder",
    type: "Paid",
    player: "Malik Tillman"
},
{
    date: cleanDate("11-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Havre"),
    fromClubId: getClubId("Caen"),
    id: 536,
    position: "Winger",
    type: "Free",
    player: "Godson Kyeremeh"
},
{
    date: cleanDate("12-07-2025"),
    country: "GEO",
    amount: cleanAmount(850000),
    toClubId: getClubId("Nuremberg"),
    fromClubId: getClubId("Cremonese"),
    id: 537,
    position: "Defender",
    type: "Paid",
    player: "Luka Lochoshvili"
},
{
    date: cleanDate("12-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Chelsea"),
    id: 538,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Mathis Amougou"
},
{
    date: cleanDate("12-07-2025"),
    country: "SEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Havre"),
    fromClubId: getClubId("Clermont Foot"),
    id: 539,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Mory Diaw"
},
{
    date: cleanDate("11-07-2025"),
    country: "SUI",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Havre"),
    fromClubId: getClubId("St Gallen"),
    id: 540,
    position: "Forward",
    type: "Free",
    player: "Felix Mambimbi"
},
{
    date: cleanDate("12-07-2025"),
    country: "CHI",
    amount: cleanAmount(0),
    toClubId: getClubId("Sevilla"),
    fromClubId: getClubId("Toulouse"),
    id: 541,
    position: "Defender",
    type: "Free",
    player: "Gabriel Suazo"
},
{
    date: cleanDate("12-07-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Vejle"),
    fromClubId: getClubId("Stuttgart"),
    id: 542,
    position: "Forward",
    type: "Free",
    player: "Wahid Faghir"
},
{
    date: cleanDate("11-07-2025"),
    country: "MAR",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Madrid"),
    fromClubId: getClubId("Almería"),
    id: 543,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Rachad Fettal"
},
{
    date: cleanDate("12-07-2025"),
    country: "BRA",
    amount: cleanAmount(5620000),
    toClubId: getClubId("Krasnodar"),
    fromClubId: getClubId("Nantes"),
    id: 544,
    position: "Midfielder",
    type: "Paid",
    player: "Douglas Augusto"
},
{
    date: cleanDate("13-07-2025"),
    country: "JAM",
    amount: cleanAmount(0),
    toClubId: getClubId("Al-Gharafa"),
    fromClubId: getClubId("Everton"),
    id: 545,
    position: "Defender",
    type: "Free",
    player: "Mason Holgate"
},
{
    date: cleanDate("13-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Havre"),
    fromClubId: getClubId("Strasbourg"),
    id: 546,
    position: "Defender",
    type: "Free",
    player: "Thomas Delaine"
},
{
    date: cleanDate("13-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Salernitana"),
    fromClubId: getClubId("Cremonese"),
    id: 547,
    position: "Defender",
    type: "Loan",
    player: "Eddy Cabianca"
},
{
    date: cleanDate("13-07-2025"),
    country: "COD",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Havre"),
    fromClubId: getClubId("Rodez"),
    id: 548,
    position: "Goalkeeper",
    type: "Free",
    player: "Lionel Mpasi-Nzau"
},
{
    date: cleanDate("13-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Pianese"),
    fromClubId: getClubId("Fiorentina"),
    id: 549,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Lorenzo Vigiani"
},
{
    date: cleanDate("11-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Crewe"),
    fromClubId: getClubId("Burnley"),
    id: 550,
    position: "Goalkeeper",
    type: "Loan",
    player: "Sam Waller"
},
{
    date: cleanDate("07-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Lens"),
    fromClubId: getClubId("Amiens"),
    id: 551,
    position: "Goalkeeper",
    type: "Free",
    player: "Régis Gurtner"
},
{
    date: cleanDate("03-07-2025"),
    country: "MLI",
    amount: cleanAmount(0),
    toClubId: getClubId("Kocaelispor"),
    fromClubId: getClubId("Brest"),
    id: 552,
    position: "Defender",
    type: "Free",
    player: "Massadio Haïdara"
},
{
    date: cleanDate("13-07-2025"),
    country: "NED",
    amount: cleanAmount(9900000),
    toClubId: getClubId("Ipswich Town"),
    fromClubId: getClubId("Rennes"),
    id: 553,
    position: "Midfielder",
    type: "Paid",
    player: "Azor Matusiwa"
},
{
    date: cleanDate("13-07-2025"),
    country: "DEN",
    amount: cleanAmount(1300000),
    toClubId: getClubId("Hamburg"),
    fromClubId: getClubId("RB Leipzig"),
    id: 554,
    position: "Forward",
    type: "Paid",
    player: "Yussuf Poulsen"
},
{
    date: cleanDate("13-07-2025"),
    country: "GEQ",
    amount: cleanAmount(0),
    toClubId: getClubId("FC Andorra"),
    fromClubId: getClubId("Alavés"),
    id: 555,
    position: "Goalkeeper",
    type: "Loan",
    player: "Jesús Owono"
},
{
    date: cleanDate("13-07-2025"),
    country: "CIV",
    amount: cleanAmount(0),
    toClubId: getClubId("Brest"),
    fromClubId: getClubId("Troyes"),
    id: 556,
    position: "Defender",
    type: "Loan",
    player: "Junior Diaz"
},
{
    date: cleanDate("13-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Avellino"),
    fromClubId: getClubId("Atalanta"),
    id: 557,
    position: "Midfielder",
    type: "Loan",
    player: "Emmanuel Gyabuaa"
},
{
    date: cleanDate("04-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Dunkerque"),
    fromClubId: getClubId("Toulouse"),
    id: 558,
    position: "Goalkeeper",
    type: "Loan",
    player: "Mathys Niflore"
},
{
    date: cleanDate("10-07-2025"),
    country: "MLI",
    amount: cleanAmount(0),
    toClubId: getClubId("Bandirmaspor"),
    fromClubId: getClubId("Rennes"),
    id: 559,
    position: "Forward",
    type: "Free",
    player: "Wilson Samaké"
},
{
    date: cleanDate("14-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Millwall"),
    fromClubId: getClubId("Chelsea"),
    id: 560,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Zak Sturge"
},
{
    date: cleanDate("14-07-2025"),
    country: "SUI",
    amount: cleanAmount(400000),
    toClubId: getClubId("Young Boys"),
    fromClubId: getClubId("Mainz 05"),
    id: 561,
    position: "Midfielder",
    type: "Paid",
    player: "Edimilson Fernandes"
},
{
    date: cleanDate("14-07-2025"),
    country: "SWE",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Barcelona"),
    fromClubId: getClubId("FC Copenhagen"),
    id: 562,
    position: "Winger",
    type: "Paid",
    player: "Roony Bardghji"
},
{
    date: cleanDate("14-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cremonese"),
    fromClubId: getClubId("Lazio"),
    id: 563,
    position: "Winger",
    type: "Loan",
    player: "Romano Floriani Mussolini"
},
{
    date: cleanDate("14-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Beveren"),
    fromClubId: getClubId("Strasbourg"),
    id: 564,
    position: "Defender",
    type: "Loan",
    player: "Yoni Gomis"
},
{
    date: cleanDate("14-07-2025"),
    country: "SRB",
    amount: cleanAmount(0),
    toClubId: getClubId("RB Leipzig"),
    fromClubId: getClubId("Aston Villa"),
    id: 565,
    position: "Defender",
    type: "Loan",
    player: "Kosta Nedeljkovic"
},
{
    date: cleanDate("09-07-2025"),
    country: "ROU",
    amount: cleanAmount(0),
    toClubId: getClubId("Empoli"),
    fromClubId: getClubId("Nice"),
    id: 566,
    position: "Midfielder",
    type: "Loan",
    player: "Rares Ilie"
},
{
    date: cleanDate("14-07-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Mansfield Town"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 567,
    position: "Forward",
    type: "Loan",
    player: "Joe Gardner"
},
{
    date: cleanDate("14-07-2025"),
    country: "CRO",
    amount: cleanAmount(0),
    toClubId: getClubId("Milan"),
    fromClubId: getClubId("Real Madrid"),
    id: 568,
    position: "Midfielder",
    type: "Free",
    player: "Luka Modric"
},
{
    date: cleanDate("14-07-2025"),
    country: "ESP",
    amount: cleanAmount(43400000),
    toClubId: getClubId("Real Madrid"),
    fromClubId: getClubId("Benfica"),
    id: 569,
    position: "Defender",
    type: "Paid",
    player: "Álvaro Carreras"
},
{
    date: cleanDate("14-07-2025"),
    country: "ESP",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Mallorca"),
    fromClubId: getClubId("Barcelona"),
    id: 570,
    position: "Midfielder",
    type: "Paid",
    player: "Pablo Torre"
},
{
    date: cleanDate("14-07-2025"),
    country: "BIH",
    amount: cleanAmount(7400000),
    toClubId: getClubId("Benfica"),
    fromClubId: getClubId("Red Bull Salzburg"),
    id: 571,
    position: "Defender",
    type: "Paid",
    player: "Amar Dedic"
},
{
    date: cleanDate("14-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Aris Saloniki"),
    fromClubId: getClubId("Espanyol"),
    id: 572,
    position: "Defender",
    type: "Free",
    player: "Álvaro Tejero"
},
{
    date: cleanDate("14-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("AVS"),
    fromClubId: getClubId("Levante"),
    id: 573,
    position: "Midfielder",
    type: "Free",
    player: "Ángel Algobia"
},
{
    date: cleanDate("14-07-2025"),
    country: "POL",
    amount: cleanAmount(0),
    toClubId: getClubId("Rakow"),
    fromClubId: getClubId("Aston Villa"),
    id: 574,
    position: "Goalkeeper",
    type: "Loan",
    player: "Oliwier Zych"
},
{
    date: cleanDate("15-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Crewe"),
    fromClubId: getClubId("Aston Villa"),
    id: 575,
    position: "Midfielder",
    type: "Loan",
    player: "Tommi O'Reilly"
},
{
    date: cleanDate("15-07-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Wycombe"),
    fromClubId: getClubId("Brighton"),
    id: 576,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Jamie Mullins"
},
{
    date: cleanDate("15-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Swindon Town"),
    fromClubId: getClubId("Aston Villa"),
    id: 577,
    position: "Defender",
    type: "Loan",
    player: "Finley Munroe"
},
{
    date: cleanDate("15-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Blackpool"),
    fromClubId: getClubId("Crystal Palace"),
    id: 578,
    position: "Defender",
    type: "Loan",
    player: "Danny Imray"
},
{
    date: cleanDate("15-07-2025"),
    country: "IRL",
    amount: cleanAmount(4000000),
    toClubId: getClubId("Everton"),
    fromClubId: getClubId("Bournemouth"),
    id: 579,
    position: "Goalkeeper",
    type: "Paid",
    player: "Mark Travers"
},
{
    date: cleanDate("15-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Brentford"),
    fromClubId: getClubId("Ajax"),
    id: 580,
    position: "Midfielder",
    type: "Free",
    player: "Jordan Henderson"
},
{
    date: cleanDate("15-07-2025"),
    country: "SEN",
    amount: cleanAmount(22000000),
    toClubId: getClubId("West Ham"),
    fromClubId: getClubId("Slavia Prague"),
    id: 581,
    position: "Defender",
    type: "Paid",
    player: "El Hadji Malick Diouf"
},
{
    date: cleanDate("15-07-2025"),
    country: "NED",
    amount: cleanAmount(0),
    toClubId: getClubId("Aston Villa"),
    fromClubId: getClubId("Brest"),
    id: 582,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Marco Bizot"
},
{
    date: cleanDate("16-07-2025"),
    country: "SRB",
    amount: cleanAmount(25000000),
    toClubId: getClubId("Bournemouth"),
    fromClubId: getClubId("Chelsea"),
    id: 583,
    position: "Goalkeeper",
    type: "Paid",
    player: "Djordje Petrovic"
},
{
    date: cleanDate("16-07-2025"),
    country: "KOR",
    amount: cleanAmount(0),
    toClubId: getClubId("Excelsior"),
    fromClubId: getClubId("Brighton"),
    id: 584,
    position: "Winger",
    type: "Loan",
    player: "Yoon Do-young"
},
{
    date: cleanDate("16-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Bromley"),
    fromClubId: getClubId("Brentford"),
    id: 585,
    position: "Midfielder",
    type: "Loan",
    player: "Ben Krauhaus"
},
{
    date: cleanDate("16-07-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Watford"),
    fromClubId: getClubId("Udinese"),
    id: 586,
    position: "Forward",
    type: "Loan",
    player: "Luca Kjerrumgaard"
},
{
    date: cleanDate("16-07-2025"),
    country: "BRA",
    amount: cleanAmount(1900000),
    toClubId: getClubId("Al-Wasl"),
    fromClubId: getClubId("Lyon"),
    id: 587,
    position: "Defender",
    type: "Paid",
    player: "Adryelson"
},
{
    date: cleanDate("16-07-2025"),
    country: "BEL",
    amount: cleanAmount(19100000),
    toClubId: getClubId("RB Leipzig"),
    fromClubId: getClubId("PSV Eindhoven"),
    id: 588,
    position: "Winger",
    type: "Paid",
    player: "Johan Bakayoko"
},
{
    date: cleanDate("16-07-2025"),
    country: "CRO",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Dinamo Zagreb"),
    fromClubId: getClubId("Augsburg"),
    id: 589,
    position: "Forward",
    type: "Paid",
    player: "Dion Drena Beljo"
},
{
    date: cleanDate("16-07-2025"),
    country: "MAR",
    amount: cleanAmount(0),
    toClubId: getClubId("Al-Ahli Doha"),
    fromClubId: getClubId("Nice"),
    id: 590,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Ayoub Amraoui"
},
{
    date: cleanDate("16-07-2025"),
    country: "SVK",
    amount: cleanAmount(0),
    toClubId: getClubId("Ettifaq"),
    fromClubId: getClubId("Verona"),
    id: 591,
    position: "Midfielder",
    type: "Free",
    player: "Ondrej Duda"
},
{
    date: cleanDate("16-07-2025"),
    country: "NED",
    amount: cleanAmount(0),
    toClubId: getClubId("Reggiana"),
    fromClubId: getClubId("Verona"),
    id: 592,
    position: "Winger",
    type: "Loan",
    player: "Elayis Tavsan"
},
{
    date: cleanDate("16-07-2025"),
    country: "CIV",
    amount: cleanAmount(0),
    toClubId: getClubId("Alverca"),
    fromClubId: getClubId("Lorient"),
    id: 593,
    position: "Winger",
    type: "Free",
    player: "Stéphane Diarra"
},
{
    date: cleanDate("16-07-2025"),
    country: "MAR",
    amount: cleanAmount(2600000),
    toClubId: getClubId("Alavés"),
    fromClubId: getClubId("Real Madrid"),
    id: 594,
    position: "Defender",
    type: "Paid",
    player: "Youssef Enríquez"
},
{
    date: cleanDate("16-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Eibar"),
    fromClubId: getClubId("Athletic Club"),
    id: 595,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Javi Martón"
},
{
    date: cleanDate("16-07-2025"),
    country: "SRB",
    amount: cleanAmount(12100000),
    toClubId: getClubId("RB Leipzig"),
    fromClubId: getClubId("Red Star Belgrade"),
    id: 596,
    position: "Midfielder",
    type: "Paid",
    player: "Andrija Maksimovic"
},
{
    date: cleanDate("16-07-2025"),
    country: "USA",
    amount: cleanAmount(26000000),
    toClubId: getClubId("Atlético Madrid"),
    fromClubId: getClubId("Real Betis"),
    id: 597,
    position: "Midfielder",
    type: "Paid",
    player: "Johnny Cardoso"
},
{
    date: cleanDate("16-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Pontedera"),
    fromClubId: getClubId("Fiorentina"),
    id: 598,
    position: "Goalkeeper",
    type: "Loan",
    player: "Tommaso Vannucchi"
},
{
    date: cleanDate("16-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Ingolstadt"),
    fromClubId: getClubId("Freiburg"),
    id: 599,
    position: "Winger",
    type: "Loan",
    player: "Yann Sturm"
},
{
    date: cleanDate("16-07-2025"),
    country: "FIN",
    amount: cleanAmount(0),
    toClubId: getClubId("Modena"),
    fromClubId: getClubId("Bologna"),
    id: 600,
    position: "Midfielder",
    type: "Loan",
    player: "Niklas Pyyhtiä"
},
{
    date: cleanDate("17-07-2025"),
    country: "DOM",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Betis"),
    fromClubId: getClubId("Leeds United"),
    id: 601,
    position: "Defender",
    type: "Free",
    player: "Junior Firpo"
},
{
    date: cleanDate("17-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Paris Saint-Germain"),
    fromClubId: getClubId("Roma"),
    id: 602,
    position: "Goalkeeper",
    type: "Free",
    player: "Renato Marin"
},
{
    date: cleanDate("17-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Empoli"),
    fromClubId: getClubId("Inter"),
    id: 603,
    position: "Winger",
    type: "Loan",
    player: "Franco Carboni"
},
{
    date: cleanDate("17-07-2025"),
    country: "NED",
    amount: cleanAmount(21600000),
    toClubId: getClubId("Napoli"),
    fromClubId: getClubId("PSV Eindhoven"),
    id: 604,
    position: "Winger",
    type: "Paid",
    player: "Noa Lang"
},
{
    date: cleanDate("17-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Frosinone"),
    fromClubId: getClubId("Bologna"),
    id: 605,
    position: "Forward",
    type: "Loan",
    player: "Antonio Raimondo"
},
{
    date: cleanDate("17-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Rapid Wien"),
    fromClubId: getClubId("Sassuolo"),
    id: 606,
    position: "Forward",
    type: "Loan",
    player: "Janis Antiste"
},
{
    date: cleanDate("17-07-2025"),
    country: "NED",
    amount: cleanAmount(0),
    toClubId: getClubId("Exeter City"),
    fromClubId: getClubId("Aston Villa"),
    id: 607,
    position: "Defender",
    type: "Loan",
    player: "Sil Swinkels"
},
{
    date: cleanDate("17-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Grasshopper"),
    fromClubId: getClubId("Crystal Palace"),
    id: 608,
    position: "Forward",
    type: "Free",
    player: "Luke Plange"
},
{
    date: cleanDate("17-07-2025"),
    country: "SRB",
    amount: cleanAmount(0),
    toClubId: getClubId("Atlético Madrid"),
    fromClubId: getClubId("Racing Ferrol"),
    id: 609,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Aleksa Puric"
},
{
    date: cleanDate("17-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Rotherham"),
    fromClubId: getClubId("Manchester United"),
    id: 610,
    position: "Midfielder",
    type: "Loan",
    player: "Dan Gore"
},
{
    date: cleanDate("17-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Bari"),
    fromClubId: getClubId("Napoli"),
    id: 611,
    position: "Forward",
    type: "Loan",
    player: "Emanuele Rao"
},
{
    date: cleanDate("17-07-2025"),
    country: "ARG",
    amount: cleanAmount(18200000),
    toClubId: getClubId("Atlético Madrid"),
    fromClubId: getClubId("Botafogo"),
    id: 612,
    position: "Winger",
    type: "Paid",
    player: "Thiago Almada"
},
{
    date: cleanDate("17-07-2025"),
    country: "POR",
    amount: cleanAmount(6100000),
    toClubId: getClubId("Lille"),
    fromClubId: getClubId("Gil Vicente"),
    id: 613,
    position: "Winger",
    type: "Paid",
    player: "Félix Correia"
},
{
    date: cleanDate("17-07-2025"),
    country: "FRA",
    amount: cleanAmount(2600000),
    toClubId: getClubId("PSV Eindhoven"),
    fromClubId: getClubId("Borussia Mönchengladbach"),
    id: 614,
    position: "Winger",
    type: "Paid",
    player: "Alassane Pléa"
},
{
    date: cleanDate("16-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Leganés"),
    fromClubId: getClubId("Elche"),
    id: 615,
    position: "Goalkeeper",
    type: "Free",
    player: "Miguel San Román"
},
{
    date: cleanDate("17-07-2025"),
    country: "NOR",
    amount: cleanAmount(12400000),
    toClubId: getClubId("Manchester City"),
    fromClubId: getClubId("Rosenborg"),
    id: 616,
    position: "Midfielder",
    type: "Paid",
    player: "Sverre Nypan"
},
{
    date: cleanDate("16-07-2025"),
    country: "SEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Dunkerque"),
    fromClubId: getClubId("Strasbourg"),
    id: 617,
    position: "Midfielder",
    type: "Loan",
    player: "Pape Diong"
},
{
    date: cleanDate("16-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Rayo Vallecano"),
    fromClubId: getClubId("Granada"),
    id: 618,
    position: "Midfielder",
    type: "Loan",
    player: "Gerard Gumbau"
},
{
    date: cleanDate("16-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Elche"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 619,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Alejandro Iturbe"
},
{
    date: cleanDate("16-07-2025"),
    country: "ESP",
    amount: cleanAmount(400000),
    toClubId: getClubId("Levante"),
    fromClubId: getClubId("Real Sociedad"),
    id: 620,
    position: "Midfielder",
    type: "Paid",
    player: "Jon Ander Olasagasti"
},
{
    date: cleanDate("16-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Huesca"),
    fromClubId: getClubId("Levante"),
    id: 621,
    position: "Goalkeeper",
    type: "Loan",
    player: "Dani Martín"
},
{
    date: cleanDate("16-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Trento"),
    fromClubId: getClubId("Verona"),
    id: 622,
    position: "Defender",
    type: "Loan",
    player: "Christian Corradi"
},
{
    date: cleanDate("16-07-2025"),
    country: "TUR",
    amount: cleanAmount(0),
    toClubId: getClubId("Alanyaspor"),
    fromClubId: getClubId("Genoa"),
    id: 623,
    position: "Forward",
    type: "Free",
    player: "Guven Yalcin"
},
{
    date: cleanDate("16-07-2025"),
    country: "POL",
    amount: cleanAmount(5200000),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Legia Warsaw"),
    id: 624,
    position: "Midfielder",
    type: "Paid",
    player: "Maxi Oyedele"
},
{
    date: cleanDate("16-07-2025"),
    country: "CIV",
    amount: cleanAmount(0),
    toClubId: getClubId("Nancy"),
    fromClubId: getClubId("Strasbourg"),
    id: 625,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Patrick Ouotro"
},
{
    date: cleanDate("16-07-2025"),
    country: "CIV",
    amount: cleanAmount(17300000),
    toClubId: getClubId("RB Leipzig"),
    fromClubId: getClubId("Leganés"),
    id: 626,
    position: "Winger",
    type: "Paid",
    player: "Yan Diomande"
},
{
    date: cleanDate("16-07-2025"),
    country: "FRA",
    amount: cleanAmount(5000000),
    toClubId: getClubId("PSV Eindhoven"),
    fromClubId: getClubId("Freiburg"),
    id: 627,
    position: "Defender",
    type: "Paid",
    player: "Kiliann Sildillia"
},
{
    date: cleanDate("17-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Panathinaikos"),
    fromClubId: getClubId("Nantes"),
    id: 628,
    position: "Goalkeeper",
    type: "Loan",
    player: "Alban Lafont"
},
{
    date: cleanDate("17-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Granada"),
    fromClubId: getClubId("Osasuna"),
    id: 629,
    position: "Winger",
    type: "Free",
    player: "José Arnaiz"
},
{
    date: cleanDate("17-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Talleres"),
    fromClubId: getClubId("Cagliari"),
    id: 630,
    position: "Defender",
    type: "Free",
    player: "José Luis Palomino"
},
{
    date: cleanDate("15-07-2025"),
    country: "ESP",
    amount: cleanAmount(300000),
    toClubId: getClubId("Málaga"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 631,
    position: "Forward",
    type: "Paid",
    player: "Adrián Niño"
},
{
    date: cleanDate("15-07-2025"),
    country: "NOR",
    amount: cleanAmount(0),
    toClubId: getClubId("Al-Khaleej"),
    fromClubId: getClubId("Toulouse"),
    id: 632,
    position: "Forward",
    type: "Free",
    player: "Joshua King"
},
{
    date: cleanDate("15-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Carrarese"),
    fromClubId: getClubId("Fiorentina"),
    id: 633,
    position: "Forward",
    type: "Loan",
    player: "Tommaso Rubino"
},
{
    date: cleanDate("15-07-2025"),
    country: "SRB",
    amount: cleanAmount(0),
    toClubId: getClubId("Spezia"),
    fromClubId: getClubId("Atalanta"),
    id: 634,
    position: "Forward",
    type: "Loan",
    player: "Vanja Vlahovic"
},
{
    date: cleanDate("15-07-2025"),
    country: "FRA",
    amount: cleanAmount(3000000),
    toClubId: getClubId("Lens"),
    fromClubId: getClubId("Metz"),
    id: 635,
    position: "Defender",
    type: "Paid",
    player: "Matthieu Udol"
},
{
    date: cleanDate("15-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Lugano"),
    fromClubId: getClubId("Wolfsburg"),
    id: 636,
    position: "Forward",
    type: "Free",
    player: "Kevin Behrens"
},
{
    date: cleanDate("15-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Crotone"),
    fromClubId: getClubId("Sassuolo"),
    id: 637,
    position: "Midfielder",
    type: "Loan",
    player: "Kevin Bruno"
},
{
    date: cleanDate("15-07-2025"),
    country: "CMR",
    amount: cleanAmount(0),
    toClubId: getClubId("Verona"),
    fromClubId: getClubId("Udinese"),
    id: 638,
    position: "Defender",
    type: "Loan",
    player: "Enzo Ebosse"
},
{
    date: cleanDate("15-07-2025"),
    country: "GER",
    amount: cleanAmount(300000),
    toClubId: getClubId("Preußen Münster"),
    fromClubId: getClubId("Union Berlin"),
    id: 639,
    position: "Defender",
    type: "Paid",
    player: "Paul Jaeckel"
},
{
    date: cleanDate("15-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Marítimo"),
    fromClubId: getClubId("Valencia"),
    id: 640,
    position: "Midfielder",
    type: "Free",
    player: "Martín Tejón"
},
{
    date: cleanDate("15-07-2025"),
    country: "SLO",
    amount: cleanAmount(0),
    toClubId: getClubId("Mechelen"),
    fromClubId: getClubId("Roma"),
    id: 641,
    position: "Defender",
    type: "Free",
    player: "Lovro Golic"
},
{
    date: cleanDate("15-07-2025"),
    country: "POL",
    amount: cleanAmount(0),
    toClubId: getClubId("Darmstadt"),
    fromClubId: getClubId("Wolfsburg"),
    id: 642,
    position: "Forward",
    type: "Free",
    player: "Bartosz Bialek"
},
{
    date: cleanDate("15-07-2025"),
    country: "CZE",
    amount: cleanAmount(0),
    toClubId: getClubId("PSV Eindhoven"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 643,
    position: "Goalkeeper",
    type: "Loan",
    player: "Matej Kovar"
},
{
    date: cleanDate("15-07-2025"),
    country: "FIN",
    amount: cleanAmount(0),
    toClubId: getClubId("Mallorca"),
    fromClubId: getClubId("Chelsea"),
    id: 644,
    position: "Goalkeeper",
    type: "Free",
    player: "Lucas Bergström"
},
{
    date: cleanDate("15-07-2025"),
    country: "CIV",
    amount: cleanAmount(0),
    toClubId: getClubId("Metz"),
    fromClubId: getClubId("FC Zurich"),
    id: 645,
    position: "Midfielder",
    type: "Free",
    player: "Jean-Philippe Gbamin"
},
{
    date: cleanDate("17-07-2025"),
    country: "GEO",
    amount: cleanAmount(0),
    toClubId: getClubId("Metz"),
    fromClubId: getClubId("Kolkheti Poti"),
    id: 646,
    position: "Forward",
    type: "Loan",
    player: "Giorgi Abuashvili"
},
{
    date: cleanDate("14-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Albacete"),
    fromClubId: getClubId("Real Madrid"),
    id: 647,
    position: "Defender",
    type: "Free",
    player: "Jesús Vallejo"
},
{
    date: cleanDate("14-07-2025"),
    country: "SRB",
    amount: cleanAmount(2600000),
    toClubId: getClubId("Aris Saloniki"),
    fromClubId: getClubId("Sassuolo"),
    id: 648,
    position: "Midfielder",
    type: "Paid",
    player: "Uros Racic"
},
{
    date: cleanDate("14-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Carrarese"),
    fromClubId: getClubId("Fiorentina"),
    id: 649,
    position: "Forward",
    type: "Loan",
    player: "Filippo Distefano"
},
{
    date: cleanDate("18-07-2025"),
    country: "ARG",
    amount: cleanAmount(11250000),
    toClubId: getClubId("Como"),
    fromClubId: getClubId("Manchester City"),
    id: 650,
    position: "Midfielder",
    type: "Paid",
    player: "Máximo Perrone"
},
{
    date: cleanDate("18-07-2025"),
    country: "NOR",
    amount: cleanAmount(2170000),
    toClubId: getClubId("Cologne"),
    fromClubId: getClubId("Brøndby"),
    id: 651,
    position: "Defender",
    type: "Paid",
    player: "Sebastian Sebulonsen"
},
{
    date: cleanDate("18-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Napoli"),
    fromClubId: getClubId("Udinese"),
    id: 652,
    position: "Forward",
    type: "Loan",
    player: "Lorenzo Lucca"
},
{
    date: cleanDate("18-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Milan"),
    fromClubId: getClubId("Fiorentina"),
    id: 653,
    position: "Goalkeeper",
    type: "Free",
    player: "Pietro Terracciano"
},
{
    date: cleanDate("18-07-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Pachuca"),
    fromClubId: getClubId("Real Betis"),
    id: 654,
    position: "Midfielder",
    type: "Free",
    player: "William Carvalho"
},
{
    date: cleanDate("18-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Genoa"),
    fromClubId: getClubId("Inter"),
    id: 655,
    position: "Midfielder",
    type: "Loan",
    player: "Valentín Carboni"
},
{
    date: cleanDate("18-07-2025"),
    country: "BIH",
    amount: cleanAmount(0),
    toClubId: getClubId("Borussia Mönchengladbach"),
    fromClubId: getClubId("Hoffenheim"),
    id: 656,
    position: "Forward",
    type: "Loan",
    player: "Haris Tabakovic"
},
{
    date: cleanDate("18-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Atalanta"),
    fromClubId: getClubId("Milan"),
    id: 657,
    position: "Goalkeeper",
    type: "Free",
    player: "Marco Sportiello"
},
{
    date: cleanDate("18-07-2025"),
    country: "ENG",
    amount: cleanAmount(48500000),
    toClubId: getClubId("Arsenal"),
    fromClubId: getClubId("Chelsea"),
    id: 658,
    position: "Winger",
    type: "Paid",
    player: "Noni Madueke"
},
{
    date: cleanDate("18-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cercle Brugge"),
    fromClubId: getClubId("Monaco"),
    id: 659,
    position: "Midfielder",
    type: "Loan",
    player: "Edan Diop"
},
{
    date: cleanDate("18-07-2025"),
    country: "URU",
    amount: cleanAmount(5200000),
    toClubId: getClubId("Real Betis"),
    fromClubId: getClubId("Nacional (Uruguay)"),
    id: 660,
    position: "Forward",
    type: "Paid",
    player: "Gonzalo Petit"
},
{
    date: cleanDate("18-07-2025"),
    country: "AUS",
    amount: cleanAmount(0),
    toClubId: getClubId("Watford"),
    fromClubId: getClubId("Bayern Munich"),
    id: 661,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Nestory Irankunda"
},
{
    date: cleanDate("18-07-2025"),
    country: "NIR",
    amount: cleanAmount(0),
    toClubId: getClubId("Mansfield Town"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 662,
    position: "Midfielder",
    type: "Loan",
    player: "Jamie McDonnell"
},
{
    date: cleanDate("18-07-2025"),
    country: "SRB",
    amount: cleanAmount(1750000),
    toClubId: getClubId("Real Oviedo"),
    fromClubId: getClubId("Red Star Belgrade"),
    id: 663,
    position: "Midfielder",
    type: "Paid",
    player: "Luka Ilic"
},
{
    date: cleanDate("18-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Benfica"),
    fromClubId: getClubId("Aston Villa"),
    id: 664,
    position: "Midfielder",
    type: "Loan",
    player: "Enzo Barrenechea"
},
{
    date: cleanDate("18-07-2025"),
    country: "ENG",
    amount: cleanAmount(12000000),
    toClubId: getClubId("Leeds United"),
    fromClubId: getClubId("Newcastle"),
    id: 665,
    position: "Midfielder",
    type: "Paid",
    player: "Sean Longstaff"
},
{
    date: cleanDate("18-07-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Tondela"),
    fromClubId: getClubId("Wolves"),
    id: 666,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Joe Hodge"
},
{
    date: cleanDate("18-07-2025"),
    country: "ESP",
    amount: cleanAmount(1000000),
    toClubId: getClubId("Lech Poznan"),
    fromClubId: getClubId("Lecce"),
    id: 667,
    position: "Midfielder",
    type: "Paid",
    player: "Pablo Rodríguez"
},
{
    date: cleanDate("19-07-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Braga"),
    fromClubId: getClubId("Paris Saint-Germain"),
    id: 668,
    position: "Midfielder",
    type: "Loan",
    player: "Gabriel Moscardo"
},
{
    date: cleanDate("19-07-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Luton Town"),
    fromClubId: getClubId("Tottenham"),
    id: 669,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Josh Keeley"
},
{
    date: cleanDate("19-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Barnet"),
    fromClubId: getClubId("Manchester United"),
    id: 670,
    position: "Forward",
    type: "Loan",
    player: "Joe Hugill"
},
{
    date: cleanDate("19-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Aberdeen"),
    fromClubId: getClubId("Tottenham"),
    id: 671,
    position: "Defender",
    type: "Loan",
    player: "Alfie Dorrington"
},
{
    date: cleanDate("19-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Valladolid"),
    fromClubId: getClubId("Lorient"),
    id: 672,
    position: "Midfielder",
    type: "Free",
    player: "Julien Ponceau"
},
{
    date: cleanDate("19-07-2025"),
    country: "TUR",
    amount: cleanAmount(0),
    toClubId: getClubId("Eintracht Braunschweig"),
    fromClubId: getClubId("Hoffenheim"),
    id: 673,
    position: "Forward",
    type: "Loan",
    player: "Erencan Yardimci"
},
{
    date: cleanDate("18-07-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Shelbourne"),
    fromClubId: getClubId("Arsenal"),
    id: 674,
    position: "Midfielder",
    type: "Free",
    player: "Jack Henry-Francis"
},
{
    date: cleanDate("18-07-2025"),
    country: "ROU",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Oviedo"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 675,
    position: "Goalkeeper",
    type: "Loan",
    player: "Horatiu Moldovan"
},
{
    date: cleanDate("18-07-2025"),
    country: "BRA",
    amount: cleanAmount(20000000),
    toClubId: getClubId("Botafogo"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 676,
    position: "Midfielder",
    type: "Paid",
    player: "Danilo"
},
{
    date: cleanDate("18-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Monza"),
    fromClubId: getClubId("Fiorentina"),
    id: 677,
    position: "Defender",
    type: "Loan",
    player: "Lorenzo Lucchesi"
},
{
    date: cleanDate("19-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Bologna"),
    fromClubId: getClubId("Toronto FC"),
    id: 678,
    position: "Winger",
    type: "Free",
    player: "Federico Bernardeschi"
},
{
    date: cleanDate("18-07-2025"),
    country: "ROU",
    amount: cleanAmount(1750000),
    toClubId: getClubId("Caykur Rizespor"),
    fromClubId: getClubId("Parma"),
    id: 679,
    position: "Winger",
    type: "Paid",
    player: "Valentin Mihaila"
},
{
    date: cleanDate("19-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cremonese"),
    fromClubId: getClubId("Empoli"),
    id: 680,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Alberto Grassi"
},
{
    date: cleanDate("19-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Sassuolo"),
    fromClubId: getClubId("Brescia"),
    id: 681,
    position: "Winger",
    type: "Free",
    player: "Patrick Nuamah"
},
{
    date: cleanDate("19-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Catanzaro"),
    fromClubId: getClubId("Sassuolo"),
    id: 682,
    position: "Winger",
    type: "Loan",
    player: "Patrick Nuamah"
},
{
    date: cleanDate("20-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("West Ham"),
    fromClubId: getClubId("Southampton"),
    id: 683,
    position: "Defender",
    type: "Free",
    player: "Kyle Walker-Peters"
},
{
    date: cleanDate("20-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Las Palmas"),
    fromClubId: getClubId("Fiorentina"),
    id: 684,
    position: "Midfielder",
    type: "Loan",
    player: "Lorenzo Amatucci"
},
{
    date: cleanDate("20-07-2025"),
    country: "NED",
    amount: cleanAmount(26900000),
    toClubId: getClubId("Napoli"),
    fromClubId: getClubId("Bologna"),
    id: 685,
    position: "Defender",
    type: "Paid",
    player: "Sam Beukema"
},
{
    date: cleanDate("20-07-2025"),
    country: "MAR",
    amount: cleanAmount(20000000),
    toClubId: getClubId("Roma"),
    fromClubId: getClubId("Lens"),
    id: 686,
    position: "Midfielder",
    type: "Paid",
    player: "Neil El Aynaoui"
},
{
    date: cleanDate("20-07-2025"),
    country: "ESP",
    amount: cleanAmount(175000),
    toClubId: getClubId("Real Valladolid"),
    fromClubId: getClubId("Borussia Dortmund"),
    id: 687,
    position: "Defender",
    type: "Paid",
    player: "Guille Bueno"
},
{
    date: cleanDate("21-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Catanzaro"),
    fromClubId: getClubId("Como"),
    id: 688,
    position: "Midfielder",
    type: "Loan",
    player: "Fabio Rispoli"
},
{
    date: cleanDate("20-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Al-Wakrah"),
    fromClubId: getClubId("Rayo Vallecano"),
    id: 689,
    position: "Forward",
    type: "Loan",
    player: "Raúl de Tomás"
},
{
    date: cleanDate("20-07-2025"),
    country: "URU",
    amount: cleanAmount(0),
    toClubId: getClubId("Independiente Santa Fe"),
    fromClubId: getClubId("Bologna"),
    id: 690,
    position: "Defender",
    type: "Loan",
    player: "Joaquín Sosa"
},
{
    date: cleanDate("18-07-2025"),
    country: "SCO",
    amount: cleanAmount(0),
    toClubId: getClubId("Chesterfield"),
    fromClubId: getClubId("Everton"),
    id: 691,
    position: "Midfielder",
    type: "Free",
    player: "Luke Butterfield"
},
{
    date: cleanDate("19-07-2025"),
    country: "SEN",
    amount: cleanAmount(4000000),
    toClubId: getClubId("Aston Villa"),
    fromClubId: getClubId("LASK"),
    id: 692,
    position: "Defender",
    type: "Paid",
    player: "Modou Kéba Cissé"
},
{
    date: cleanDate("15-07-2025"),
    country: "WAL",
    amount: cleanAmount(0),
    toClubId: getClubId("Retired"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 693,
    position: "Goalkeeper",
    type: "Retired",
    player: "Wayne Hennessey"
},
{
    date: cleanDate("04-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Chelsea"),
    fromClubId: getClubId("Preston"),
    id: 694,
    position: "Defender",
    type: "Free",
    player: "Kian Best"
},
{
    date: cleanDate("11-07-2025"),
    country: "WAL",
    amount: cleanAmount(0),
    toClubId: getClubId("Kilmarnock"),
    fromClubId: getClubId("Chelsea"),
    id: 695,
    position: "Goalkeeper",
    type: "Free",
    player: "Eddie Beach"
},
{
    date: cleanDate("04-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Nottingham Forest"),
    fromClubId: getClubId("Chelsea"),
    id: 696,
    position: "Goalkeeper",
    type: "Free",
    player: "Luke Campbell"
},
{
    date: cleanDate("12-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Arsenal"),
    fromClubId: getClubId("Chelsea"),
    id: 697,
    position: "Defender",
    type: "Free",
    player: "Marcell Washington"
},
{
    date: cleanDate("02-05-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Burton Albion"),
    fromClubId: getClubId("Chelsea"),
    id: 698,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Dylan Williams"
},
{
    date: cleanDate("15-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Newport County"),
    fromClubId: getClubId("Manchester United"),
    id: 699,
    position: "Defender",
    type: "Loan",
    player: "Habeeb Ogunneye"
},
{
    date: cleanDate("10-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Lausanne"),
    fromClubId: getClubId("Manchester United"),
    id: 700,
    position: "Forward",
    type: "Free",
    player: "Enzo Kana-Biyik"
},
{
    date: cleanDate("16-07-2025"),
    country: "GAM",
    amount: cleanAmount(0),
    toClubId: getClubId("Nottingham Forest"),
    fromClubId: getClubId("Olympiacos"),
    id: 701,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Lamin Sillah"
},
{
    date: cleanDate("21-07-2025"),
    country: "GUI",
    amount: cleanAmount(0),
    toClubId: getClubId("St Gallen"),
    fromClubId: getClubId("Nice"),
    id: 702,
    position: "Winger",
    type: "Loan",
    player: "Aliou Baldé"
},
{
    date: cleanDate("02-07-2025"),
    country: "NIR",
    amount: cleanAmount(0),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("Coleraine"),
    id: 703,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Matthew Burns"
},
{
    date: cleanDate("09-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("West Ham"),
    fromClubId: getClubId("Concord Rangers"),
    id: 704,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Connor Brooks"
},
{
    date: cleanDate("10-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cagliari"),
    fromClubId: getClubId("Brescia"),
    id: 705,
    position: "Forward",
    type: "Free",
    player: "Gennaro Borrelli"
},
{
    date: cleanDate("18-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Giana Erminio"),
    fromClubId: getClubId("Como"),
    id: 706,
    position: "Defender",
    type: "Loan",
    player: "Tommaso Nucifero"
},
{
    date: cleanDate("17-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Trento"),
    fromClubId: getClubId("Como"),
    id: 707,
    position: "Forward",
    type: "Loan",
    player: "Federico Chinetti"
},
{
    date: cleanDate("12-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Pergolettese"),
    fromClubId: getClubId("Como"),
    id: 708,
    position: "Midfielder",
    type: "Free",
    player: "Marco Tremolada"
},
{
    date: cleanDate("21-07-2025"),
    country: "ISR",
    amount: cleanAmount(0),
    toClubId: getClubId("Hamburg"),
    fromClubId: getClubId("Bayern Munich"),
    id: 709,
    position: "Goalkeeper",
    type: "Loan",
    player: "Daniel Peretz"
},
{
    date: cleanDate("11-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Como"),
    fromClubId: getClubId("Milan"),
    id: 710,
    position: "Forward",
    type: "Free",
    player: "Samuele Pisati"
},
{
    date: cleanDate("05-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Monopoli"),
    fromClubId: getClubId("Como"),
    id: 711,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Diego Ronco"
},
{
    date: cleanDate("04-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Virtus Entella"),
    fromClubId: getClubId("Como"),
    id: 712,
    position: "Forward",
    type: "Loan",
    player: "Tommaso Fumagalli"
},
{
    date: cleanDate("17-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cremonese"),
    fromClubId: getClubId("Milan"),
    id: 713,
    position: "Goalkeeper",
    type: "Free",
    player: "Lapo Nava"
},
{
    date: cleanDate("15-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Giana Erminio"),
    fromClubId: getClubId("Cremonese"),
    id: 714,
    position: "Defender",
    type: "Loan",
    player: "Tommaso Duca"
},
{
    date: cleanDate("09-07-2025"),
    country: "URU",
    amount: cleanAmount(0),
    toClubId: getClubId("Mantova"),
    fromClubId: getClubId("Cremonese"),
    id: 715,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "César Falletti"
},
{
    date: cleanDate("26-06-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Crotone"),
    fromClubId: getClubId("Cremonese"),
    id: 716,
    position: "Winger",
    type: "Free",
    player: "Marco Zunno"
},
{
    date: cleanDate("21-07-2025"),
    country: "UKR",
    amount: cleanAmount(0),
    toClubId: getClubId("Villarreal"),
    fromClubId: getClubId("Karpaty Lviv"),
    id: 717,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Yakiv Kinareykin"
},
{
    date: cleanDate("21-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Alverca"),
    fromClubId: getClubId("Wolves"),
    id: 718,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Bastien Meupiyou"
},
{
    date: cleanDate("15-07-2025"),
    country: "SUI",
    amount: cleanAmount(300000),
    toClubId: getClubId("Fiorentina"),
    fromClubId: getClubId("Barcelona"),
    id: 719,
    position: "Defender",
    type: "Paid",
    player: "Eman Kospo"
},
{
    date: cleanDate("21-07-2025"),
    country: "ITA",
    amount: cleanAmount(56300000),
    toClubId: getClubId("Al-Qadsiah"),
    fromClubId: getClubId("Atalanta"),
    id: 720,
    position: "Forward",
    type: "Paid",
    player: "Mateo Retegui"
},
{
    date: cleanDate("21-07-2025"),
    country: "CMR",
    amount: cleanAmount(71000000),
    toClubId: getClubId("Manchester United"),
    fromClubId: getClubId("Brentford"),
    id: 721,
    position: "Forward",
    type: "Paid",
    player: "Bryan Mbeumo"
},
{
    date: cleanDate("21-07-2025"),
    country: "POL",
    amount: cleanAmount(0),
    toClubId: getClubId("Hertha BSC"),
    fromClubId: getClubId("Werder Bremen"),
    id: 722,
    position: "Forward",
    type: "Loan",
    player: "Dawid Kownacki"
},
{
    date: cleanDate("21-07-2025"),
    country: "FRA",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Al-Diriyah"),
    fromClubId: getClubId("Nice"),
    id: 723,
    position: "Forward",
    type: "Paid",
    player: "Gaëtan Laborde"
},
{
    date: cleanDate("21-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Virtus Entella"),
    fromClubId: getClubId("Sassuolo"),
    id: 724,
    position: "Forward",
    type: "Loan",
    player: "Flavio Russo"
},
{
    date: cleanDate("21-07-2025"),
    country: "AUT",
    amount: cleanAmount(0),
    toClubId: getClubId("Red Star Belgrade"),
    fromClubId: getClubId("Inter"),
    id: 725,
    position: "Forward",
    type: "Free",
    player: "Marko Arnautovic"
},
{
    date: cleanDate("21-07-2025"),
    country: "NED",
    amount: cleanAmount(0),
    toClubId: getClubId("Aris Saloniki"),
    fromClubId: getClubId("Girona"),
    id: 726,
    position: "Midfielder",
    type: "Loan",
    player: "Gabriel Misehouy"
},
{
    date: cleanDate("22-07-2025"),
    country: "GER",
    amount: cleanAmount(17000000),
    toClubId: getClubId("Leeds United"),
    fromClubId: getClubId("Hoffenheim"),
    id: 727,
    position: "Midfielder",
    type: "Paid",
    player: "Anton Stach"
},
{
    date: cleanDate("22-07-2025"),
    country: "NED",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Hoffenheim"),
    fromClubId: getClubId("Stoke City"),
    id: 728,
    position: "Midfielder",
    type: "Paid",
    player: "Wouter Burger"
},
{
    date: cleanDate("22-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Verona"),
    fromClubId: getClubId("Fiorentina"),
    id: 729,
    position: "Defender",
    type: "Loan",
    player: "Nicolás Valentini"
},
{
    date: cleanDate("22-07-2025"),
    country: "NGR",
    amount: cleanAmount(0),
    toClubId: getClubId("Pisa"),
    fromClubId: getClubId("Inter"),
    id: 730,
    position: "Midfielder",
    type: "Loan",
    player: "Ebenezer Akinsanmiro"
},
{
    date: cleanDate("22-07-2025"),
    country: "POR",
    amount: cleanAmount(27800000),
    toClubId: getClubId("Juventus"),
    fromClubId: getClubId("Porto"),
    id: 731,
    position: "Winger",
    type: "Paid",
    player: "Francisco Conceição"
},
{
    date: cleanDate("23-07-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Roma"),
    fromClubId: getClubId("Brighton"),
    id: 732,
    position: "Forward",
    type: "Loan",
    player: "Evan Ferguson"
},
{
    date: cleanDate("22-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Sheffield United"),
    fromClubId: getClubId("Aston Villa"),
    id: 733,
    position: "Forward",
    type: "Loan",
    player: "Louie Barry"
},
{
    date: cleanDate("22-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Bologna"),
    fromClubId: getClubId("Milan"),
    id: 734,
    position: "Midfielder",
    type: "Loan",
    player: "Tommaso Pobega"
},
{
    date: cleanDate("21-07-2025"),
    country: "FRA",
    amount: cleanAmount(11300000),
    toClubId: getClubId("Rennes"),
    fromClubId: getClubId("Marseille"),
    id: 735,
    position: "Defender",
    type: "Paid",
    player: "Quentin Merlin"
},
{
    date: cleanDate("22-07-2025"),
    country: "ESP",
    amount: cleanAmount(700000),
    toClubId: getClubId("Leganés"),
    fromClubId: getClubId("Real Madrid"),
    id: 736,
    position: "Defender",
    type: "Paid",
    player: "Marvel"
},
{
    date: cleanDate("23-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Barcelona"),
    fromClubId: getClubId("Manchester United"),
    id: 737,
    position: "Forward",
    type: "Loan",
    player: "Marcus Rashford"
},
{
    date: cleanDate("22-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Betis"),
    fromClubId: getClubId("Toluca"),
    id: 738,
    position: "Goalkeeper",
    type: "Free",
    player: "Pau López"
},
{
    date: cleanDate("22-07-2025"),
    country: "ZIM",
    amount: cleanAmount(0),
    toClubId: getClubId("Aris Saloniki"),
    fromClubId: getClubId("Nantes"),
    id: 739,
    position: "Forward",
    type: "Free",
    player: "Tino Kadewere"
},
{
    date: cleanDate("23-07-2025"),
    country: "FRA",
    amount: cleanAmount(79000000),
    toClubId: getClubId("Liverpool"),
    fromClubId: getClubId("Eintracht Frankfurt"),
    id: 740,
    position: "Forward",
    type: "Paid",
    player: "Hugo Ekitiké"
},
{
    date: cleanDate("22-07-2025"),
    country: "MLI",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Havre"),
    fromClubId: getClubId("Red Star"),
    id: 741,
    position: "Defender",
    type: "Free",
    player: "Fodé Doucouré"
},
{
    date: cleanDate("22-07-2025"),
    country: "ESP",
    amount: cleanAmount(10400000),
    toClubId: getClubId("Athletic Club"),
    fromClubId: getClubId("Osasuna"),
    id: 742,
    position: "Defender",
    type: "Paid",
    player: "Jesús Areso"
},
{
    date: cleanDate("22-07-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Alverca"),
    fromClubId: getClubId("Udinese"),
    id: 743,
    position: "Defender",
    type: "Loan",
    player: "Gonçalo Esteves"
},
{
    date: cleanDate("22-07-2025"),
    country: "URU",
    amount: cleanAmount(1730000),
    toClubId: getClubId("Elche"),
    fromClubId: getClubId("Real Madrid"),
    id: 744,
    position: "Forward",
    type: "Paid",
    player: "Álvaro Rodríguez"
},
{
    date: cleanDate("22-07-2025"),
    country: "KOR",
    amount: cleanAmount(0),
    toClubId: getClubId("Kaiserslautern"),
    fromClubId: getClubId("Brentford"),
    id: 745,
    position: "Defender",
    type: "Loan",
    player: "Kim Ji-soo"
},
{
    date: cleanDate("23-07-2025"),
    country: "FRA",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Krasnodar"),
    fromClubId: getClubId("Auxerre"),
    id: 746,
    position: "Midfielder",
    type: "Paid",
    player: "Gaëtan Perrin"
},
{
    date: cleanDate("23-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Mantova"),
    fromClubId: getClubId("Fiorentina"),
    id: 747,
    position: "Forward",
    type: "Loan",
    player: "Maat Daniel Caprini"
},
{
    date: cleanDate("24-07-2025"),
    country: "ECU",
    amount: cleanAmount(17500000),
    toClubId: getClubId("Milan"),
    fromClubId: getClubId("Brighton"),
    id: 748,
    position: "Defender",
    type: "Paid",
    player: "Pervis Estupinan"
},
{
    date: cleanDate("24-07-2025"),
    country: "GHA",
    amount: cleanAmount(0),
    toClubId: getClubId("Norwich City"),
    fromClubId: getClubId("Crystal Palace"),
    id: 749,
    position: "Midfielder",
    type: "Free",
    player: "Jeffrey Schlupp"
},
{
    date: cleanDate("24-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Union Berlin"),
    fromClubId: getClubId("Hoffenheim"),
    id: 750,
    position: "Defender",
    type: "Loan",
    player: "Stanley Nsoki"
},
{
    date: cleanDate("24-07-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Eibar"),
    fromClubId: getClubId("Udinese"),
    id: 751,
    position: "Defender",
    type: "Loan",
    player: "Leonardo Buta"
},
{
    date: cleanDate("24-07-2025"),
    country: "NED",
    amount: cleanAmount(0),
    toClubId: getClubId("Union St-Gilloise"),
    fromClubId: getClubId("Brighton"),
    id: 752,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Kjell Scherpen"
},
{
    date: cleanDate("24-07-2025"),
    country: "COL",
    amount: cleanAmount(15000000),
    toClubId: getClubId("Wolves"),
    fromClubId: getClubId("Fluminense"),
    id: 753,
    position: "Winger",
    type: "Paid",
    player: "Jhon Arias"
},
{
    date: cleanDate("24-07-2025"),
    country: "KOR",
    amount: cleanAmount(0),
    toClubId: getClubId("Newcastle"),
    fromClubId: getClubId("Suwon Bluewings"),
    id: 754,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Park Seung-soo"
},
{
    date: cleanDate("22-07-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Alavés"),
    fromClubId: getClubId("Fortaleza"),
    id: 755,
    position: "Midfielder",
    type: "Loan",
    player: "Calebe Gonçalves"
},
{
    date: cleanDate("24-07-2025"),
    country: "BUR",
    amount: cleanAmount(1000000),
    toClubId: getClubId("Lorient"),
    fromClubId: getClubId("Ajaccio"),
    id: 756,
    position: "Defender",
    type: "Paid",
    player: "Arsène Kouassi"
},
{
    date: cleanDate("24-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Juve Stabia"),
    fromClubId: getClubId("Inter"),
    id: 757,
    position: "Forward",
    type: "Loan",
    player: "Giacomo De Pieri"
},
{
    date: cleanDate("08-07-2025"),
    country: "CHI",
    amount: cleanAmount(0),
    toClubId: getClubId("CF Montréal"),
    fromClubId: getClubId("Bologna"),
    id: 758,
    position: "Goalkeeper",
    type: "Loan",
    player: "Thomas Gillier"
},
{
    date: cleanDate("24-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Salford City"),
    fromClubId: getClubId("Sunderland"),
    id: 759,
    position: "Goalkeeper",
    type: "Loan",
    player: "Matty Young"
},
{
    date: cleanDate("24-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cagliari"),
    fromClubId: getClubId("Napoli"),
    id: 760,
    position: "Midfielder",
    type: "Loan",
    player: "Michael Folorunsho"
},
{
    date: cleanDate("24-07-2025"),
    country: "MLI",
    amount: cleanAmount(0),
    toClubId: getClubId("Metz"),
    fromClubId: getClubId("Wolves"),
    id: 761,
    position: "Midfielder",
    type: "Loan",
    player: "Boubacar Traoré"
},
{
    date: cleanDate("24-07-2025"),
    country: "SEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Sion"),
    fromClubId: getClubId("Nantes"),
    id: 762,
    position: "Midfielder",
    type: "Loan",
    player: "Lamine Diack"
},
{
    date: cleanDate("24-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Pescara"),
    fromClubId: getClubId("Roma"),
    id: 763,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Leonardo Graziani"
},
{
    date: cleanDate("23-07-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Wolfsburg"),
    fromClubId: getClubId("Napoli"),
    id: 764,
    position: "Winger",
    type: "Loan",
    player: "Jesper Lindstrøm"
},
{
    date: cleanDate("23-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Flamengo"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 765,
    position: "Midfielder",
    type: "Free",
    player: "Saúl Ñiguez"
},
{
    date: cleanDate("23-07-2025"),
    country: "BEL",
    amount: cleanAmount(8700000),
    toClubId: getClubId("Werder Bremen"),
    fromClubId: getClubId("Juventus"),
    id: 766,
    position: "Winger",
    type: "Paid",
    player: "Samuel Mbangula"
},
{
    date: cleanDate("23-07-2025"),
    country: "CMR",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Al-Duhail"),
    fromClubId: getClubId("Nantes"),
    id: 767,
    position: "Defender",
    type: "Paid",
    player: "Jean-Charles Castelletto"
},
{
    date: cleanDate("23-07-2025"),
    country: "ESP",
    amount: cleanAmount(14000000),
    toClubId: getClubId("Atlético Madrid"),
    fromClubId: getClubId("Almería"),
    id: 768,
    position: "Defender",
    type: "Paid",
    player: "Marc Pubill"
},
{
    date: cleanDate("23-07-2025"),
    country: "BRA",
    amount: cleanAmount(17400000),
    toClubId: getClubId("Paris FC"),
    fromClubId: getClubId("Porto"),
    id: 769,
    position: "Defender",
    type: "Paid",
    player: "Otávio"
},
{
    date: cleanDate("23-07-2025"),
    country: "NGR",
    amount: cleanAmount(740000),
    toClubId: getClubId("Nantes"),
    fromClubId: getClubId("Colorado Rapids"),
    id: 770,
    position: "Defender",
    type: "Paid",
    player: "Chidozie Awaziem"
},
{
    date: cleanDate("23-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Austria Vienna"),
    fromClubId: getClubId("St Pauli"),
    id: 771,
    position: "Forward",
    type: "Free",
    player: "Johannes Eggestein"
},
{
    date: cleanDate("24-07-2025"),
    country: "ESP",
    amount: cleanAmount(13000000),
    toClubId: getClubId("Arsenal"),
    fromClubId: getClubId("Valencia"),
    id: 772,
    position: "Defender",
    type: "Paid",
    player: "Cristhian Mosquera"
},
{
    date: cleanDate("23-07-2025"),
    country: "KOR",
    amount: cleanAmount(1300000),
    toClubId: getClubId("Arouca"),
    fromClubId: getClubId("Bayern Munich"),
    id: 773,
    position: "Midfielder",
    type: "Paid",
    player: "Lee Hyun-ju"
},
{
    date: cleanDate("24-07-2025"),
    country: "SVK",
    amount: cleanAmount(26100000),
    toClubId: getClubId("Atlético Madrid"),
    fromClubId: getClubId("Feyenoord"),
    id: 774,
    position: "Defender",
    type: "Paid",
    player: "David Hancko"
},
{
    date: cleanDate("24-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Verona"),
    fromClubId: getClubId("Getafe"),
    id: 775,
    position: "Midfielder",
    type: "Free",
    player: "Yellu Santiago"
},
{
    date: cleanDate("24-07-2025"),
    country: "SRB",
    amount: cleanAmount(8700000),
    toClubId: getClubId("Club Brugge"),
    fromClubId: getClubId("Inter"),
    id: 776,
    position: "Midfielder",
    type: "Paid",
    player: "Aleksandar Stankovic"
},
{
    date: cleanDate("24-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Oviedo"),
    fromClubId: getClubId("Villarreal"),
    id: 777,
    position: "Forward",
    type: "Loan",
    player: "Álex Forés"
},
{
    date: cleanDate("24-07-2025"),
    country: "BEL",
    amount: cleanAmount(3900000),
    toClubId: getClubId("Lille"),
    fromClubId: getClubId("Standard Liège"),
    id: 778,
    position: "Defender",
    type: "Paid",
    player: "Nathan Ngoy"
},
{
    date: cleanDate("24-07-2025"),
    country: "POR",
    amount: cleanAmount(11000000),
    toClubId: getClubId("Juventus"),
    fromClubId: getClubId("Porto"),
    id: 779,
    position: "Defender",
    type: "Paid",
    player: "João Mário"
},
{
    date: cleanDate("24-07-2025"),
    country: "POR",
    amount: cleanAmount(13100000),
    toClubId: getClubId("Porto"),
    fromClubId: getClubId("Juventus"),
    id: 780,
    position: "Defender",
    type: "Paid",
    player: "Alberto Costa"
},
{
    date: cleanDate("24-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Wrexham"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 781,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Lewis O'Brien"
},
{
    date: cleanDate("24-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Coventry City"),
    fromClubId: getClubId("Brighton"),
    id: 782,
    position: "Goalkeeper",
    type: "Loan",
    player: "Carl Rushworth"
},
{
    date: cleanDate("24-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Bradford City"),
    fromClubId: getClubId("Everton"),
    id: 783,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Jenson Metcalfe"
},
{
    date: cleanDate("24-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Alavés"),
    fromClubId: getClubId("Getafe"),
    id: 784,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Carles Aleñá"
},
{
    date: cleanDate("24-07-2025"),
    country: "BEL",
    amount: cleanAmount(0),
    toClubId: getClubId("Torino"),
    fromClubId: getClubId("Napoli"),
    id: 785,
    position: "Winger",
    type: "Loan",
    player: "Cyril Ngonge"
},
{
    date: cleanDate("22-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Luton Town"),
    fromClubId: getClubId("West Ham"),
    id: 786,
    position: "Forward",
    type: "Loan",
    player: "Gideon Kodua"
},
{
    date: cleanDate("22-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Shrewsbury Town"),
    fromClubId: getClubId("Manchester United"),
    id: 787,
    position: "Goalkeeper",
    type: "Loan",
    player: "Elyh Harrison"
},
{
    date: cleanDate("22-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Rotherham"),
    fromClubId: getClubId("Wolves"),
    id: 788,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Marvin Kaleta"
},
{
    date: cleanDate("22-07-2025"),
    country: "USA",
    amount: cleanAmount(0),
    toClubId: getClubId("Watford"),
    fromClubId: getClubId("Chelsea"),
    id: 789,
    position: "Defender",
    type: "Loan",
    player: "Caleb Wiley"
},
{
    date: cleanDate("21-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Barnsley"),
    fromClubId: getClubId("Brighton"),
    id: 790,
    position: "Winger",
    type: "Loan",
    player: "Caylan Vickers"
},
{
    date: cleanDate("25-07-2025"),
    country: "WAL",
    amount: cleanAmount(0),
    toClubId: getClubId("Derby County"),
    fromClubId: getClubId("Liverpool"),
    id: 791,
    position: "Defender",
    type: "Loan",
    player: "Owen Beck"
},
{
    date: cleanDate("25-07-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Birmingham City"),
    fromClubId: getClubId("Brighton"),
    id: 792,
    position: "Defender",
    type: "Loan",
    player: "Eiran Cashin"
},
{
    date: cleanDate("24-07-2025"),
    country: "SEN",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Norwich City"),
    fromClubId: getClubId("Metz"),
    id: 793,
    position: "Winger",
    type: "Paid",
    player: "Papa Amadou Diallo"
},
{
    date: cleanDate("25-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Espanyol"),
    fromClubId: getClubId("Blackburn Rovers"),
    id: 794,
    position: "Winger",
    type: "Free",
    player: "Tyrhys Dolan"
},
{
    date: cleanDate("25-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Verona"),
    fromClubId: getClubId("Celta Vigo"),
    id: 795,
    position: "Defender",
    type: "Loan",
    player: "Unai Núñez"
},
{
    date: cleanDate("25-07-2025"),
    country: "GHA",
    amount: cleanAmount(2200000),
    toClubId: getClubId("Nice"),
    fromClubId: getClubId("IFK Norrköping"),
    id: 796,
    position: "Defender",
    type: "Paid",
    player: "Kojo Peprah Oppong"
},
{
    date: cleanDate("25-07-2025"),
    country: "NIR",
    amount: cleanAmount(0),
    toClubId: getClubId("Northampton"),
    fromClubId: getClubId("West Ham"),
    id: 797,
    position: "Defender",
    type: "Loan",
    player: "Michael Forbes"
},
{
    date: cleanDate("25-07-2025"),
    country: "KOR",
    amount: cleanAmount(0),
    toClubId: getClubId("Nantes"),
    fromClubId: getClubId("Celtic"),
    id: 798,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Kwon Hyeok-kyu"
},
{
    date: cleanDate("25-07-2025"),
    country: "FRA",
    amount: cleanAmount(500000),
    toClubId: getClubId("Al-Arabi"),
    fromClubId: getClubId("Lyon"),
    id: 799,
    position: "Midfielder",
    type: "Paid",
    player: "Jordan Veretout"
},
{
    date: cleanDate("25-07-2025"),
    country: "SEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Lorient"),
    fromClubId: getClubId("Pau"),
    id: 800,
    position: "Goalkeeper",
    type: "Free",
    player: "Bingourou Kamara"
},
{
    date: cleanDate("25-07-2025"),
    country: "ITA",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Cremonese"),
    fromClubId: getClubId("Empoli"),
    id: 801,
    position: "Defender",
    type: "Paid",
    player: "Giuseppe Pezzella"
},
{
    date: cleanDate("24-07-2025"),
    country: "SUI",
    amount: cleanAmount(0),
    toClubId: getClubId("Pisa"),
    fromClubId: getClubId("FC Zurich"),
    id: 802,
    position: "Defender",
    type: "Loan",
    player: "Daniel Denoon"
},
{
    date: cleanDate("25-07-2025"),
    country: "NED",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Lyon"),
    fromClubId: getClubId("Casa Pia"),
    id: 803,
    position: "Defender",
    type: "Paid",
    player: "Ruben Kluivert"
},
{
    date: cleanDate("25-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Empoli"),
    fromClubId: getClubId("Como"),
    id: 804,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Marco Curto"
},
{
    date: cleanDate("25-07-2025"),
    country: "BEL",
    amount: cleanAmount(1700000),
    toClubId: getClubId("KAA Gent"),
    fromClubId: getClubId("Mallorca"),
    id: 805,
    position: "Defender",
    type: "Paid",
    player: "Siebe Van der Heyden"
},
{
    date: cleanDate("25-07-2025"),
    country: "SEN",
    amount: cleanAmount(0),
    toClubId: getClubId("La Louvière"),
    fromClubId: getClubId("Metz"),
    id: 806,
    position: "Forward",
    type: "Loan",
    player: "Pape Moussa Fall"
},
{
    date: cleanDate("25-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Atlanta United"),
    fromClubId: getClubId("Getafe"),
    id: 807,
    position: "Defender",
    type: "Loan",
    player: "Juan Berrocal"
},
{
    date: cleanDate("25-07-2025"),
    country: "ESP",
    amount: cleanAmount(10500000),
    toClubId: getClubId("Braga"),
    fromClubId: getClubId("Barcelona"),
    id: 808,
    position: "Forward",
    type: "Paid",
    player: "Pau Víctor"
},
{
    date: cleanDate("25-07-2025"),
    country: "POL",
    amount: cleanAmount(0),
    toClubId: getClubId("Sassuolo"),
    fromClubId: getClubId("Torino"),
    id: 809,
    position: "Defender",
    type: "Loan",
    player: "Sebastian Walukiewicz"
},
{
    date: cleanDate("25-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Millwall"),
    fromClubId: getClubId("Fulham"),
    id: 810,
    position: "Goalkeeper",
    type: "Loan",
    player: "Steven Benda"
},
{
    date: cleanDate("25-07-2025"),
    country: "WAL",
    amount: cleanAmount(0),
    toClubId: getClubId("Oxford United"),
    fromClubId: getClubId("Fulham"),
    id: 811,
    position: "Midfielder",
    type: "Loan",
    player: "Luke Harris"
},
{
    date: cleanDate("26-07-2025"),
    country: "JPN",
    amount: cleanAmount(6120000),
    toClubId: getClubId("Borussia Mönchengladbach"),
    fromClubId: getClubId("Holstein Kiel"),
    id: 812,
    position: "Forward",
    type: "Paid",
    player: "Shuto Machino"
},
{
    date: cleanDate("26-07-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Leyton Orient"),
    fromClubId: getClubId("Crystal Palace"),
    id: 813,
    position: "Defender",
    type: "Loan",
    player: "Tayo Adaramola"
},
{
    date: cleanDate("26-07-2025"),
    country: "COL",
    amount: cleanAmount(0),
    toClubId: getClubId("FC Zurich"),
    fromClubId: getClubId("Stuttgart"),
    id: 814,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Juan José Perea"
},
{
    date: cleanDate("26-07-2025"),
    country: "ARG",
    amount: cleanAmount(4800000),
    toClubId: getClubId("Real Betis"),
    fromClubId: getClubId("Vélez Sarsfield"),
    id: 815,
    position: "Defender",
    type: "Paid",
    player: "Valentín Gómez"
},
{
    date: cleanDate("26-07-2025"),
    country: "FRA",
    amount: cleanAmount(430000),
    toClubId: getClubId("Fulham"),
    fromClubId: getClubId("Montpellier"),
    id: 816,
    position: "Goalkeeper",
    type: "Paid",
    player: "Benjamin Lecomte"
},
{
    date: cleanDate("26-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Empoli"),
    fromClubId: getClubId("Juventus"),
    id: 817,
    position: "Defender",
    type: "Loan",
    player: "Brando Moruzzi"
},
{
    date: cleanDate("26-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Arouca"),
    fromClubId: getClubId("Real Betis"),
    id: 818,
    position: "Midfielder",
    type: "Loan",
    player: "Mateo Flores"
},
{
    date: cleanDate("25-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Inter Miami"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 819,
    position: "Midfielder",
    type: "Loan",
    player: "Rodrigo de Paul"
},
{
    date: cleanDate("03-07-2025"),
    country: "NGR",
    amount: cleanAmount(4720000),
    toClubId: getClubId("Lazio"),
    fromClubId: getClubId("Hatayspor"),
    id: 820,
    position: "Midfielder",
    type: "Paid",
    player: "Fisayo Dele-Bashiru"
},
{
    date: cleanDate("01-07-2025"),
    country: "ITA",
    amount: cleanAmount(5240000),
    toClubId: getClubId("Cagliari"),
    fromClubId: getClubId("Napoli"),
    id: 821,
    position: "Midfielder",
    type: "Paid",
    player: "Gianluca Gaetano"
},
{
    date: cleanDate("26-07-2025"),
    country: "SWE",
    amount: cleanAmount(64000000),
    toClubId: getClubId("Arsenal"),
    fromClubId: getClubId("Sporting CP"),
    id: 822,
    position: "Forward",
    type: "Paid",
    player: "Viktor Gyökeres"
},
{
    date: cleanDate("26-07-2025"),
    country: "BRA",
    amount: cleanAmount(13000000),
    toClubId: getClubId("Leeds United"),
    fromClubId: getClubId("Lyon"),
    id: 823,
    position: "Goalkeeper",
    type: "Paid",
    player: "Lucas Perri"
},
{
    date: cleanDate("26-07-2025"),
    country: "CZE",
    amount: cleanAmount(0),
    toClubId: getClubId("Antalyaspor"),
    fromClubId: getClubId("Borussia Mönchengladbach"),
    id: 824,
    position: "Forward",
    type: "Loan",
    player: "Tomas Cvancara"
},
{
    date: cleanDate("26-07-2025"),
    country: "CRO",
    amount: cleanAmount(0),
    toClubId: getClubId("Osijek"),
    fromClubId: getClubId("Augsburg"),
    id: 825,
    position: "Defender",
    type: "Loan",
    player: "David Colina"
},
{
    date: cleanDate("27-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("FC Zurich"),
    fromClubId: getClubId("Pisa"),
    id: 826,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Lisandru Tramoni"
},
{
    date: cleanDate("27-07-2025"),
    country: "INA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cremonese"),
    fromClubId: getClubId("Como"),
    id: 827,
    position: "Goalkeeper",
    type: "Loan",
    player: "Emil Audero"
},
{
    date: cleanDate("27-07-2025"),
    country: "URU",
    amount: cleanAmount(4400000),
    toClubId: getClubId("Torino"),
    fromClubId: getClubId("Sporting CP"),
    id: 828,
    position: "Goalkeeper",
    type: "Paid",
    player: "Franco Israel"
},
{
    date: cleanDate("26-07-2025"),
    country: "BRA",
    amount: cleanAmount(7800000),
    toClubId: getClubId("Flamengo"),
    fromClubId: getClubId("Milan"),
    id: 829,
    position: "Defender",
    type: "Paid",
    player: "Emerson Royal"
},
{
    date: cleanDate("27-07-2025"),
    country: "SRB",
    amount: cleanAmount(0),
    toClubId: getClubId("Napoli"),
    fromClubId: getClubId("Torino"),
    id: 830,
    position: "Goalkeeper",
    type: "Loan",
    player: "Vanja Milinkovic-Savic"
},
{
    date: cleanDate("27-07-2025"),
    country: "ARG",
    amount: cleanAmount(14400000),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Alavés"),
    id: 831,
    position: "Forward",
    type: "Paid",
    player: "Joaquín Panichelli"
},
{
    date: cleanDate("27-07-2025"),
    country: "ESP",
    amount: cleanAmount(2600000),
    toClubId: getClubId("Stuttgart"),
    fromClubId: getClubId("Real Madrid"),
    id: 832,
    position: "Midfielder",
    type: "Paid",
    player: "Chema Andrés"
},
{
    date: cleanDate("25-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Châteauroux"),
    fromClubId: getClubId("Paris Saint-Germain"),
    id: 833,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Lucas Lavallée"
},
{
    date: cleanDate("23-07-2025"),
    country: "GUI",
    amount: cleanAmount(0),
    toClubId: getClubId("Brommapojkarna"),
    fromClubId: getClubId("Nice"),
    id: 834,
    position: "Midfielder",
    type: "Loan",
    player: "Issiaga Camara"
},
{
    date: cleanDate("18-07-2025"),
    country: "MAR",
    amount: cleanAmount(0),
    toClubId: getClubId("Nantes"),
    fromClubId: getClubId("Apoel Nicosia"),
    id: 835,
    position: "Forward",
    type: "Free",
    player: "Youssef el-Arabi"
},
{
    date: cleanDate("27-07-2025"),
    country: "ITA",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Palermo"),
    fromClubId: getClubId("Genoa"),
    id: 836,
    position: "Defender",
    type: "Paid",
    player: "Mattia Bani"
},
{
    date: cleanDate("28-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Al-Arabi"),
    fromClubId: getClubId("Villarreal"),
    id: 837,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Gerard Hernández"
},
{
    date: cleanDate("28-07-2025"),
    country: "BEL",
    amount: cleanAmount(0),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Chelsea"),
    id: 838,
    position: "Goalkeeper",
    type: "Loan",
    player: "Mike Penders"
},
{
    date: cleanDate("28-07-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Lecce"),
    fromClubId: getClubId("Kilmarnock"),
    id: 839,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Corrie Ndaba"
},
{
    date: cleanDate("23-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Marseille"),
    fromClubId: getClubId("Montpellier"),
    id: 840,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Pladi N'Zinga Pambani"
},
{
    date: cleanDate("28-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Giana Erminio"),
    fromClubId: getClubId("Cremonese"),
    id: 841,
    position: "Forward",
    type: "Loan",
    player: "Giacomo Gabbiani"
},
{
    date: cleanDate("28-07-2025"),
    country: "ESP",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Valencia"),
    fromClubId: getClubId("Mallorca"),
    id: 842,
    position: "Defender",
    type: "Paid",
    player: "José Copete"
},
{
    date: cleanDate("22-07-2025"),
    country: "POR",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Lyon"),
    fromClubId: getClubId("Sporting CP"),
    id: 843,
    position: "Winger",
    type: "Paid",
    player: "Afonso Moreira"
},
{
    date: cleanDate("09-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Young Boys"),
    fromClubId: getClubId("Lille"),
    id: 844,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Alan Virginius"
},
{
    date: cleanDate("17-07-2025"),
    country: "AUT",
    amount: cleanAmount(6900000),
    toClubId: getClubId("Lens"),
    fromClubId: getClubId("Red Bull Salzburg"),
    id: 845,
    position: "Defender",
    type: "Paid",
    player: "Samson Baidoo"
},
{
    date: cleanDate("23-07-2025"),
    country: "JPN",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Havre"),
    fromClubId: getClubId("Grasshopper"),
    id: 846,
    position: "Defender",
    type: "Free",
    player: "Ayumu Seko"
},
{
    date: cleanDate("01-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Ethnikos Achna"),
    fromClubId: getClubId("Le Havre"),
    id: 847,
    position: "Midfielder",
    type: "Free",
    player: "Aloïs Confais"
},
{
    date: cleanDate("23-07-2025"),
    country: "CIV",
    amount: cleanAmount(0),
    toClubId: getClubId("Dunkerque"),
    fromClubId: getClubId("Auxerre"),
    id: 848,
    position: "Winger",
    type: "Loan",
    player: "Aristide Zossou"
},
{
    date: cleanDate("15-07-2025"),
    country: "FRA",
    amount: cleanAmount(2600000),
    toClubId: getClubId("Augsburg"),
    fromClubId: getClubId("Burnley"),
    id: 849,
    position: "Midfielder",
    type: "Paid",
    player: "Han-Noah Massengo"
},
{
    date: cleanDate("09-07-2025"),
    country: "GUI",
    amount: cleanAmount(0),
    toClubId: getClubId("RWDM Brussels"),
    fromClubId: getClubId("Auxerre"),
    id: 850,
    position: "Defender",
    type: "Free",
    player: "Madiou Keita"
},
{
    date: cleanDate("28-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Al-Gharafa"),
    fromClubId: getClubId("Athletic Club"),
    id: 851,
    position: "Forward",
    type: "Loan",
    player: "Álvaro Djaló"
},
{
    date: cleanDate("28-07-2025"),
    country: "CZE",
    amount: cleanAmount(0),
    toClubId: getClubId("Bristol City"),
    fromClubId: getClubId("Manchester United"),
    id: 852,
    position: "Goalkeeper",
    type: "Loan",
    player: "Radek Vitek"
},
{
    date: cleanDate("28-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Heidenheim"),
    fromClubId: getClubId("Borussia Dortmund"),
    id: 853,
    position: "Goalkeeper",
    type: "Loan",
    player: "Diant Ramaj"
},
{
    date: cleanDate("11-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Bochum"),
    fromClubId: getClubId("Wolfsburg"),
    id: 854,
    position: "Forward",
    type: "Free",
    player: "Jonathan Akaegbobi"
},
{
    date: cleanDate("10-07-2025"),
    country: "CRO",
    amount: cleanAmount(0),
    toClubId: getClubId("Venezia"),
    fromClubId: getClubId("Wolfsburg"),
    id: 855,
    position: "Defender",
    type: "Loan",
    player: "Bartol Franjic"
},
{
    date: cleanDate("30-06-2025"),
    country: "GER",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Wolfsburg"),
    fromClubId: getClubId("Paderborn"),
    id: 856,
    position: "Winger",
    type: "Paid",
    player: "Aaron Zehnter"
},
{
    date: cleanDate("28-07-2025"),
    country: "BRA",
    amount: cleanAmount(21700000),
    toClubId: getClubId("Roma"),
    fromClubId: getClubId("Flamengo"),
    id: 857,
    position: "Defender",
    type: "Paid",
    player: "Wesley França"
},
{
    date: cleanDate("28-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Genoa"),
    fromClubId: getClubId("Milan"),
    id: 858,
    position: "Forward",
    type: "Loan",
    player: "Lorenzo Colombo"
},
{
    date: cleanDate("28-07-2025"),
    country: "GAM",
    amount: cleanAmount(0),
    toClubId: getClubId("Sassuolo"),
    fromClubId: getClubId("Como"),
    id: 859,
    position: "Winger",
    type: "Loan",
    player: "Alieu Fadera"
},
{
    date: cleanDate("30-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Magdeburg"),
    fromClubId: getClubId("Stuttgart"),
    id: 860,
    position: "Midfielder",
    type: "Loan",
    player: "Laurin Ulrich"
},
{
    date: cleanDate("15-07-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Radomiak Radom"),
    fromClubId: getClubId("St Pauli"),
    id: 861,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Maurides"
},
{
    date: cleanDate("20-05-2025"),
    country: "USA",
    amount: cleanAmount(0),
    toClubId: getClubId("St Pauli"),
    fromClubId: getClubId("New York City"),
    id: 862,
    position: "Midfielder",
    type: "Loan extended",
    player: "James Sands"
},
{
    date: cleanDate("19-05-2025"),
    country: "POL",
    amount: cleanAmount(0),
    toClubId: getClubId("St Pauli"),
    fromClubId: getClubId("Piast Gliwice"),
    id: 863,
    position: "Defender",
    type: "Free",
    player: "Arkadiusz Pyrka"
},
{
    date: cleanDate("29-07-2025"),
    country: "POR",
    amount: cleanAmount(26200000),
    toClubId: getClubId("Al-Nassr"),
    fromClubId: getClubId("Chelsea"),
    id: 864,
    position: "Forward",
    type: "Paid",
    player: "João Félix"
},
{
    date: cleanDate("29-07-2025"),
    country: "CRO",
    amount: cleanAmount(0),
    toClubId: getClubId("Grasshopper"),
    fromClubId: getClubId("Bayern Munich"),
    id: 865,
    position: "Midfielder",
    type: "Loan",
    player: "Lovro Zvonarek"
},
{
    date: cleanDate("29-07-2025"),
    country: "INA",
    amount: cleanAmount(0),
    toClubId: getClubId("Fortuna Sittard"),
    fromClubId: getClubId("Wolves"),
    id: 866,
    position: "Defender",
    type: "Free",
    player: "Justin Hubner"
},
{
    date: cleanDate("29-07-2025"),
    country: "FIN",
    amount: cleanAmount(0),
    toClubId: getClubId("Cambuur"),
    fromClubId: getClubId("Manchester City"),
    id: 867,
    position: "Defender",
    type: "Loan",
    player: "Tomas Galvez"
},
{
    date: cleanDate("29-07-2025"),
    country: "CAN",
    amount: cleanAmount(7650000),
    toClubId: getClubId("Villarreal"),
    fromClubId: getClubId("Inter"),
    id: 868,
    position: "Winger",
    type: "Paid",
    player: "Tajon Buchanan"
},
{
    date: cleanDate("29-07-2025"),
    country: "CAF",
    amount: cleanAmount(0),
    toClubId: getClubId("Levante"),
    fromClubId: getClubId("Lens"),
    id: 869,
    position: "Forward",
    type: "Loan",
    player: "Goduine Koyalipou"
},
{
    date: cleanDate("29-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Empoli"),
    fromClubId: getClubId("Cremonese"),
    id: 870,
    position: "Goalkeeper",
    type: "Loan",
    player: "Andrea Fulignati"
},
{
    date: cleanDate("29-07-2025"),
    country: "CAN",
    amount: cleanAmount(0),
    toClubId: getClubId("Sassuolo"),
    fromClubId: getClubId("Marseille"),
    id: 871,
    position: "Defender",
    type: "Loan",
    player: "Ismaël Koné"
},
{
    date: cleanDate("29-07-2025"),
    country: "MAR",
    amount: cleanAmount(8000000),
    toClubId: getClubId("Everton"),
    fromClubId: getClubId("Bayern Munich"),
    id: 872,
    position: "Defender",
    type: "Paid",
    player: "Adam Aznou"
},
{
    date: cleanDate("29-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Stevenage"),
    fromClubId: getClubId("Aston Villa"),
    id: 873,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Filip Marschall"
},
{
    date: cleanDate("29-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Getafe"),
    fromClubId: getClubId("Real Madrid"),
    id: 874,
    position: "Midfielder",
    type: "Loan",
    player: "Mario Martín"
},
{
    date: cleanDate("29-07-2025"),
    country: "ITA",
    amount: cleanAmount(2550000),
    toClubId: getClubId("Cremonese"),
    fromClubId: getClubId("Lecce"),
    id: 875,
    position: "Defender",
    type: "Paid",
    player: "Federico Baschirotto"
},
{
    date: cleanDate("29-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cremonese"),
    fromClubId: getClubId("Napoli"),
    id: 876,
    position: "Winger",
    type: "Loan",
    player: "Alessio Zerbin"
},
{
    date: cleanDate("29-07-2025"),
    country: "DEN",
    amount: cleanAmount(2550000),
    toClubId: getClubId("Metz"),
    fromClubId: getClubId("Fredrikstad"),
    id: 877,
    position: "Goalkeeper",
    type: "Paid",
    player: "Jonathan Fischer"
},
{
    date: cleanDate("29-07-2025"),
    country: "MAR",
    amount: cleanAmount(6800000),
    toClubId: getClubId("Torino"),
    fromClubId: getClubId("Toulouse"),
    id: 878,
    position: "Winger",
    type: "Paid",
    player: "Zakaria Aboukhal"
},
{
    date: cleanDate("29-07-2025"),
    country: "ROU",
    amount: cleanAmount(0),
    toClubId: getClubId("Juve Stabia"),
    fromClubId: getClubId("Lecce"),
    id: 879,
    position: "Forward",
    type: "Loan",
    player: "Rares Burnete"
},
{
    date: cleanDate("29-07-2025"),
    country: "MAR",
    amount: cleanAmount(0),
    toClubId: getClubId("Getafe"),
    fromClubId: getClubId("Alavés"),
    id: 880,
    position: "Defender",
    type: "Free",
    player: "Abdel Abqar"
},
{
    date: cleanDate("29-07-2025"),
    country: "ENG",
    amount: cleanAmount(27000000),
    toClubId: getClubId("Manchester City"),
    fromClubId: getClubId("Burnley"),
    id: 881,
    position: "Goalkeeper",
    type: "Paid",
    player: "James Trafford"
},
{
    date: cleanDate("29-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Derby County"),
    fromClubId: getClubId("Crystal Palace"),
    id: 882,
    position: "Midfielder",
    type: "Loan",
    player: "David Ozoh"
},
{
    date: cleanDate("29-07-2025"),
    country: "SEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Lorient"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 883,
    position: "Defender",
    type: "Loan",
    player: "Abdoulaye Faye"
},
{
    date: cleanDate("29-07-2025"),
    country: "ITA",
    amount: cleanAmount(1300000),
    toClubId: getClubId("Udinese"),
    fromClubId: getClubId("Benevento"),
    id: 884,
    position: "Goalkeeper",
    type: "Paid",
    player: "Alessandro Nunziante"
},
{
    date: cleanDate("29-07-2025"),
    country: "NOR",
    amount: cleanAmount(0),
    toClubId: getClubId("Genoa"),
    fromClubId: getClubId("Rennes"),
    id: 885,
    position: "Defender",
    type: "Loan",
    player: "Leo Ostigard"
},
{
    date: cleanDate("29-07-2025"),
    country: "COL",
    amount: cleanAmount(0),
    toClubId: getClubId("Roma"),
    fromClubId: getClubId("Milan"),
    id: 886,
    position: "Goalkeeper",
    type: "Free",
    player: "Devis Vásquez"
},
{
    date: cleanDate("30-07-2025"),
    country: "COL",
    amount: cleanAmount(65500000),
    toClubId: getClubId("Bayern Munich"),
    fromClubId: getClubId("Liverpool"),
    id: 887,
    position: "Winger",
    type: "Paid",
    player: "Luis Díaz"
},
{
    date: cleanDate("30-07-2025"),
    country: "SUI",
    amount: cleanAmount(13000000),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 888,
    position: "Midfielder",
    type: "Paid",
    player: "Granit Xhaka"
},
{
    date: cleanDate("30-07-2025"),
    country: "BRA",
    amount: cleanAmount(18900000),
    toClubId: getClubId("Flamengo"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 889,
    position: "Winger",
    type: "Paid",
    player: "Samuel Lino"
},
{
    date: cleanDate("29-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Girona"),
    fromClubId: getClubId("Athletic Club"),
    id: 890,
    position: "Defender",
    type: "Loan",
    player: "Hugo Rincón"
},
{
    date: cleanDate("29-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Hull City"),
    fromClubId: getClubId("Manchester City"),
    id: 891,
    position: "Forward",
    type: "Loan",
    player: "Joel Ndala"
},
{
    date: cleanDate("30-07-2025"),
    country: "POL",
    amount: cleanAmount(0),
    toClubId: getClubId("Elversberg"),
    fromClubId: getClubId("Hamburg"),
    id: 892,
    position: "Midfielder",
    type: "Loan",
    player: "Lukasz Poreba"
},
{
    date: cleanDate("30-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Deportivo La Coruña"),
    fromClubId: getClubId("Cremonese"),
    id: 893,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Giacomo Quagliata"
},
{
    date: cleanDate("30-07-2025"),
    country: "ISL",
    amount: cleanAmount(0),
    toClubId: getClubId("Kasimpasa"),
    fromClubId: getClubId("Bologna"),
    id: 894,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Andri Baldursson"
},
{
    date: cleanDate("30-07-2025"),
    country: "ENG",
    amount: cleanAmount(6500000),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Chelsea"),
    id: 895,
    position: "Defender",
    type: "Paid",
    player: "Ishé Samuels-Smith"
},
{
    date: cleanDate("30-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Deportivo La Coruña"),
    fromClubId: getClubId("Espanyol"),
    id: 896,
    position: "Midfielder",
    type: "Loan",
    player: "José Gragera"
},
{
    date: cleanDate("30-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Casertana"),
    fromClubId: getClubId("Sassuolo"),
    id: 897,
    position: "Midfielder",
    type: "Loan",
    player: "Kevin Leone"
},
{
    date: cleanDate("30-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Inter"),
    fromClubId: getClubId("Sassuolo"),
    id: 898,
    position: "Defender",
    type: "Loan",
    player: "Simone Cinquegrano"
},
{
    date: cleanDate("29-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Leyton Orient"),
    fromClubId: getClubId("Newcastle"),
    id: 899,
    position: "Midfielder",
    type: "Loan",
    player: "Joe White"
},
{
    date: cleanDate("17-07-2025"),
    country: "CZE",
    amount: cleanAmount(0),
    toClubId: getClubId("Dordrecht"),
    fromClubId: getClubId("RB Leipzig"),
    id: 900,
    position: "Forward",
    type: "Loan",
    player: "Yannick Eduardo"
},
{
    date: cleanDate("09-07-2025"),
    country: "JPN",
    amount: cleanAmount(0),
    toClubId: getClubId("Mainz 05"),
    fromClubId: getClubId("Kyoto Sanga"),
    id: 901,
    position: "Midfielder",
    type: "Loan",
    player: "Sota Kawasaki"
},
{
    date: cleanDate("30-07-2025"),
    country: "SVK",
    amount: cleanAmount(8600000),
    toClubId: getClubId("Fenerbahçe"),
    fromClubId: getClubId("Paris Saint-Germain"),
    id: 902,
    position: "Defender",
    type: "Paid",
    player: "Milan Skriniar"
},
{
    date: cleanDate("30-07-2025"),
    country: "POL",
    amount: cleanAmount(0),
    toClubId: getClubId("Kocaelispor"),
    fromClubId: getClubId("Cagliari"),
    id: 903,
    position: "Defender",
    type: "Loan",
    player: "Mateusz Wieteska"
},
{
    date: cleanDate("30-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cagliari"),
    fromClubId: getClubId("Como"),
    id: 904,
    position: "Midfielder",
    type: "Loan",
    player: "Luca Mazzitelli"
},
{
    date: cleanDate("10-07-2025"),
    country: "GER",
    amount: cleanAmount(1300000),
    toClubId: getClubId("Hoffenheim"),
    fromClubId: getClubId("Ingolstadt"),
    id: 905,
    position: "Forward",
    type: "Paid",
    player: "Deniz Zeitler"
},
{
    date: cleanDate("01-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("TSV Solingen"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 906,
    position: "Goalkeeper",
    type: "Free",
    player: "Luca Novodomsky"
},
{
    date: cleanDate("01-07-2025"),
    country: "ITA",
    amount: cleanAmount(4250000),
    toClubId: getClubId("Venezia"),
    fromClubId: getClubId("Juventus"),
    id: 907,
    position: "Midfielder",
    type: "Paid",
    player: "Hans Nicolussi Caviglia"
},
{
    date: cleanDate("22-07-2025"),
    country: "FIN",
    amount: cleanAmount(0),
    toClubId: getClubId("Östers IF"),
    fromClubId: getClubId("Hamburg"),
    id: 908,
    position: "Midfielder",
    type: "Loan",
    player: "Anssi Suhonen"
},
{
    date: cleanDate("06-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("SC Verl"),
    fromClubId: getClubId("Wolfsburg"),
    id: 909,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Philipp Schulze"
},
{
    date: cleanDate("09-07-2025"),
    country: "CRO",
    amount: cleanAmount(6900000),
    toClubId: getClubId("Freiburg"),
    fromClubId: getClubId("Eintracht Frankfurt"),
    id: 910,
    position: "Forward",
    type: "Paid",
    player: "Igor Matanovic"
},
{
    date: cleanDate("18-06-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Wacker Burghausen"),
    fromClubId: getClubId("Hamburg"),
    id: 911,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Tom Sanne"
},
{
    date: cleanDate("01-07-2025"),
    country: "SEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Spezia"),
    fromClubId: getClubId("Cremonese"),
    id: 912,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Mouhamadou Sarr"
},
{
    date: cleanDate("30-07-2025"),
    country: "CRO",
    amount: cleanAmount(0),
    toClubId: getClubId("Magdeburg"),
    fromClubId: getClubId("Borussia Mönchengladbach"),
    id: 913,
    position: "Winger",
    type: "Loan",
    player: "Noah Pesch"
},
{
    date: cleanDate("30-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Celta Vigo"),
    fromClubId: getClubId("Bayern Munich"),
    id: 914,
    position: "Winger",
    type: "Loan",
    player: "Bryan Zaragoza"
},
{
    date: cleanDate("30-07-2025"),
    country: "KOR",
    amount: cleanAmount(0),
    toClubId: getClubId("Nantes"),
    fromClubId: getClubId("Mainz 05"),
    id: 915,
    position: "Midfielder",
    type: "Loan",
    player: "Hong Hyun-seok"
},
{
    date: cleanDate("30-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Granada"),
    fromClubId: getClubId("Villarreal"),
    id: 916,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Jorge Pascual"
},
{
    date: cleanDate("30-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Girona"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 917,
    position: "Winger",
    type: "Loan",
    player: "Thomas Lemar"
},
{
    date: cleanDate("30-07-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Elche"),
    fromClubId: getClubId("Benfica"),
    id: 918,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Martim Neto"
},
{
    date: cleanDate("31-07-2025"),
    country: "SUI",
    amount: cleanAmount(34000000),
    toClubId: getClubId("Nottingham Forest"),
    fromClubId: getClubId("Bologna"),
    id: 919,
    position: "Winger",
    type: "Paid",
    player: "Dan Ndoye"
},
{
    date: cleanDate("31-07-2025"),
    country: "ECU",
    amount: cleanAmount(0),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Chelsea"),
    id: 920,
    position: "Midfielder",
    type: "Loan",
    player: "Kendry Páez"
},
{
    date: cleanDate("31-07-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Darmstadt"),
    fromClubId: getClubId("Mainz 05"),
    id: 921,
    position: "Midfielder",
    type: "Loan",
    player: "Marco Richter"
},
{
    date: cleanDate("23-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Stoke City"),
    fromClubId: getClubId("Tottenham"),
    id: 922,
    position: "Defender",
    type: "Loan",
    player: "Ashley Phillips"
},
{
    date: cleanDate("31-07-2025"),
    country: "GAB",
    amount: cleanAmount(0),
    toClubId: getClubId("Marseille"),
    fromClubId: getClubId("Al-Qadsiah"),
    id: 923,
    position: "Forward",
    type: "Free",
    player: "Pierre-Emerick Aubameyang"
},
{
    date: cleanDate("31-07-2025"),
    country: "BRA",
    amount: cleanAmount(7000000),
    toClubId: getClubId("Olympiacos"),
    fromClubId: getClubId("Como"),
    id: 924,
    position: "Winger",
    type: "Paid",
    player: "Gabriel Strefezza"
},
{
    date: cleanDate("31-07-2025"),
    country: "ESP",
    amount: cleanAmount(2150000),
    toClubId: getClubId("Como"),
    fromClubId: getClubId("Real Madrid"),
    id: 925,
    position: "Defender",
    type: "Paid",
    player: "Jacobo Ramón"
},
{
    date: cleanDate("31-07-2025"),
    country: "GER",
    amount: cleanAmount(850000),
    toClubId: getClubId("Cologne"),
    fromClubId: getClubId("Hoffenheim"),
    id: 926,
    position: "Forward",
    type: "Paid",
    player: "Marius Bülter"
},
{
    date: cleanDate("31-07-2025"),
    country: "FRA",
    amount: cleanAmount(17300000),
    toClubId: getClubId("Neom SC"),
    fromClubId: getClubId("Nantes"),
    id: 927,
    position: "Defender",
    type: "Paid",
    player: "Nathan Zézé"
},
{
    date: cleanDate("01-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Rangers"),
    fromClubId: getClubId("Tottenham"),
    id: 928,
    position: "Forward",
    type: "Loan",
    player: "Mikey Moore"
},
{
    date: cleanDate("01-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Chelsea"),
    id: 929,
    position: "Defender",
    type: "Loan",
    player: "Mamadou Sarr"
},
{
    date: cleanDate("01-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Northampton"),
    fromClubId: getClubId("Manchester United"),
    id: 930,
    position: "Forward",
    type: "Loan",
    player: "Ethan Wheatley"
},
{
    date: cleanDate("01-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Wigan Athletic"),
    fromClubId: getClubId("Liverpool"),
    id: 931,
    position: "Defender",
    type: "Loan",
    player: "Isaac Mabaya"
},
{
    date: cleanDate("01-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Huddersfield"),
    fromClubId: getClubId("Chelsea"),
    id: 932,
    position: "Midfielder",
    type: "Loan",
    player: "Leo Castledine"
},
{
    date: cleanDate("01-08-2025"),
    country: "NED",
    amount: cleanAmount(9100000),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("NEC Nijmegen"),
    id: 933,
    position: "Goalkeeper",
    type: "Paid",
    player: "Robin Roefs"
},
{
    date: cleanDate("31-07-2025"),
    country: "NGR",
    amount: cleanAmount(65000000),
    toClubId: getClubId("Galatasaray"),
    fromClubId: getClubId("Napoli"),
    id: 934,
    position: "Forward",
    type: "Paid",
    player: "Victor Osimhen"
},
{
    date: cleanDate("31-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Wigan Athletic"),
    fromClubId: getClubId("Brentford"),
    id: 935,
    position: "Midfielder",
    type: "Loan",
    player: "Ryan Trevitt"
},
{
    date: cleanDate("01-08-2025"),
    country: "CRO",
    amount: cleanAmount(0),
    toClubId: getClubId("Hajduk Split"),
    fromClubId: getClubId("Lecce"),
    id: 936,
    position: "Forward",
    type: "Free",
    player: "Ante Rebic"
},
{
    date: cleanDate("01-08-2025"),
    country: "JPN",
    amount: cleanAmount(1740000),
    toClubId: getClubId("Red Bull Salzburg"),
    fromClubId: getClubId("Stuttgart"),
    id: 937,
    position: "Defender",
    type: "Paid",
    player: "Anrie Chase"
},
{
    date: cleanDate("01-08-2025"),
    country: "ITA",
    amount: cleanAmount(870000),
    toClubId: getClubId("Inter"),
    fromClubId: getClubId("Verona"),
    id: 938,
    position: "Midfielder",
    type: "Paid",
    player: "Richi Agbonifo"
},
{
    date: cleanDate("01-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Juve Stabia"),
    fromClubId: getClubId("Roma"),
    id: 939,
    position: "Midfielder",
    type: "Loan",
    player: "Mattia Mannini"
},
{
    date: cleanDate("01-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Córdoba"),
    fromClubId: getClubId("Real Oviedo"),
    id: 940,
    position: "Midfielder",
    type: "Loan",
    player: "Alberto del Moral"
},
{
    date: cleanDate("01-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Westerlo"),
    fromClubId: getClubId("Newcastle"),
    id: 941,
    position: "Winger",
    type: "Loan",
    player: "Antonio Cordero"
},
{
    date: cleanDate("01-08-2025"),
    country: "BRA",
    amount: cleanAmount(26150000),
    toClubId: getClubId("Marseille"),
    fromClubId: getClubId("Feyenoord"),
    id: 942,
    position: "Winger",
    type: "Paid",
    player: "Igor Paixão"
},
{
    date: cleanDate("01-08-2025"),
    country: "MAR",
    amount: cleanAmount(0),
    toClubId: getClubId("Auxerre"),
    fromClubId: getClubId("Bologna"),
    id: 943,
    position: "Midfielder",
    type: "Loan",
    player: "Oussama El Azzouzi"
},
{
    date: cleanDate("01-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Padova"),
    fromClubId: getClubId("Inter"),
    id: 944,
    position: "Midfielder",
    type: "Loan",
    player: "Luca Di Maggio"
},
{
    date: cleanDate("01-08-2025"),
    country: "URU",
    amount: cleanAmount(8500000),
    toClubId: getClubId("Villarreal"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 945,
    position: "Defender",
    type: "Paid",
    player: "Santiago Mouriño"
},
{
    date: cleanDate("31-07-2025"),
    country: "URU",
    amount: cleanAmount(3400000),
    toClubId: getClubId("Atlético Madrid"),
    fromClubId: getClubId("Alavés"),
    id: 946,
    position: "Defender",
    type: "Paid",
    player: "Santiago Mouriño"
},
{
    date: cleanDate("01-08-2025"),
    country: "USA",
    amount: cleanAmount(6800000),
    toClubId: getClubId("Lyon"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 947,
    position: "Goalkeeper",
    type: "Paid",
    player: "Matt Turner"
},
{
    date: cleanDate("31-07-2025"),
    country: "EGY",
    amount: cleanAmount(0),
    toClubId: getClubId("Ettifaq"),
    fromClubId: getClubId("Le Havre"),
    id: 948,
    position: "Forward",
    type: "Free",
    player: "Ahmed Hassan"
},
{
    date: cleanDate("31-07-2025"),
    country: "ARG",
    amount: cleanAmount(2550000),
    toClubId: getClubId("Toulouse"),
    fromClubId: getClubId("Independiente"),
    id: 949,
    position: "Forward",
    type: "Paid",
    player: "Santiago Hidalgo"
},
{
    date: cleanDate("01-08-2025"),
    country: "MAR",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Valladolid"),
    fromClubId: getClubId("Rennes"),
    id: 950,
    position: "Defender",
    type: "Free",
    player: "Mohamed Jaouab"
},
{
    date: cleanDate("01-08-2025"),
    country: "CRO",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Sociedad"),
    fromClubId: getClubId("Lyon"),
    id: 951,
    position: "Defender",
    type: "Loan",
    player: "Duje Caleta-Car"
},
{
    date: cleanDate("02-08-2025"),
    country: "NOR",
    amount: cleanAmount(10000000),
    toClubId: getClubId("Wolves"),
    fromClubId: getClubId("AZ Alkmaar"),
    id: 952,
    position: "Defender",
    type: "Paid",
    player: "David Møller Wolfe"
},
{
    date: cleanDate("01-08-2025"),
    country: "USA",
    amount: cleanAmount(0),
    toClubId: getClubId("New England Revolution"),
    fromClubId: getClubId("Lyon"),
    id: 953,
    position: "Goalkeeper",
    type: "Loan",
    player: "Matt Turner"
},
{
    date: cleanDate("02-08-2025"),
    country: "TUR",
    amount: cleanAmount(0),
    toClubId: getClubId("Anderlecht"),
    fromClubId: getClubId("Aston Villa"),
    id: 954,
    position: "Defender",
    type: "Loan",
    player: "Yasin Ozcan"
},
{
    date: cleanDate("02-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Roma"),
    fromClubId: getClubId("Verona"),
    id: 955,
    position: "Defender",
    type: "Loan",
    player: "Daniele Ghilardi"
},
{
    date: cleanDate("02-08-2025"),
    country: "SLO",
    amount: cleanAmount(0),
    toClubId: getClubId("Oxford United"),
    fromClubId: getClubId("Cagliari"),
    id: 956,
    position: "Forward",
    type: "Loan",
    player: "Nik Prelec"
},
{
    date: cleanDate("02-08-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Sturm Graz"),
    fromClubId: getClubId("Fiorentina"),
    id: 957,
    position: "Goalkeeper",
    type: "Loan",
    player: "Oliver Christensen"
},
{
    date: cleanDate("02-08-2025"),
    country: "JAM",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Newcastle"),
    id: 958,
    position: "Midfielder",
    type: "Released",
    player: "Isaac Hayden"
},
{
    date: cleanDate("02-08-2025"),
    country: "GAB",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Red Star Belgrade"),
    fromClubId: getClubId("Toulouse"),
    id: 959,
    position: "Winger",
    type: "Paid",
    player: "Shavy Babicka"
},
{
    date: cleanDate("02-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Newcastle"),
    fromClubId: getClubId("Southampton"),
    id: 960,
    position: "Goalkeeper",
    type: "Loan",
    player: "Aaron Ramsdale"
},
{
    date: cleanDate("02-08-2025"),
    country: "POL",
    amount: cleanAmount(2550000),
    toClubId: getClubId("Udinese"),
    fromClubId: getClubId("Ludogorets"),
    id: 961,
    position: "Midfielder",
    type: "Paid",
    player: "Jakub Piotrowski"
},
{
    date: cleanDate("03-08-2025"),
    country: "TUR",
    amount: cleanAmount(0),
    toClubId: getClubId("Cagliari"),
    fromClubId: getClubId("Beşiktaş"),
    id: 962,
    position: "Forward",
    type: "Loan",
    player: "Semih Kılıçsoy"
},
{
    date: cleanDate("03-08-2025"),
    country: "CRO",
    amount: cleanAmount(0),
    toClubId: getClubId("Verona"),
    fromClubId: getClubId("Salernitana"),
    id: 963,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Domagoj Bradarić"
},
{
    date: cleanDate("03-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Colorado Rapids"),
    fromClubId: getClubId("Crystal Palace"),
    id: 964,
    position: "Defender",
    type: "Free ",
    player: "Rob Holding"
},
{
    date: cleanDate("03-08-2025"),
    country: "NED",
    amount: cleanAmount(38500000),
    toClubId: getClubId("Chelsea"),
    fromClubId: getClubId("Ajax"),
    id: 965,
    position: "Defender",
    type: "Paid",
    player: "Jorrel Hato"
},
{
    date: cleanDate("03-08-2025"),
    country: "KSA",
    amount: cleanAmount(0),
    toClubId: getClubId("Lens"),
    fromClubId: getClubId("Roma"),
    id: 966,
    position: "Defender",
    type: "Loan",
    player: "Saud Abdulhamid"
},
{
    date: cleanDate("03-08-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Tottenham"),
    fromClubId: getClubId("Bayern Munich"),
    id: 967,
    position: "Midfielder",
    type: "Loan",
    player: "João Palhinha"
},
{
    date: cleanDate("03-08-2025"),
    country: "MAR",
    amount: cleanAmount(0),
    toClubId: getClubId("Panathinaikos"),
    fromClubId: getClubId("Lens"),
    id: 968,
    position: "Winger",
    type: "Loan",
    player: "Anass Zaroury"
},
{
    date: cleanDate("03-08-2025"),
    country: "SUI",
    amount: cleanAmount(0),
    toClubId: getClubId("Pisa"),
    fromClubId: getClubId("Bologna"),
    id: 969,
    position: "Midfielder",
    type: "Loan",
    player: "Michel Aebischer"
},
{
    date: cleanDate("04-08-2025"),
    country: "NOR",
    amount: cleanAmount(870000),
    toClubId: getClubId("Nordsjælland"),
    fromClubId: getClubId("Roma"),
    id: 970,
    position: "Winger",
    type: "Paid",
    player: "Ola Solbakken"
},
{
    date: cleanDate("04-08-2025"),
    country: "BRA",
    amount: cleanAmount(13000000),
    toClubId: getClubId("Al-Duhail"),
    fromClubId: getClubId("Eintracht Frankfurt"),
    id: 971,
    position: "Defender",
    type: "Paid",
    player: "Tuta"
},
{
    date: cleanDate("04-08-2025"),
    country: "CRO",
    amount: cleanAmount(4400000),
    toClubId: getClubId("FC Midtjylland"),
    fromClubId: getClubId("Bologna"),
    id: 972,
    position: "Defender",
    type: "Paid",
    player: "Martin Erlic"
},
{
    date: cleanDate("04-08-2025"),
    country: "COL",
    amount: cleanAmount(11300000),
    toClubId: getClubId("Real Betis"),
    fromClubId: getClubId("Monterrey"),
    id: 973,
    position: "Midfielder",
    type: "Paid",
    player: "Nelson Deossa"
},
{
    date: cleanDate("04-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Pau"),
    fromClubId: getClubId("Lens"),
    id: 974,
    position: "Defender",
    type: "Free",
    player: "Tom Pouilly"
},
{
    date: cleanDate("04-08-2025"),
    country: "SEN",
    amount: cleanAmount(5700000),
    toClubId: getClubId("Parma"),
    fromClubId: getClubId("Troyes"),
    id: 975,
    position: "Defender",
    type: "Paid",
    player: "Abdoulaye Ndiaye"
},
{
    date: cleanDate("04-08-2025"),
    country: "CZE",
    amount: cleanAmount(6500000),
    toClubId: getClubId("Lyon"),
    fromClubId: getClubId("Viktoria Plzen"),
    id: 976,
    position: "Midfielder",
    type: "Paid",
    player: "Pavel Sulc"
},
{
    date: cleanDate("04-08-2025"),
    country: "POR",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Real Sociedad"),
    fromClubId: getClubId("Wolves"),
    id: 977,
    position: "Winger",
    type: "Paid",
    player: "Gonçalo Guedes"
},
{
    date: cleanDate("04-08-2025"),
    country: "SUI",
    amount: cleanAmount(13000000),
    toClubId: getClubId("Fiorentina"),
    fromClubId: getClubId("Parma"),
    id: 978,
    position: "Midfielder",
    type: "Paid",
    player: "Simon Sohm"
},
{
    date: cleanDate("05-08-2025"),
    country: "SRB",
    amount: cleanAmount(0),
    toClubId: getClubId("AEK Athens"),
    fromClubId: getClubId("Milan"),
    id: 979,
    position: "Forward",
    type: "Free",
    player: "Luka Jovic"
},
{
    date: cleanDate("05-08-2025"),
    country: "TAN",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Havre"),
    fromClubId: getClubId("PAOK"),
    id: 980,
    position: "Forward",
    type: "Free",
    player: "Mbwana Ally Samatta"
},
{
    date: cleanDate("01-07-2025"),
    country: "CYP",
    amount: cleanAmount(0),
    toClubId: getClubId("Verona"),
    fromClubId: getClubId("Salernitana"),
    id: 981,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Grigoris Kastanos"
},
{
    date: cleanDate("02-07-2025"),
    country: "SEN",
    amount: cleanAmount(3045000),
    toClubId: getClubId("Verona"),
    fromClubId: getClubId("Young Boys"),
    id: 982,
    position: "Midfielder",
    type: "Paid",
    player: "Cheikh Niasse"
},
{
    date: cleanDate("01-07-2025"),
    country: "SRB",
    amount: cleanAmount(17400000),
    toClubId: getClubId("Atalanta"),
    fromClubId: getClubId("Udinese"),
    id: 983,
    position: "Midfielder",
    type: "Paid",
    player: "Lazar Samardzic"
},
{
    date: cleanDate("01-07-2025"),
    country: "FRA",
    amount: cleanAmount(6000000),
    toClubId: getClubId("Marseille"),
    fromClubId: getClubId("Everton"),
    id: 984,
    position: "Forward",
    type: "Paid",
    player: "Neal Maupay"
},
{
    date: cleanDate("02-07-2025"),
    country: "SEN",
    amount: cleanAmount(6880000),
    toClubId: getClubId("Galatasaray"),
    fromClubId: getClubId("Monaco"),
    id: 985,
    position: "Defender",
    type: "Paid",
    player: "Ismail Jakobs"
},
{
    date: cleanDate("05-08-2025"),
    country: "USA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cologne"),
    fromClubId: getClubId("Palermo"),
    id: 986,
    position: "Defender",
    type: "Loan",
    player: "Kristoffer Lund"
},
{
    date: cleanDate("05-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Oxford United"),
    fromClubId: getClubId("Tottenham"),
    id: 987,
    position: "Forward",
    type: "Loan",
    player: "Will Lankshear"
},
{
    date: cleanDate("05-08-2025"),
    country: "CZE",
    amount: cleanAmount(0),
    toClubId: getClubId("Hoffenheim"),
    fromClubId: getClubId("West Ham"),
    id: 988,
    position: "Defender",
    type: "Free",
    player: "Vladimir Coufal"
},
{
    date: cleanDate("05-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Celtic"),
    fromClubId: getClubId("Manchester City"),
    id: 989,
    position: "Defender",
    type: "Loan",
    player: "Jahmai Simpson-Pusey"
},
{
    date: cleanDate("05-08-2025"),
    country: "ENG",
    amount: cleanAmount(1000000),
    toClubId: getClubId("Blackpool"),
    fromClubId: getClubId("Crystal Palace"),
    id: 990,
    position: "Winger",
    type: "Paid",
    player: "Malcolm Ebiowei"
},
{
    date: cleanDate("04-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Notts County"),
    fromClubId: getClubId("Tottenham"),
    id: 991,
    position: "Midfielder",
    type: "Loan",
    player: "Tyrese Hall"
},
{
    date: cleanDate("04-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Braintree Town"),
    fromClubId: getClubId("West Ham"),
    id: 992,
    position: "Goalkeeper",
    type: "Loan",
    player: "Mason Terry"
},
{
    date: cleanDate("04-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Reading"),
    fromClubId: getClubId("Brighton"),
    id: 993,
    position: "Midfielder",
    type: "Loan",
    player: "Kamari Doyle"
},
{
    date: cleanDate("04-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Leyton Orient"),
    fromClubId: getClubId("Fulham"),
    id: 994,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Lemar Gordon"
},
{
    date: cleanDate("05-08-2025"),
    country: "GEO",
    amount: cleanAmount(3480000),
    toClubId: getClubId("Udinese"),
    fromClubId: getClubId("Empoli"),
    id: 995,
    position: "Defender",
    type: "Paid",
    player: "Saba Goglichidze"
},
{
    date: cleanDate("05-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Feyenoord"),
    fromClubId: getClubId("Napoli"),
    id: 996,
    position: "Midfielder",
    type: "Free",
    player: "Matteo Malasomma"
},
{
    date: cleanDate("05-08-2025"),
    country: "CRO",
    amount: cleanAmount(0),
    toClubId: getClubId("Salernitana"),
    fromClubId: getClubId("Sassuolo"),
    id: 997,
    position: "Forward",
    type: "Loan",
    player: "Borna Knezovic"
},
{
    date: cleanDate("05-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Charlotte FC"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 998,
    position: "Defender",
    type: "Free",
    player: "Harry Toffolo"
},
{
    date: cleanDate("05-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Accrington"),
    fromClubId: getClubId("Burnley"),
    id: 999,
    position: "Midfielder",
    type: "Loan",
    player: "Joe Bauress"
},
{
    date: cleanDate("05-08-2025"),
    country: "ENG",
    amount: cleanAmount(15000000),
    toClubId: getClubId("Lyon"),
    fromClubId: getClubId("Liverpool"),
    id: 1000,
    position: "Midfielder",
    type: "Paid",
    player: "Tyler Morton"
},
{
    date: cleanDate("05-08-2025"),
    country: "WAL",
    amount: cleanAmount(0),
    toClubId: getClubId("Doncaster"),
    fromClubId: getClubId("Leeds United"),
    id: 1001,
    position: "Midfielder",
    type: "Loan",
    player: "Charlie Crew"
},
{
    date: cleanDate("06-08-2025"),
    country: "NIR",
    amount: cleanAmount(0),
    toClubId: getClubId("Stoke City"),
    fromClubId: getClubId("Tottenham"),
    id: 1002,
    position: "Forward",
    type: "Loan",
    player: "Jamie Donley"
},
{
    date: cleanDate("06-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Wycombe"),
    fromClubId: getClubId("Tottenham"),
    id: 1003,
    position: "Midfielder",
    type: "Loan",
    player: "George Abbott"
},
{
    date: cleanDate("06-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Colchester"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 1004,
    position: "Defender",
    type: "Loan",
    player: "Josh Powell"
},
{
    date: cleanDate("06-08-2025"),
    country: "ENG",
    amount: cleanAmount(28000000),
    toClubId: getClubId("Everton"),
    fromClubId: getClubId("Chelsea"),
    id: 1005,
    position: "Midfielder",
    type: "Paid",
    player: "Kiernan Dewsbury-Hall"
},
{
    date: cleanDate("06-08-2025"),
    country: "AUT",
    amount: cleanAmount(0),
    toClubId: getClubId("Bari"),
    fromClubId: getClubId("Como"),
    id: 1006,
    position: "Midfielder",
    type: "Loan",
    player: "Matthias Braunöder"
},
{
    date: cleanDate("05-08-2025"),
    country: "SEN",
    amount: cleanAmount(0),
    toClubId: getClubId("AVS"),
    fromClubId: getClubId("Lens"),
    id: 1007,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Sidi Bané"
},
{
    date: cleanDate("06-08-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Le Havre"),
    fromClubId: getClubId("PEC Zwolle"),
    id: 1008,
    position: "Winger",
    type: "Free",
    player: "Younes Namli"
},
{
    date: cleanDate("06-08-2025"),
    country: "SCO",
    amount: cleanAmount(0),
    toClubId: getClubId("Nottingham Forest"),
    fromClubId: getClubId("Norwich City"),
    id: 1009,
    position: "Goalkeeper",
    type: "Free",
    player: "Angus Gunn"
},
{
    date: cleanDate("06-08-2025"),
    country: "GER",
    amount: cleanAmount(350000),
    toClubId: getClubId("Paderborn"),
    fromClubId: getClubId("Cologne"),
    id: 1010,
    position: "Forward",
    type: "Paid",
    player: "Steffen Tigges"
},
{
    date: cleanDate("06-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cesena"),
    fromClubId: getClubId("Sassuolo"),
    id: 1011,
    position: "Forward",
    type: "Loan",
    player: "Riccardo Ciervo"
},
{
    date: cleanDate("06-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Cesena"),
    fromClubId: getClubId("Atalanta"),
    id: 1012,
    position: "Forward",
    type: "Loan",
    player: "Siren Diao"
},
{
    date: cleanDate("06-08-2025"),
    country: "GHA",
    amount: cleanAmount(1800000),
    toClubId: getClubId("Toulouse"),
    fromClubId: getClubId("Cercle Brugge"),
    id: 1013,
    position: "Midfielder",
    type: "Paid",
    player: "Abu Francis"
},
{
    date: cleanDate("05-08-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Nuremberg"),
    fromClubId: getClubId("Bayern Munich"),
    id: 1014,
    position: "Defender",
    type: "Loan",
    player: "Tarek Buchmann"
},
{
    date: cleanDate("06-08-2025"),
    country: "SUI",
    amount: cleanAmount(31000000),
    toClubId: getClubId("Milan"),
    fromClubId: getClubId("Club Brugge"),
    id: 1015,
    position: "Midfielder",
    type: "Paid",
    player: "Ardon Jashari"
},
{
    date: cleanDate("06-08-2025"),
    country: "CUR",
    amount: cleanAmount(0),
    toClubId: getClubId("FC Zurich"),
    fromClubId: getClubId("Juventus"),
    id: 1016,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Livano Comenencia"
},
{
    date: cleanDate("06-08-2025"),
    country: "USA",
    amount: cleanAmount(0),
    toClubId: getClubId("Marseille"),
    fromClubId: getClubId("Juventus"),
    id: 1017,
    position: "Forward",
    type: "Loan",
    player: "Timothy Weah"
},
{
    date: cleanDate("06-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("Chelsea"),
    id: 1018,
    position: "Forward",
    type: "Loan",
    player: "Marc Guiu"
},
{
    date: cleanDate("06-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Swansea"),
    fromClubId: getClubId("West Ham"),
    id: 1019,
    position: "Defender",
    type: "Loan",
    player: "Kaelan Casey"
},
{
    date: cleanDate("06-08-2025"),
    country: "KOR",
    amount: cleanAmount(19500000),
    toClubId: getClubId("Los Angeles FC"),
    fromClubId: getClubId("Tottenham"),
    id: 1020,
    position: "Forward",
    type: "Paid",
    player: "Son Heung-min"
},
{
    date: cleanDate("06-08-2025"),
    country: "COL",
    amount: cleanAmount(0),
    toClubId: getClubId("Pisa"),
    fromClubId: getClubId("Atalanta"),
    id: 1021,
    position: "Defender",
    type: "Free",
    player: "Juan Cuadrado"
},
{
    date: cleanDate("06-08-2025"),
    country: "FRA",
    amount: cleanAmount(23000000),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Chelsea"),
    id: 1022,
    position: "Midfielder",
    type: "Paid",
    player: "Lesley Ugochukwu"
},
{
    date: cleanDate("07-08-2025"),
    country: "JPN",
    amount: cleanAmount(17000000),
    toClubId: getClubId("Eintracht Frankfurt"),
    fromClubId: getClubId("Freiburg"),
    id: 1023,
    position: "Forward",
    type: "Paid",
    player: "Ritsu Doan"
},
{
    date: cleanDate("07-08-2025"),
    country: "GER",
    amount: cleanAmount(1750000),
    toClubId: getClubId("Birmingham City"),
    fromClubId: getClubId("Werder Bremen"),
    id: 1024,
    position: "Forward",
    type: "Paid",
    player: "Marvin Ducksch"
},
{
    date: cleanDate("07-08-2025"),
    country: "SVK",
    amount: cleanAmount(0),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Newcastle"),
    id: 1025,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Martin Dubravka"
},
{
    date: cleanDate("07-08-2025"),
    country: "NIR",
    amount: cleanAmount(0),
    toClubId: getClubId("Blackpool"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 1026,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Dale Taylor"
},
{
    date: cleanDate("07-08-2025"),
    country: "COM",
    amount: cleanAmount(0),
    toClubId: getClubId("Hamburg"),
    fromClubId: getClubId("Rennes"),
    id: 1027,
    position: "Defender",
    type: "Loan",
    player: "Warmed Omari"
},
{
    date: cleanDate("07-08-2025"),
    country: "JAM",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("West Ham"),
    id: 1028,
    position: "Forward",
    type: "Released",
    player: "Michail Antonio"
},
{
    date: cleanDate("07-08-2025"),
    country: "DOM",
    amount: cleanAmount(0),
    toClubId: getClubId("Alavés"),
    fromClubId: getClubId("Free agent"),
    id: 1029,
    position: "Forward",
    type: "Released",
    player: "Mariano Díaz"
},
{
    date: cleanDate("07-08-2025"),
    country: "GHA",
    amount: cleanAmount(0),
    toClubId: getClubId("Villarreal"),
    fromClubId: getClubId("Arsenal"),
    id: 1030,
    position: "Midfielder",
    type: "Free",
    player: "Thomas Partey"
},
{
    date: cleanDate("07-08-2025"),
    country: "SWE",
    amount: cleanAmount(0),
    toClubId: getClubId("Ipswich Town"),
    fromClubId: getClubId("Napoli"),
    id: 1031,
    position: "Midfielder",
    type: "Loan",
    player: "Jens Cajuste"
},
{
    date: cleanDate("07-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Accrington"),
    fromClubId: getClubId("Burnley"),
    id: 1032,
    position: "Defender",
    type: "Loan",
    player: "Logan Pye"
},
{
    date: cleanDate("07-08-2025"),
    country: "BEL",
    amount: cleanAmount(4340000),
    toClubId: getClubId("Trabzonspor"),
    fromClubId: getClubId("Rennes"),
    id: 1033,
    position: "Winger",
    type: "Paid",
    player: "Kazeem Olaigbe"
},
{
    date: cleanDate("07-08-2025"),
    country: "ANG",
    amount: cleanAmount(0),
    toClubId: getClubId("Pisa"),
    fromClubId: getClubId("Fiorentina"),
    id: 1034,
    position: "Forward",
    type: "Loan",
    player: "M\u2019Bala Nzola"
},
{
    date: cleanDate("07-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Elche"),
    fromClubId: getClubId("Cádiz"),
    id: 1035,
    position: "Defender",
    type: "Loan",
    player: "Víctor Chust"
},
{
    date: cleanDate("07-08-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Torino"),
    fromClubId: getClubId("Napoli"),
    id: 1036,
    position: "Forward",
    type: "Loan",
    player: "Giovanni Simeone"
},
{
    date: cleanDate("07-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Modena"),
    fromClubId: getClubId("Cremonese"),
    id: 1037,
    position: "Winger",
    type: "Loan",
    player: "Luca Zanimacchia"
},
{
    date: cleanDate("07-08-2025"),
    country: "FRA",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Valencia"),
    fromClubId: getClubId("Rennes"),
    id: 1038,
    position: "Midfielder",
    type: "Paid",
    player: "Baptiste Santamaria"
},
{
    date: cleanDate("07-08-2025"),
    country: "LUX",
    amount: cleanAmount(350000),
    toClubId: getClubId("Heracles Almelo"),
    fromClubId: getClubId("Borussia Mönchengladbach"),
    id: 1039,
    position: "Midfielder",
    type: "Paid",
    player: "Yvandro Borges Sanches"
},
{
    date: cleanDate("07-08-2025"),
    country: "CMR",
    amount: cleanAmount(0),
    toClubId: getClubId("Montpellier"),
    fromClubId: getClubId("Marseille"),
    id: 1040,
    position: "Goalkeeper",
    type: "Free",
    player: "Simon Ngapandouetnbu"
},
{
    date: cleanDate("07-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Cádiz"),
    fromClubId: getClubId("Osasuna"),
    id: 1041,
    position: "Defender",
    type: "Free",
    player: "Jorge Moreno"
},
{
    date: cleanDate("08-08-2025"),
    country: "CIV",
    amount: cleanAmount(30500000),
    toClubId: getClubId("Aston Villa"),
    fromClubId: getClubId("Nice"),
    id: 1042,
    position: "Forward",
    type: "Paid",
    player: "Evann Guessand"
},
{
    date: cleanDate("08-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Preston"),
    fromClubId: getClubId("Tottenham"),
    id: 1043,
    position: "Midfielder",
    type: "Loan",
    player: "Alfie Devine"
},
{
    date: cleanDate("08-08-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Girona"),
    fromClubId: getClubId("Manchester City"),
    id: 1044,
    position: "Defender",
    type: "Loan",
    player: "Vitor Reis"
},
{
    date: cleanDate("08-08-2025"),
    country: "FRA",
    amount: cleanAmount(5000000),
    toClubId: getClubId("Lens"),
    fromClubId: getClubId("Udinese"),
    id: 1045,
    position: "Winger",
    type: "Paid",
    player: "Florian Thauvin"
},
{
    date: cleanDate("08-08-2025"),
    country: "KOR",
    amount: cleanAmount(0),
    toClubId: getClubId("Portsmouth"),
    fromClubId: getClubId("Tottenham"),
    id: 1046,
    position: "Winger",
    type: "Loan",
    player: "Yang Min-hyeok"
},
{
    date: cleanDate("08-08-2025"),
    country: "ALB",
    amount: cleanAmount(20000000),
    toClubId: getClubId("Burnley"),
    fromClubId: getClubId("Chelsea"),
    id: 1047,
    position: "Forward",
    type: "Paid",
    player: "Armando Broja"
},
{
    date: cleanDate("07-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Alverca"),
    fromClubId: getClubId("Espanyol"),
    id: 1048,
    position: "Defender",
    type: "Free",
    player: "Sergi Gómez"
},
{
    date: cleanDate("08-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Zaragoza"),
    fromClubId: getClubId("Girona"),
    id: 1049,
    position: "Defender",
    type: "Free",
    player: "Valery Fernández"
},
{
    date: cleanDate("08-08-2025"),
    country: "KOS",
    amount: cleanAmount(0),
    toClubId: getClubId("Fortuna Düsseldorf"),
    fromClubId: getClubId("Freiburg"),
    id: 1050,
    position: "Midfielder",
    type: "Loan",
    player: "Florent Muslija"
},
{
    date: cleanDate("08-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Watford"),
    fromClubId: getClubId("Manchester City"),
    id: 1051,
    position: "Defender",
    type: "Loan",
    player: "Max Alleyne"
},
{
    date: cleanDate("08-08-2025"),
    country: "HUN",
    amount: cleanAmount(0),
    toClubId: getClubId("Ferencvaros"),
    fromClubId: getClubId("Eintracht Frankfurt"),
    id: 1052,
    position: "Midfielder",
    type: "Loan",
    player: "Krisztian Lisztes"
},
{
    date: cleanDate("08-08-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Nuremberg"),
    fromClubId: getClubId("Augsburg"),
    id: 1053,
    position: "Defender",
    type: "Loan",
    player: "Henri Koudossou"
},
{
    date: cleanDate("08-08-2025"),
    country: "JPN",
    amount: cleanAmount(9000000),
    toClubId: getClubId("Ajax"),
    fromClubId: getClubId("Borussia Mönchengladbach"),
    id: 1054,
    position: "Defender",
    type: "Paid",
    player: "Ko Itakura"
},
{
    date: cleanDate("08-08-2025"),
    country: "FIN",
    amount: cleanAmount(2600000),
    toClubId: getClubId("Monaco"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 1055,
    position: "Goalkeeper",
    type: "Paid",
    player: "Lukas Hradecky"
},
{
    date: cleanDate("05-08-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Botafogo"),
    fromClubId: getClubId("Bournemouth"),
    id: 1056,
    position: "Goalkeeper",
    type: "Free",
    player: "Neto"
},
{
    date: cleanDate("08-08-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Atlético Mineiro"),
    fromClubId: getClubId("Real Madrid"),
    id: 1057,
    position: "Midfielder",
    type: "Free",
    player: "Reinier Jesus"
},
{
    date: cleanDate("08-08-2025"),
    country: "URU",
    amount: cleanAmount(0),
    toClubId: getClubId("Mirandés"),
    fromClubId: getClubId("Real Betis"),
    id: 1058,
    position: "Forward",
    type: "Loan",
    player: "Gonzalo Petit"
},
{
    date: cleanDate("08-08-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Casa Pia"),
    fromClubId: getClubId("Lille"),
    id: 1059,
    position: "Winger",
    type: "Loan",
    player: "Tiago Morais"
},
{
    date: cleanDate("08-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Lille"),
    fromClubId: getClubId("Real Betis"),
    id: 1060,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Romain Perraud"
},
{
    date: cleanDate("08-08-2025"),
    country: "SUI",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Valencia"),
    fromClubId: getClubId("Young Boys"),
    id: 1061,
    position: "Midfielder",
    type: "Paid",
    player: "Filip Ugrinic"
},
{
    date: cleanDate("08-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Bari"),
    fromClubId: getClubId("Parma"),
    id: 1062,
    position: "Forward",
    type: "Loan",
    player: "Anthony Partipilo"
},
{
    date: cleanDate("09-08-2025"),
    country: "TOG",
    amount: cleanAmount(0),
    toClubId: getClubId("Lorient"),
    fromClubId: getClubId("Lommel SK"),
    id: 1063,
    position: "Midfielder",
    type: "Loan",
    player: "Dermane Karim"
},
{
    date: cleanDate("09-08-2025"),
    country: "TUR",
    amount: cleanAmount(0),
    toClubId: getClubId("Cologne"),
    fromClubId: getClubId("Valencia"),
    id: 1064,
    position: "Defender",
    type: "Loan",
    player: "Cenk Özkacar"
},
{
    date: cleanDate("09-08-2025"),
    country: "SLO",
    amount: cleanAmount(73700000),
    toClubId: getClubId("Manchester United"),
    fromClubId: getClubId("RB Leipzig"),
    id: 1065,
    position: "Forward",
    type: "Paid",
    player: "Benjamin Sesko"
},
{
    date: cleanDate("09-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Mallorca"),
    fromClubId: getClubId("Leeds United"),
    id: 1066,
    position: "Forward",
    type: "Loan",
    player: "Mateo Joseph"
},
{
    date: cleanDate("09-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Racing Santander"),
    fromClubId: getClubId("Alavés"),
    id: 1067,
    position: "Forward",
    type: "Loan",
    player: "Asier Villalibre"
},
{
    date: cleanDate("09-08-2025"),
    country: "POL",
    amount: cleanAmount(0),
    toClubId: getClubId("Brest"),
    fromClubId: getClubId("Monaco"),
    id: 1068,
    position: "Goalkeeper",
    type: "Loan",
    player: "Radoslaw Majecki"
},
{
    date: cleanDate("09-08-2025"),
    country: "DEN",
    amount: cleanAmount(18000000),
    toClubId: getClubId("West Ham"),
    fromClubId: getClubId("Leicester City"),
    id: 1069,
    position: "Goalkeeper",
    type: "Paid",
    player: "Mads Hermansen"
},
{
    date: cleanDate("09-08-2025"),
    country: "DEN",
    amount: cleanAmount(13000000),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Nordsjælland"),
    id: 1070,
    position: "Defender",
    type: "Paid",
    player: "Lucas Høgsberg"
},
{
    date: cleanDate("09-08-2025"),
    country: "INA",
    amount: cleanAmount(0),
    toClubId: getClubId("Sassuolo"),
    fromClubId: getClubId("Venezia"),
    id: 1071,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Jay Idzes"
},
{
    date: cleanDate("09-08-2025"),
    country: "MLI",
    amount: cleanAmount(0),
    toClubId: getClubId("Nantes"),
    fromClubId: getClubId("Sturm Graz"),
    id: 1072,
    position: "Forward",
    type: "Loan",
    player: "Amady Camara"
},
{
    date: cleanDate("09-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Hull City"),
    fromClubId: getClubId("Leeds United"),
    id: 1073,
    position: "Forward",
    type: "Loan",
    player: "Joe Gelhardt"
},
{
    date: cleanDate("09-08-2025"),
    country: "FRA",
    amount: cleanAmount(25900000),
    toClubId: getClubId("Al-Ahli"),
    fromClubId: getClubId("Stuttgart"),
    id: 1074,
    position: "Midfielder",
    type: "Paid",
    player: "Enzo Millot"
},
{
    date: cleanDate("09-08-2025"),
    country: "FRA",
    amount: cleanAmount(47600000),
    toClubId: getClubId("Paris Saint-Germain"),
    fromClubId: getClubId("Lille"),
    id: 1075,
    position: "Goalkeeper",
    type: "Paid",
    player: "Lucas Chevalier"
},
{
    date: cleanDate("09-08-2025"),
    country: "URU",
    amount: cleanAmount(46000000),
    toClubId: getClubId("Al-Hilal"),
    fromClubId: getClubId("Liverpool"),
    id: 1076,
    position: "Forward",
    type: "Paid",
    player: "Darwin Núñez"
},
{
    date: cleanDate("09-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Al-Nassr"),
    fromClubId: getClubId("Barcelona"),
    id: 1077,
    position: "Defender",
    type: "Free",
    player: "Iñigo Martínez"
},
{
    date: cleanDate("10-08-2025"),
    country: "GBS",
    amount: cleanAmount(3000000),
    toClubId: getClubId("Sassuolo"),
    fromClubId: getClubId("Venezia"),
    id: 1078,
    position: "Defender",
    type: "Paid",
    player: "Fali Candé"
},
{
    date: cleanDate("10-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Lecce"),
    fromClubId: getClubId("Fiorentina"),
    id: 1079,
    position: "Winger",
    type: "Loan",
    player: "Riccardo Sottil"
},
{
    date: cleanDate("10-08-2025"),
    country: "NED",
    amount: cleanAmount(0),
    toClubId: getClubId("Valencia"),
    fromClubId: getClubId("Villarreal"),
    id: 1080,
    position: "Winger",
    type: "Free ",
    player: "Arnaut Danjuma"
},
{
    date: cleanDate("10-08-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Pisa"),
    fromClubId: getClubId("Rennes"),
    id: 1081,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Henrik Meister"
},
{
    date: cleanDate("10-08-2025"),
    country: "COD",
    amount: cleanAmount(0),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("Beşiktaş"),
    id: 1082,
    position: "Defender",
    type: "Free",
    player: "Arthur Masuaku"
},
{
    date: cleanDate("11-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Livorno"),
    fromClubId: getClubId("Napoli"),
    id: 1083,
    position: "Winger",
    type: "Loan",
    player: "Antonio Cioffi"
},
{
    date: cleanDate("11-08-2025"),
    country: "AUS",
    amount: cleanAmount(0),
    toClubId: getClubId("Melbourne Victory"),
    fromClubId: getClubId("Lecce"),
    id: 1084,
    position: "Defender",
    type: "Loan",
    player: "Sebastian Esposito"
},
{
    date: cleanDate("01-07-2025"),
    country: "URU",
    amount: cleanAmount(4350000),
    toClubId: getClubId("Lens"),
    fromClubId: getClubId("Inter"),
    id: 1085,
    position: "Forward",
    type: "Paid",
    player: "Martín Satriano"
},
{
    date: cleanDate("02-06-2025"),
    country: "FRA",
    amount: cleanAmount(2610000),
    toClubId: getClubId("Brest"),
    fromClubId: getClubId("Mainz 05"),
    id: 1086,
    position: "Forward",
    type: "Paid",
    player: "Ludovic Ajorque"
},
{
    date: cleanDate("21-07-2025"),
    country: "FRA",
    amount: cleanAmount(8265000),
    toClubId: getClubId("Rennes"),
    fromClubId: getClubId("Marseille"),
    id: 1087,
    position: "Midfielder",
    type: "Paid",
    player: "Valentin Rongier"
},
{
    date: cleanDate("01-08-2025"),
    country: "FRA",
    amount: cleanAmount(10440000),
    toClubId: getClubId("Rennes"),
    fromClubId: getClubId("Brest"),
    id: 1088,
    position: "Defender",
    type: "Paid",
    player: "Lilian Brassier"
},
{
    date: cleanDate("30-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("FC Utrecht"),
    fromClubId: getClubId("Lorient"),
    id: 1089,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Yoann Cathline"
},
{
    date: cleanDate("09-08-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Stuttgart"),
    fromClubId: getClubId("RB Leipzig"),
    id: 1090,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Nuha Jatta"
},
{
    date: cleanDate("11-08-2025"),
    country: "GER",
    amount: cleanAmount(1740000),
    toClubId: getClubId("Bayer Leverkusen"),
    fromClubId: getClubId("RB Leipzig"),
    id: 1091,
    position: "Goalkeeper",
    type: "Paid",
    player: "Janis Blaswich"
},
{
    date: cleanDate("11-08-2025"),
    country: "AUS",
    amount: cleanAmount(0),
    toClubId: getClubId("Port Vale"),
    fromClubId: getClubId("Aston Villa"),
    id: 1092,
    position: "Goalkeeper",
    type: "Loan",
    player: "Joe Gauci"
},
{
    date: cleanDate("02-07-2025"),
    country: "ITA",
    amount: cleanAmount(14620000),
    toClubId: getClubId("Lazio"),
    fromClubId: getClubId("Juventus"),
    id: 1093,
    position: "Midfielder",
    type: "Paid",
    player: "Nicolò Rovella"
},
{
    date: cleanDate("02-07-2025"),
    country: "ITA",
    amount: cleanAmount(3440000),
    toClubId: getClubId("Lazio"),
    fromClubId: getClubId("Juventus"),
    id: 1094,
    position: "Defender",
    type: "Paid",
    player: "Luca Pellegrini"
},
{
    date: cleanDate("03-07-2025"),
    country: "ITA",
    amount: cleanAmount(8600000),
    toClubId: getClubId("Atalanta"),
    fromClubId: getClubId("Frosinone"),
    id: 1095,
    position: "Defender",
    type: "Paid",
    player: "Marco Brescianini"
},
{
    date: cleanDate("11-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Carrarese"),
    fromClubId: getClubId("Verona"),
    id: 1096,
    position: "Defender",
    type: "Loan",
    player: "Nicolò Calabrese"
},
{
    date: cleanDate("03-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Lazio"),
    fromClubId: getClubId("Marseille"),
    id: 1097,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Samuel Gigot"
},
{
    date: cleanDate("03-07-2025"),
    country: "NOR",
    amount: cleanAmount(3000000),
    toClubId: getClubId("Torino"),
    fromClubId: getClubId("Feyenoord"),
    id: 1098,
    position: "Midfielder",
    type: "Paid",
    player: "Marcus Pedersen"
},
{
    date: cleanDate("11-08-2025"),
    country: "ITA",
    amount: cleanAmount(18920000),
    toClubId: getClubId("Atlético Madrid"),
    fromClubId: getClubId("Napoli"),
    id: 1099,
    position: "Forward",
    type: "Paid",
    player: "Giacomo Raspadori"
},
{
    date: cleanDate("10-07-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Pescara"),
    fromClubId: getClubId("Bologna"),
    id: 1100,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Gianmarco Cangiano"
},
{
    date: cleanDate("30-06-2025"),
    country: "BEL",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Como"),
    fromClubId: getClubId("Red Bull Salzburg"),
    id: 1101,
    position: "Defender",
    type: "Paid",
    player: "Ignace Van der Brempt"
},
{
    date: cleanDate("02-07-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Verona"),
    fromClubId: getClubId("Lausanne"),
    id: 1102,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Antoine Bernede"
},
{
    date: cleanDate("05-08-2025"),
    country: "POL",
    amount: cleanAmount(0),
    toClubId: getClubId("Rennes"),
    fromClubId: getClubId("Galatasaray"),
    id: 1103,
    position: "Defender",
    type: "Loan",
    player: "Przemyslaw Frankowski"
},
{
    date: cleanDate("08-08-2025"),
    country: "GAB",
    amount: cleanAmount(0),
    toClubId: getClubId("Lusitânia Lourosa"),
    fromClubId: getClubId("Rennes"),
    id: 1104,
    position: "Forward",
    type: "Free",
    player: "Alan Do Marcolino"
},
{
    date: cleanDate("11-08-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Zaragoza"),
    fromClubId: getClubId("Alavés"),
    id: 1105,
    position: "Goalkeeper",
    type: "Loan",
    player: "Adrián Rodríguez"
},
{
    date: cleanDate("11-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cremonese"),
    fromClubId: getClubId("Milan"),
    id: 1106,
    position: "Defender",
    type: "Loan",
    player: "Filippo Terracciano"
},
{
    date: cleanDate("04-07-2025"),
    country: "JPN",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Arsenal"),
    id: 1107,
    position: "Defender",
    type: "Released",
    player: "Takehiro Tomiyasu"
},
{
    date: cleanDate("21-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Brentford"),
    fromClubId: getClubId("Aston Villa"),
    id: 1108,
    position: "Forward",
    type: "Free",
    player: "Kyrie Pierre"
},
{
    date: cleanDate("30-06-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Dundee"),
    fromClubId: getClubId("Brentford"),
    id: 1109,
    position: "Winger",
    type: "Loan",
    player: "Tony Yogane"
},
{
    date: cleanDate("22-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Feyenoord"),
    fromClubId: getClubId("Brentford"),
    id: 1110,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Emeka Peters"
},
{
    date: cleanDate("29-06-2025"),
    country: "SWE",
    amount: cleanAmount(750000),
    toClubId: getClubId("Brighton"),
    fromClubId: getClubId("Eintracht Frankfurt"),
    id: 1111,
    position: "Goalkeeper",
    type: "Paid",
    player: "Nils Ramming"
},
{
    date: cleanDate("01-08-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Brighton"),
    fromClubId: getClubId("Dundalk"),
    id: 1112,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Sean Keogh"
},
{
    date: cleanDate("01-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Brighton"),
    fromClubId: getClubId("Bristol Rovers"),
    id: 1113,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Kofi Shaw"
},
{
    date: cleanDate("31-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Stockport County"),
    fromClubId: getClubId("Burnley"),
    id: 1114,
    position: "Defender",
    type: "Loan",
    player: "Owen Dodgson"
},
{
    date: cleanDate("31-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Chelsea"),
    fromClubId: getClubId("Crystal Palace"),
    id: 1115,
    position: "Winger",
    type: "Undisclosed Paid",
    player: "Jesse Derry"
},
{
    date: cleanDate("23-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("WSG Tirol"),
    fromClubId: getClubId("Crystal Palace"),
    id: 1116,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Ademola Ola-Adebomi"
},
{
    date: cleanDate("30-07-2025"),
    country: "CAN",
    amount: cleanAmount(0),
    toClubId: getClubId("FCV Dender"),
    fromClubId: getClubId("Fulham"),
    id: 1117,
    position: "Defender",
    type: "Loan",
    player: "Luc De Fougerolles"
},
{
    date: cleanDate("25-07-2025"),
    country: "NGR",
    amount: cleanAmount(0),
    toClubId: getClubId("FCV Dender"),
    fromClubId: getClubId("Brentford"),
    id: 1118,
    position: "Defender",
    type: "Loan",
    player: "Benjamin Frederick"
},
{
    date: cleanDate("01-08-2025"),
    country: "NOR",
    amount: cleanAmount(0),
    toClubId: getClubId("HamKam"),
    fromClubId: getClubId("Aston Villa"),
    id: 1119,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Ethan Amundsen-Day"
},
{
    date: cleanDate("11-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Shrewsbury Town"),
    fromClubId: getClubId("Burnley"),
    id: 1120,
    position: "Midfielder",
    type: "Loan",
    player: "Tommy McDermott"
},
{
    date: cleanDate("11-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Spezia"),
    fromClubId: getClubId("Parma"),
    id: 1121,
    position: "Midfielder",
    type: "Loan",
    player: "Rachid Kouda"
},
{
    date: cleanDate("11-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Genoa"),
    fromClubId: getClubId("Milan"),
    id: 1122,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Salem Albè"
},
{
    date: cleanDate("12-08-2025"),
    country: "NED",
    amount: cleanAmount(8700000),
    toClubId: getClubId("Bayer Leverkusen"),
    fromClubId: getClubId("AZ Alkmaar"),
    id: 1123,
    position: "Winger",
    type: "Paid",
    player: "Ernest Poku"
},
{
    date: cleanDate("12-08-2025"),
    country: "UKR",
    amount: cleanAmount(54810000),
    toClubId: getClubId("Paris Saint-Germain"),
    fromClubId: getClubId("Bournemouth"),
    id: 1124,
    position: "Defender",
    type: "Paid",
    player: "Illia Zabarnyi"
},
{
    date: cleanDate("12-08-2025"),
    country: "ESP",
    amount: cleanAmount(1305000),
    toClubId: getClubId("Celta Vigo"),
    fromClubId: getClubId("Real Betis"),
    id: 1125,
    position: "Forward",
    type: "Paid",
    player: "Borja Iglesias"
},
{
    date: cleanDate("12-08-2025"),
    country: "GRE",
    amount: cleanAmount(0),
    toClubId: getClubId("Sevilla"),
    fromClubId: getClubId("Newcastle"),
    id: 1126,
    position: "Goalkeeper",
    type: "Loan",
    player: "Odysseas Vlachodimos"
},
{
    date: cleanDate("12-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Como"),
    fromClubId: getClubId("Milan"),
    id: 1127,
    position: "Forward",
    type: "Loan",
    player: "Álvaro Morata"
},
{
    date: cleanDate("12-08-2025"),
    country: "PAR",
    amount: cleanAmount(10000000),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("Getafe"),
    id: 1128,
    position: "Defender",
    type: "Paid",
    player: "Omar Alderete"
},
{
    date: cleanDate("12-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Everton"),
    fromClubId: getClubId("Manchester City"),
    id: 1129,
    position: "Winger",
    type: "Loan",
    player: "Jack Grealish"
},
{
    date: cleanDate("12-08-2025"),
    country: "ROU",
    amount: cleanAmount(7400000),
    toClubId: getClubId("PSV Eindhoven"),
    fromClubId: getClubId("Parma"),
    id: 1130,
    position: "Winger",
    type: "Paid",
    player: "Dennis Man"
},
{
    date: cleanDate("12-08-2025"),
    country: "GER",
    amount: cleanAmount(34600000),
    toClubId: getClubId("Newcastle"),
    fromClubId: getClubId("Milan"),
    id: 1131,
    position: "Defender",
    type: "Paid",
    player: "Malick Thiaw"
},
{
    date: cleanDate("13-08-2025"),
    country: "FRA",
    amount: cleanAmount(34500000),
    toClubId: getClubId("Bournemouth"),
    fromClubId: getClubId("Lille"),
    id: 1132,
    position: "Defender",
    type: "Paid",
    player: "Bafodé Diakité"
},
{
    date: cleanDate("13-08-2025"),
    country: "KOS",
    amount: cleanAmount(0),
    toClubId: getClubId("Sassuolo"),
    fromClubId: getClubId("Ipswich Town"),
    id: 1133,
    position: "Goalkeeper",
    type: "Loan",
    player: "Arijanet Muric"
},
{
    date: cleanDate("12-08-2025"),
    country: "SCO",
    amount: cleanAmount(4750000),
    toClubId: getClubId("Udinese"),
    fromClubId: getClubId("Motherwell"),
    id: 1134,
    position: "Midfielder",
    type: "Paid",
    player: "Lennon Miller"
},
{
    date: cleanDate("12-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cagliari"),
    fromClubId: getClubId("Inter"),
    id: 1135,
    position: "Forward",
    type: "Loan",
    player: "Sebastiano Esposito"
},
{
    date: cleanDate("11-08-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Arouca"),
    fromClubId: getClubId("Leeds United"),
    id: 1136,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Diogo Monteiro"
},
{
    date: cleanDate("12-08-2025"),
    country: "BEL",
    amount: cleanAmount(0),
    toClubId: getClubId("Girona"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 1137,
    position: "Defender",
    type: "Free",
    player: "Axel Witsel"
},
{
    date: cleanDate("12-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Castellón"),
    fromClubId: getClubId("Celta Vigo"),
    id: 1138,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Tincho Conde"
},
{
    date: cleanDate("12-08-2025"),
    country: "NED",
    amount: cleanAmount(1300000),
    toClubId: getClubId("Rayo Vallecano"),
    fromClubId: getClubId("Castellón"),
    id: 1139,
    position: "Defender",
    type: "Paid",
    player: "Jozhua Vertrouwd"
},
{
    date: cleanDate("12-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Virtus Entella"),
    fromClubId: getClubId("Genoa"),
    id: 1140,
    position: "Forward",
    type: "Loan",
    player: "Alessandro Debenedetti"
},
{
    date: cleanDate("12-08-2025"),
    country: "CZE",
    amount: cleanAmount(0),
    toClubId: getClubId("Lyon"),
    fromClubId: getClubId("Sparta Prague"),
    id: 1141,
    position: "Midfielder",
    type: "Loan",
    player: "Adam Karabec"
},
{
    date: cleanDate("13-08-2025"),
    country: "NED",
    amount: cleanAmount(6900000),
    toClubId: getClubId("Cologne"),
    fromClubId: getClubId("Middlesbrough"),
    id: 1142,
    position: "Defender",
    type: "Paid",
    player: "Rav van den Berg"
},
{
    date: cleanDate("12-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cremonese"),
    fromClubId: getClubId("Milan"),
    id: 1143,
    position: "Midfielder",
    type: "Loan",
    player: "Warren Bondo"
},
{
    date: cleanDate("11-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Monza"),
    fromClubId: getClubId("Cremonese"),
    id: 1144,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Luca Ravanelli"
},
{
    date: cleanDate("11-08-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Monza"),
    fromClubId: getClubId("Cremonese"),
    id: 1145,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Paulo Azzi"
},
{
    date: cleanDate("06-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Moreirense"),
    fromClubId: getClubId("Arsenal"),
    id: 1146,
    position: "Midfielder",
    type: "Free",
    player: "Jimi Gower"
},
{
    date: cleanDate("04-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Dundee"),
    fromClubId: getClubId("Brentford"),
    id: 1147,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Ashley Hay"
},
{
    date: cleanDate("13-08-2025"),
    country: "NOR",
    amount: cleanAmount(6900000),
    toClubId: getClubId("Parma"),
    fromClubId: getClubId("FC Midtjylland"),
    id: 1148,
    position: "Midfielder",
    type: "Paid",
    player: "Oliver Sørensen"
},
{
    date: cleanDate("05-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Dundee"),
    fromClubId: getClubId("Burnley"),
    id: 1149,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Joe Westley"
},
{
    date: cleanDate("28-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Burnley"),
    id: 1150,
    position: "Midfielder",
    type: "Released",
    player: "Josh Brownhill"
},
{
    date: cleanDate("23-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Plymouth Argyle"),
    fromClubId: getClubId("Fulham"),
    id: 1151,
    position: "Goalkeeper",
    type: "Free",
    player: "Luca Ashby-Hammond"
},
{
    date: cleanDate("13-08-2025"),
    country: "BEL",
    amount: cleanAmount(17250000),
    toClubId: getClubId("Milan"),
    fromClubId: getClubId("Genoa"),
    id: 1152,
    position: "Defender",
    type: "Paid",
    player: "Koni De Winter"
},
{
    date: cleanDate("13-08-2025"),
    country: "SWE",
    amount: cleanAmount(0),
    toClubId: getClubId("Nantes"),
    fromClubId: getClubId("AZ Alkmaar"),
    id: 1153,
    position: "Winger",
    type: "Loan",
    player: "Mayckel Lahdo"
},
{
    date: cleanDate("14-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Oviedo"),
    fromClubId: getClubId("Free agent"),
    id: 1154,
    position: "Winger",
    type: "Released",
    player: "Ovie Ejaria"
},
{
    date: cleanDate("13-08-2025"),
    country: "FRA",
    amount: cleanAmount(6900000),
    toClubId: getClubId("Rennes"),
    fromClubId: getClubId("Brest"),
    id: 1155,
    position: "Midfielder",
    type: "Paid",
    player: "Mahdi Camara"
},
{
    date: cleanDate("13-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Carrarese"),
    fromClubId: getClubId("Lazio"),
    id: 1156,
    position: "Defender",
    type: "Free",
    player: "Fabio Ruggeri"
},
{
    date: cleanDate("13-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Juve Stabia"),
    fromClubId: getClubId("Torino"),
    id: 1157,
    position: "Winger",
    type: "Loan",
    player: "Alessio Cacciamani"
},
{
    date: cleanDate("13-08-2025"),
    country: "GUI",
    amount: cleanAmount(0),
    toClubId: getClubId("Bolton"),
    fromClubId: getClubId("Toulouse"),
    id: 1158,
    position: "Winger",
    type: "Loan",
    player: "Ibrahim Cissoko "
},
{
    date: cleanDate("13-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Cremonese"),
    fromClubId: getClubId("Empoli"),
    id: 1159,
    position: "Goalkeeper",
    type: "Free",
    player: "Marco Silvestri"
},
{
    date: cleanDate("14-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Saint-Etienne"),
    fromClubId: getClubId("Sunderland"),
    id: 1160,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Pierre Ekwah"
},
{
    date: cleanDate("14-08-2025"),
    country: "ARG",
    amount: cleanAmount(2000000),
    toClubId: getClubId("Elche"),
    fromClubId: getClubId("Inter Miami"),
    id: 1161,
    position: "Midfielder",
    type: "Paid",
    player: "Federico Redondo"
},
{
    date: cleanDate("14-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Dundee United"),
    fromClubId: getClubId("Liverpool"),
    id: 1162,
    position: "Midfielder",
    type: "Loan",
    player: "Luca Stephenson"
},
{
    date: cleanDate("14-08-2025"),
    country: "CIV",
    amount: cleanAmount(0),
    toClubId: getClubId("Swansea"),
    fromClubId: getClubId("Brighton"),
    id: 1163,
    position: "Midfielder",
    type: "Loan",
    player: "Malick Yalcouye"
},
{
    date: cleanDate("15-08-2025"),
    country: "BRA",
    amount: cleanAmount(21500000),
    toClubId: getClubId("RB Leipzig"),
    fromClubId: getClubId("Göztepe"),
    id: 1164,
    position: "Forward",
    type: "Paid",
    player: "Rômulo"
},
{
    date: cleanDate("15-08-2025"),
    country: "NOR",
    amount: cleanAmount(10000000),
    toClubId: getClubId("Bologna"),
    fromClubId: getClubId("West Bromwich Albion"),
    id: 1165,
    position: "Defender",
    type: "Paid",
    player: "Torbjørn Heggem"
},
{
    date: cleanDate("15-08-2025"),
    country: "SUI",
    amount: cleanAmount(8600000),
    toClubId: getClubId("Milan"),
    fromClubId: getClubId("Young Boys"),
    id: 1166,
    position: "Defender",
    type: "Paid",
    player: "Zachary Athekame"
},
{
    date: cleanDate("14-08-2025"),
    country: "GHA",
    amount: cleanAmount(2150000),
    toClubId: getClubId("Nice"),
    fromClubId: getClubId("Lens"),
    id: 1167,
    position: "Midfielder",
    type: "Paid",
    player: "Salis Abdul Samed"
},
{
    date: cleanDate("15-08-2025"),
    country: "ESP",
    amount: cleanAmount(860000),
    toClubId: getClubId("Rayo Vallecano"),
    fromClubId: getClubId("Valencia"),
    id: 1168,
    position: "Winger",
    type: "Paid",
    player: "Fran Pérez"
},
{
    date: cleanDate("15-08-2025"),
    country: "NED",
    amount: cleanAmount(0),
    toClubId: getClubId("Sparta Rotterdam"),
    fromClubId: getClubId("Burnley"),
    id: 1169,
    position: "Defender",
    type: "Loan",
    player: "Shurandy Sambo"
},
{
    date: cleanDate("15-08-2025"),
    country: "ITA",
    amount: cleanAmount(26000000),
    toClubId: getClubId("Liverpool"),
    fromClubId: getClubId("Parma"),
    id: 1170,
    position: "Defender",
    type: "Paid",
    player: "Giovanni Leoni"
},
{
    date: cleanDate("15-08-2025"),
    country: "CRO",
    amount: cleanAmount(0),
    toClubId: getClubId("Cultural Leonesa"),
    fromClubId: getClubId("Elche"),
    id: 1171,
    position: "Defender",
    type: "Loan",
    player: "Matía Barzic"
},
{
    date: cleanDate("15-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Racing Santander"),
    fromClubId: getClubId("Athletic Club"),
    id: 1172,
    position: "Midfielder",
    type: "Loan",
    player: "Peio Canales"
},
{
    date: cleanDate("15-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("West Bromwich Albion"),
    fromClubId: getClubId("Manchester United"),
    id: 1173,
    position: "Midfielder",
    type: "Loan",
    player: "Toby Collyer"
},
{
    date: cleanDate("15-08-2025"),
    country: "AUT",
    amount: cleanAmount(0),
    toClubId: getClubId("Cercle Brugge"),
    fromClubId: getClubId("Burnley"),
    id: 1174,
    position: "Midfielder",
    type: "Loan",
    player: "Oluwaseun Adewumi"
},
{
    date: cleanDate("14-08-2025"),
    country: "TUR",
    amount: cleanAmount(3870000),
    toClubId: getClubId("Lille"),
    fromClubId: getClubId("Eyupspor"),
    id: 1175,
    position: "Goalkeeper",
    type: "Paid",
    player: "Berke Özer"
},
{
    date: cleanDate("15-08-2025"),
    country: "FRA",
    amount: cleanAmount(21600000),
    toClubId: getClubId("Al-Nassr"),
    fromClubId: getClubId("Bayern Munich"),
    id: 1176,
    position: "Winger",
    type: "Paid",
    player: "Kingsley Coman"
},
{
    date: cleanDate("15-08-2025"),
    country: "COL",
    amount: cleanAmount(0),
    toClubId: getClubId("Vasco da Gama"),
    fromClubId: getClubId("Rennes"),
    id: 1177,
    position: "Winger",
    type: "Loan",
    player: "Andrés Gómez"
},
{
    date: cleanDate("15-08-2025"),
    country: "CRO",
    amount: cleanAmount(8600000),
    toClubId: getClubId("Parma"),
    fromClubId: getClubId("Westerlo"),
    id: 1178,
    position: "Forward",
    type: "Paid",
    player: "Matija Frigan"
},
{
    date: cleanDate("15-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("São Paulo"),
    fromClubId: getClubId("Atalanta"),
    id: 1179,
    position: "Defender",
    type: "Free",
    player: "Rafael Tolói"
},
{
    date: cleanDate("16-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Venezia"),
    fromClubId: getClubId("Parma"),
    id: 1180,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Antoine Hainaut"
},
{
    date: cleanDate("14-08-2025"),
    country: "SRB",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Lyon"),
    id: 1181,
    position: "Midfielder",
    type: "Released",
    player: "Nemanja Matic"
},
{
    date: cleanDate("15-08-2025"),
    country: "SCO",
    amount: cleanAmount(0),
    toClubId: getClubId("Barrow"),
    fromClubId: getClubId("Aston Villa"),
    id: 1182,
    position: "Defender",
    type: "Loan",
    player: "Kerr Smith"
},
{
    date: cleanDate("15-08-2025"),
    country: "WAL",
    amount: cleanAmount(0),
    toClubId: getClubId("Everton"),
    fromClubId: getClubId("Wolves"),
    id: 1183,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Tom King"
},
{
    date: cleanDate("31-07-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Fenerbahçe"),
    fromClubId: getClubId("Wolves"),
    id: 1184,
    position: "Defender",
    type: "Free",
    player: "Nélson Semedo"
},
{
    date: cleanDate("01-07-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Rio Ave"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 1185,
    position: "Defender",
    type: "Free",
    player: "Jonathan Panzo"
},
{
    date: cleanDate("30-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("West Ham"),
    id: 1186,
    position: "Defender",
    type: "Released",
    player: "Kurt Zouma"
},
{
    date: cleanDate("16-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Alavés"),
    fromClubId: getClubId("Mirandés"),
    id: 1187,
    position: "Goalkeeper",
    type: "Free",
    player: "Raúl Fernández"
},
{
    date: cleanDate("03-08-2025"),
    country: "GUI",
    amount: cleanAmount(0),
    toClubId: getClubId("Cultural Leonesa"),
    fromClubId: getClubId("Alavés"),
    id: 1188,
    position: "Midfielder",
    type: "Loan",
    player: "Selu Diallo"
},
{
    date: cleanDate("10-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Alverca"),
    fromClubId: getClubId("Alavés"),
    id: 1189,
    position: "Midfielder",
    type: "Loan",
    player: "Tomás Mendes"
},
{
    date: cleanDate("09-06-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Atlético Madrid"),
    fromClubId: getClubId("Barcelona"),
    id: 1190,
    position: "Defender",
    type: "Free",
    player: "Clément Lenglet"
},
{
    date: cleanDate("09-07-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Tigres UANL"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 1191,
    position: "Forward",
    type: "Free",
    player: "Ángel Correa"
},
{
    date: cleanDate("30-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Atlético Madrid"),
    id: 1192,
    position: "Defender",
    type: "Released",
    player: "César Azpilicueta"
},
{
    date: cleanDate("22-05-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Retired"),
    fromClubId: getClubId("Athletic Club"),
    id: 1193,
    position: "Defender",
    type: "Retired",
    player: "Óscar de Marcos"
},
{
    date: cleanDate("25-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Levante"),
    fromClubId: getClubId("Celta Vigo"),
    id: 1194,
    position: "Defender",
    type: "Loan",
    player: "Manu Sánchez"
},
{
    date: cleanDate("09-07-2025"),
    country: "MAR",
    amount: cleanAmount(0),
    toClubId: getClubId("Pau"),
    fromClubId: getClubId("Espanyol"),
    id: 1195,
    position: "Forward",
    type: "Loan",
    player: "Omar Sadik"
},
{
    date: cleanDate("16-08-2025"),
    country: "ENG",
    amount: cleanAmount(37500000),
    toClubId: getClubId("Nottingham Forest"),
    fromClubId: getClubId("Ipswich Town"),
    id: 1196,
    position: "Winger",
    type: "Paid",
    player: "Omari Hutchinson"
},
{
    date: cleanDate("16-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Bristol City"),
    id: 1197,
    position: "Goalkeeper",
    type: "Free",
    player: "Stefan Bajic"
},
{
    date: cleanDate("16-08-2025"),
    country: "POR",
    amount: cleanAmount(11200000),
    toClubId: getClubId("Stuttgart"),
    fromClubId: getClubId("Wolfsburg"),
    id: 1198,
    position: "Forward",
    type: "Paid",
    player: "Tiago Tomás"
},
{
    date: cleanDate("16-08-2025"),
    country: "SVK",
    amount: cleanAmount(0),
    toClubId: getClubId("Kayserispor"),
    fromClubId: getClubId("Union Berlin"),
    id: 1199,
    position: "Midfielder",
    type: "Loan",
    player: "Laszlo Benes"
},
{
    date: cleanDate("16-08-2025"),
    country: "BUR",
    amount: cleanAmount(42500000),
    toClubId: getClubId("Brentford"),
    fromClubId: getClubId("Bournemouth"),
    id: 1200,
    position: "Winger",
    type: "Paid",
    player: "Dango Ouattara"
},
{
    date: cleanDate("16-08-2025"),
    country: "ENG",
    amount: cleanAmount(30000000),
    toClubId: getClubId("Nottingham Forest"),
    fromClubId: getClubId("Manchester City"),
    id: 1201,
    position: "Midfielder",
    type: "Paid",
    player: "James McAtee"
},
{
    date: cleanDate("17-08-2025"),
    country: "FRA",
    amount: cleanAmount(10350000),
    toClubId: getClubId("Sunderland"),
    fromClubId: getClubId("Paris Saint-Germain"),
    id: 1202,
    position: "Defender",
    type: "Paid",
    player: "Nordi Mukiele"
},
{
    date: cleanDate("17-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Eibar"),
    fromClubId: getClubId("Athletic Club"),
    id: 1203,
    position: "Winger",
    type: "Free ",
    player: "Adu Ares"
},
{
    date: cleanDate("16-08-2025"),
    country: "FRA",
    amount: cleanAmount(7800000),
    toClubId: getClubId("Paris FC"),
    fromClubId: getClubId("St Gallen"),
    id: 1204,
    position: "Forward",
    type: "Paid",
    player: "Willem Geubbels"
},
{
    date: cleanDate("17-08-2025"),
    country: "CMR",
    amount: cleanAmount(860000),
    toClubId: getClubId("Auxerre"),
    fromClubId: getClubId("Porto"),
    id: 1205,
    position: "Forward",
    type: "Loan",
    player: "Danny Namaso"
},
{
    date: cleanDate("17-08-2025"),
    country: "ENG",
    amount: cleanAmount(39000000),
    toClubId: getClubId("Newcastle"),
    fromClubId: getClubId("Aston Villa"),
    id: 1206,
    position: "Midfielder",
    type: "Paid",
    player: "Jacob Ramsey"
},
{
    date: cleanDate("17-08-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Strasbourg"),
    fromClubId: getClubId("Benfica"),
    id: 1207,
    position: "Midfielder",
    type: "Loan",
    player: "Rafael Luís"
},
{
    date: cleanDate("17-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Panathinaikos"),
    fromClubId: getClubId("Milan"),
    id: 1208,
    position: "Defender",
    type: "Free",
    player: "Davide Calabria"
},
{
    date: cleanDate("18-08-2025"),
    country: "FRA",
    amount: cleanAmount(26000000),
    toClubId: getClubId("Nottingham Forest"),
    fromClubId: getClubId("Rennes"),
    id: 1209,
    position: "Forward",
    type: "Paid",
    player: "Arnaud Kalimuendo"
},
{
    date: cleanDate("18-08-2025"),
    country: "CIV",
    amount: cleanAmount(0),
    toClubId: getClubId("FC Utrecht"),
    fromClubId: getClubId("Borussia Dortmund"),
    id: 1210,
    position: "Forward",
    type: "Free",
    player: "Sébastian Haller"
},
{
    date: cleanDate("17-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Elche"),
    fromClubId: getClubId("Sevilla"),
    id: 1211,
    position: "Forward",
    type: "Loan",
    player: "Rafa Mir"
},
{
    date: cleanDate("17-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Rangers"),
    fromClubId: getClubId("Brentford"),
    id: 1212,
    position: "Defender",
    type: "Loan",
    player: "Jayden Meghoma"
},
{
    date: cleanDate("18-08-2025"),
    country: "COD",
    amount: cleanAmount(0),
    toClubId: getClubId("Aris Limassol"),
    fromClubId: getClubId("Lorient"),
    id: 1213,
    position: "Defender",
    type: "Free",
    player: "Gédéon Kalulu"
},
{
    date: cleanDate("18-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Empoli"),
    fromClubId: getClubId("Napoli"),
    id: 1214,
    position: "Defender",
    type: "Loan",
    player: "Nosa Obaretin"
},
{
    date: cleanDate("18-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Empoli"),
    fromClubId: getClubId("Cremonese"),
    id: 1215,
    position: "Forward",
    type: "Loan",
    player: "Marco Nasti"
},
{
    date: cleanDate("18-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Juve Stabia"),
    fromClubId: getClubId("Roma"),
    id: 1216,
    position: "Defender",
    type: "Loan",
    player: "Filippo Reale"
},
{
    date: cleanDate("18-08-2025"),
    country: "POR",
    amount: cleanAmount(900000),
    toClubId: getClubId("Elche"),
    fromClubId: getClubId("RB Leipzig"),
    id: 1217,
    position: "Forward",
    type: "Paid",
    player: "André Silva"
},
{
    date: cleanDate("18-08-2025"),
    country: "SRB",
    amount: cleanAmount(0),
    toClubId: getClubId("Aberdeen"),
    fromClubId: getClubId("Milan"),
    id: 1218,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Marko Lazetic"
},
{
    date: cleanDate("16-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Mansfield Town"),
    fromClubId: getClubId("Brentford"),
    id: 1219,
    position: "Forward",
    type: "Free",
    player: "Max Dickov"
},
{
    date: cleanDate("18-08-2025"),
    country: "CIV",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Oviedo"),
    fromClubId: getClubId("Villarreal"),
    id: 1220,
    position: "Defender",
    type: "Free",
    player: "Eric Bailly"
},
{
    date: cleanDate("18-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Lincoln City"),
    fromClubId: getClubId("Everton"),
    id: 1221,
    position: "Forward",
    type: "Loan",
    player: "Francis Okoronkwo"
},
{
    date: cleanDate("18-08-2025"),
    country: "ALB",
    amount: cleanAmount(0),
    toClubId: getClubId("Mallorca"),
    fromClubId: getClubId("Roma"),
    id: 1222,
    position: "Defender",
    type: "Loan",
    player: "Marash Kumbulla"
},
{
    date: cleanDate("18-08-2025"),
    country: "SCO",
    amount: cleanAmount(25000000),
    toClubId: getClubId("Bournemouth"),
    fromClubId: getClubId("Liverpool"),
    id: 1223,
    position: "Forward",
    type: "Paid",
    player: "Ben Doak"
},
{
    date: cleanDate("18-08-2025"),
    country: "ESP",
    amount: cleanAmount(5200000),
    toClubId: getClubId("Nice"),
    fromClubId: getClubId("Basel"),
    id: 1224,
    position: "Forward",
    type: "Paid",
    player: "Kevin Carlos"
},
{
    date: cleanDate("18-08-2025"),
    country: "SVK",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Lyon"),
    fromClubId: getClubId("Mallorca"),
    id: 1225,
    position: "Goalkeeper",
    type: "Paid",
    player: "Dominik Greif"
},
{
    date: cleanDate("19-08-2025"),
    country: "NOR",
    amount: cleanAmount(0),
    toClubId: getClubId("Middlesbrough"),
    fromClubId: getClubId("Manchester City"),
    id: 1226,
    position: "Midfielder",
    type: "Loan",
    player: "Sverre Nypan"
},
{
    date: cleanDate("19-08-2025"),
    country: "CMR",
    amount: cleanAmount(10800000),
    toClubId: getClubId("Wolves"),
    fromClubId: getClubId("Verona"),
    id: 1227,
    position: "Defender",
    type: "Paid",
    player: "Jackson Tchatchoua"
},
{
    date: cleanDate("18-08-2025"),
    country: "NED",
    amount: cleanAmount(0),
    toClubId: getClubId("Rotherham"),
    fromClubId: getClubId("Everton"),
    id: 1228,
    position: "Forward",
    type: "Loan",
    player: "Martin Sherif"
},
{
    date: cleanDate("05-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Huesca"),
    fromClubId: getClubId("Espanyol"),
    id: 1229,
    position: "Defender",
    type: "Loan",
    player: "Hugo Pérez"
},
{
    date: cleanDate("17-07-2025"),
    country: "CAN",
    amount: cleanAmount(0),
    toClubId: getClubId("Sporting Gijón"),
    fromClubId: getClubId("Espanyol"),
    id: 1230,
    position: "Midfielder",
    type: "Loan",
    player: "Justin Smith"
},
{
    date: cleanDate("30-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Espanyol"),
    id: 1231,
    position: "Goalkeeper",
    type: "Released",
    player: "Fernando Pacheco"
},
{
    date: cleanDate("30-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Getafe"),
    id: 1232,
    position: "Defender",
    type: "Released",
    player: "Juan Bernat"
},
{
    date: cleanDate("30-06-2025"),
    country: "CMR",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Getafe"),
    id: 1233,
    position: "Defender",
    type: "Released",
    player: "Allan Nyom"
},
{
    date: cleanDate("13-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("San Luis"),
    fromClubId: getClubId("Girona"),
    id: 1234,
    position: "Defender",
    type: "Free",
    player: "Juanpe"
},
{
    date: cleanDate("22-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Gimnàstic"),
    fromClubId: getClubId("Girona"),
    id: 1235,
    position: "Goalkeeper",
    type: "Loan",
    player: "Toni Fuidias"
},
{
    date: cleanDate("15-07-2025"),
    country: "KOR",
    amount: cleanAmount(0),
    toClubId: getClubId("FC Andorra"),
    fromClubId: getClubId("Girona"),
    id: 1236,
    position: "Winger",
    type: "Loan",
    player: "Kim Min-su"
},
{
    date: cleanDate("15-08-2025"),
    country: "HUN",
    amount: cleanAmount(0),
    toClubId: getClubId("FC Andorra"),
    fromClubId: getClubId("Girona"),
    id: 1237,
    position: "Defender",
    type: "Loan",
    player: "Antal Yaakobishvili"
},
{
    date: cleanDate("15-07-2025"),
    country: "HUN",
    amount: cleanAmount(0),
    toClubId: getClubId("FC Andorra"),
    fromClubId: getClubId("Barcelona"),
    id: 1238,
    position: "Goalkeeper",
    type: "Loan",
    player: "Aron Yaakobishvili"
},
{
    date: cleanDate("08-08-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("FC Andorra"),
    fromClubId: getClubId("Girona"),
    id: 1239,
    position: "Winger",
    type: "Loan",
    player: "Jastin García"
},
{
    date: cleanDate("09-07-2025"),
    country: "URU",
    amount: cleanAmount(0),
    toClubId: getClubId("Levante"),
    fromClubId: getClubId("Genoa"),
    id: 1240,
    position: "Defender",
    type: "Loan",
    player: "Alan Matturro"
},
{
    date: cleanDate("29-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Valencia"),
    fromClubId: getClubId("Levante"),
    id: 1241,
    position: "Defender",
    type: "Free",
    player: "Marcos Navarro"
},
{
    date: cleanDate("21-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Almería"),
    fromClubId: getClubId("Levante"),
    id: 1242,
    position: "Goalkeeper",
    type: "Free",
    player: "Andrés Fernández"
},
{
    date: cleanDate("21-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Cartagena"),
    fromClubId: getClubId("Levante"),
    id: 1243,
    position: "Midfielder",
    type: "Loan",
    player: "Edgar Alcañiz"
},
{
    date: cleanDate("04-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Retired"),
    fromClubId: getClubId("Levante"),
    id: 1244,
    position: "Midfielder",
    type: "Retired",
    player: "Vicente Iborra"
},
{
    date: cleanDate("12-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Leganés"),
    fromClubId: getClubId("Osasuna"),
    id: 1245,
    position: "Defender",
    type: "Free",
    player: "Rubén Peña"
},
{
    date: cleanDate("03-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Qarabag FK"),
    fromClubId: getClubId("Rayo Vallecano"),
    id: 1246,
    position: "Midfielder",
    type: "Free",
    player: "Joni Montiel"
},
{
    date: cleanDate("21-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Panetolikos"),
    fromClubId: getClubId("Osasuna"),
    id: 1247,
    position: "Defender",
    type: "Free",
    player: "Unai García"
},
{
    date: cleanDate("04-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Córdoba"),
    fromClubId: getClubId("Rayo Vallecano"),
    id: 1248,
    position: "Forward",
    type: "Free",
    player: "Sergi Guardiola"
},
{
    date: cleanDate("07-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Huesca"),
    fromClubId: getClubId("Real Betis"),
    id: 1249,
    position: "Midfielder",
    type: "Loan",
    player: "Sergio Arribas"
},
{
    date: cleanDate("14-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Leixões"),
    fromClubId: getClubId("Rayo Vallecano"),
    id: 1250,
    position: "Goalkeeper",
    type: "Loan",
    player: "Miguel Morro"
},
{
    date: cleanDate("09-07-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Valladolid"),
    fromClubId: getClubId("Real Betis"),
    id: 1251,
    position: "Goalkeeper",
    type: "Loan",
    player: "Guilherme Fernandes"
},
{
    date: cleanDate("16-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Real Madrid"),
    id: 1252,
    position: "Defender",
    type: "Released",
    player: "Lucas Vázquez"
},
{
    date: cleanDate("02-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Zaragoza"),
    fromClubId: getClubId("Real Oviedo"),
    id: 1253,
    position: "Winger",
    type: "Free",
    player: "Paulino de la Fuente"
},
{
    date: cleanDate("31-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Zaragoza"),
    fromClubId: getClubId("Real Oviedo"),
    id: 1254,
    position: "Defender",
    type: "Free",
    player: "Carlos Pomares"
},
{
    date: cleanDate("15-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Cultural Leonesa"),
    fromClubId: getClubId("Real Oviedo"),
    id: 1255,
    position: "Midfielder",
    type: "Free",
    player: "Yayo González"
},
{
    date: cleanDate("01-08-2025"),
    country: "ROU",
    amount: cleanAmount(0),
    toClubId: getClubId("Cultural Leonesa"),
    fromClubId: getClubId("Real Oviedo"),
    id: 1256,
    position: "Forward",
    type: "Loan",
    player: "Daniel Paraschiv"
},
{
    date: cleanDate("30-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Released"),
    fromClubId: getClubId("Real Oviedo"),
    id: 1257,
    position: "Winger",
    type: "Released",
    player: "Francisco Portillo"
},
{
    date: cleanDate("06-06-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Cádiz"),
    fromClubId: getClubId("Sevilla"),
    id: 1258,
    position: "Winger",
    type: "Free",
    player: "Suso"
},
{
    date: cleanDate("08-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Celta Vigo"),
    fromClubId: getClubId("Valencia"),
    id: 1259,
    position: "Winger",
    type: "Free",
    player: "Hugo González"
},
{
    date: cleanDate("04-07-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Mirandés"),
    fromClubId: getClubId("Valencia"),
    id: 1260,
    position: "Defender",
    type: "Loan",
    player: "Iker Córdoba"
},
{
    date: cleanDate("19-08-2025"),
    country: "ALG",
    amount: cleanAmount(1730000),
    toClubId: getClubId("Verona"),
    fromClubId: getClubId("Mechelen"),
    id: 1261,
    position: "Defender",
    type: "Paid",
    player: "Rafik Belghali"
},
{
    date: cleanDate("19-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Mirandés"),
    fromClubId: getClubId("Real Sociedad"),
    id: 1262,
    position: "Forward",
    type: "Loan",
    player: "Carlos Fernández"
},
{
    date: cleanDate("19-08-2025"),
    country: "ESP",
    amount: cleanAmount(17300000),
    toClubId: getClubId("Napoli"),
    fromClubId: getClubId("Girona"),
    id: 1263,
    position: "Defender",
    type: "Paid",
    player: "Miguel Gutiérrez"
},
{
    date: cleanDate("19-08-2025"),
    country: "BEL",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Oviedo"),
    fromClubId: getClubId("Aston Villa"),
    id: 1264,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Leander Dendoncker"
},
{
    date: cleanDate("19-08-2025"),
    country: "SUI",
    amount: cleanAmount(2600000),
    toClubId: getClubId("Al-Shabab"),
    fromClubId: getClubId("Toulouse"),
    id: 1265,
    position: "Midfielder",
    type: "Paid",
    player: "Vincent Sierro"
},
{
    date: cleanDate("19-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Padova"),
    fromClubId: getClubId("Monza"),
    id: 1266,
    position: "Goalkeeper",
    type: "Loan",
    player: "Alessandro Sorrentino"
},
{
    date: cleanDate("18-08-2025"),
    country: "TUN",
    amount: cleanAmount(0),
    toClubId: getClubId("Dijon"),
    fromClubId: getClubId("Brighton"),
    id: 1267,
    position: "Midfielder",
    type: "Free",
    player: "Samy Chouchane"
},
{
    date: cleanDate("22-07-2025"),
    country: "CMR",
    amount: cleanAmount(0),
    toClubId: getClubId("Südtirol"),
    fromClubId: getClubId("Atalanta"),
    id: 1268,
    position: "Forward",
    type: "Loan",
    player: "Jonathan Italeng"
},
{
    date: cleanDate("18-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Quevilly-Rouen"),
    fromClubId: getClubId("Angers"),
    id: 1269,
    position: "Defender",
    type: "Loan",
    player: "Yacine Gaya"
},
{
    date: cleanDate("19-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Pau"),
    fromClubId: getClubId("Paris FC"),
    id: 1270,
    position: "Forward",
    type: "Loan",
    player: "Omar Sissoko"
},
{
    date: cleanDate("19-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Pescara"),
    fromClubId: getClubId("Atalanta"),
    id: 1271,
    position: "Midfielder",
    type: "Loan",
    player: "Andrea Oliveri"
},
{
    date: cleanDate("20-08-2025"),
    country: "JAM",
    amount: cleanAmount(0),
    toClubId: getClubId("Roma"),
    fromClubId: getClubId("Aston Villa"),
    id: 1272,
    position: "Winger",
    type: "Loan",
    player: "Leon Bailey"
},
{
    date: cleanDate("19-08-2025"),
    country: "BRA",
    amount: cleanAmount(4800000),
    toClubId: getClubId("Palmeiras"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 1273,
    position: "Goalkeeper",
    type: "Paid",
    player: "Carlos Miguel"
},
{
    date: cleanDate("19-08-2025"),
    country: "FIN",
    amount: cleanAmount(900000),
    toClubId: getClubId("Magdeburg"),
    fromClubId: getClubId("Hoffenheim"),
    id: 1274,
    position: "Midfielder",
    type: "Paid",
    player: "Luka Hyrylainen"
},
{
    date: cleanDate("19-08-2025"),
    country: "GER",
    amount: cleanAmount(3500000),
    toClubId: getClubId("Union Berlin"),
    fromClubId: getClubId("Galatasaray"),
    id: 1275,
    position: "Defender",
    type: "Paid",
    player: "Derrick Köhn"
},
{
    date: cleanDate("20-08-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Sampdoria"),
    fromClubId: getClubId("Como"),
    id: 1276,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Oliver Abildgaard"
},
{
    date: cleanDate("19-08-2025"),
    country: "GER",
    amount: cleanAmount(0),
    toClubId: getClubId("Paris FC"),
    fromClubId: getClubId("Eintracht Frankfurt"),
    id: 1277,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "Kevin Trapp"
},
{
    date: cleanDate("20-08-2025"),
    country: "NZL",
    amount: cleanAmount(2000000),
    toClubId: getClubId("Swansea"),
    fromClubId: getClubId("Nottingham Forest"),
    id: 1278,
    position: "Midfielder",
    type: "Paid",
    player: "Marko Stamenic"
},
{
    date: cleanDate("19-08-2025"),
    country: "SLO",
    amount: cleanAmount(0),
    toClubId: getClubId("Amiens"),
    fromClubId: getClubId("Pisa"),
    id: 1279,
    position: "Winger",
    type: "Loan",
    player: "Jan Mlakar"
},
{
    date: cleanDate("20-08-2025"),
    country: "AUT",
    amount: cleanAmount(1300000),
    toClubId: getClubId("Brøndby"),
    fromClubId: getClubId("Freiburg"),
    id: 1280,
    position: "Forward",
    type: "Paid",
    player: "Michael Gregoritsch"
},
{
    date: cleanDate("20-08-2025"),
    country: "GER",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Eintracht Frankfurt"),
    fromClubId: getClubId("Werder Bremen"),
    id: 1281,
    position: "Goalkeeper",
    type: "Paid",
    player: "Michael Zetterer"
},
{
    date: cleanDate("20-08-2025"),
    country: "SEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Rayo Vallecano"),
    fromClubId: getClubId("Real Betis"),
    id: 1282,
    position: "Defender",
    type: "Loan",
    player: "Nobel Mendy"
},
{
    date: cleanDate("20-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Avellino"),
    fromClubId: getClubId("Inter"),
    id: 1283,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Alessandro Fontanarosa"
},
{
    date: cleanDate("20-08-2025"),
    country: "MLI",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Lens"),
    fromClubId: getClubId("Rapid Wien"),
    id: 1284,
    position: "Midfielder",
    type: "Paid",
    player: "Mamadou Sangaré"
},
{
    date: cleanDate("20-08-2025"),
    country: "GHA",
    amount: cleanAmount(0),
    toClubId: getClubId("Amedspor"),
    fromClubId: getClubId("Cremonese"),
    id: 1285,
    position: "Forward",
    type: "Loan",
    player: "Felix Afena-Gyan"
},
{
    date: cleanDate("20-08-2025"),
    country: "ITA",
    amount: cleanAmount(6500000),
    toClubId: getClubId("Bologna"),
    fromClubId: getClubId("Cagliari"),
    id: 1286,
    position: "Defender",
    type: "Paid",
    player: "Nadir Zortea"
},
{
    date: cleanDate("20-08-2025"),
    country: "MGO",
    amount: cleanAmount(21700000),
    toClubId: getClubId("Atalanta"),
    fromClubId: getClubId("Lecce"),
    id: 1287,
    position: "Forward",
    type: "Paid",
    player: "Nikola Krstovic"
},
{
    date: cleanDate("20-08-2025"),
    country: "MLI",
    amount: cleanAmount(0),
    toClubId: getClubId("Penafiel"),
    fromClubId: getClubId("Girona"),
    id: 1288,
    position: "Midfielder",
    type: "Free",
    player: "Ibrahima Kébé"
},
{
    date: cleanDate("21-08-2025"),
    country: "SUI",
    amount: cleanAmount(18000000),
    toClubId: getClubId("Leeds United"),
    fromClubId: getClubId("Milan"),
    id: 1289,
    position: "Winger",
    type: "Paid",
    player: "Noah Okafor"
},
{
    date: cleanDate("21-08-2025"),
    country: "MAR",
    amount: cleanAmount(25100000),
    toClubId: getClubId("Bournemouth"),
    fromClubId: getClubId("Bayer Leverkusen"),
    id: 1290,
    position: "Winger",
    type: "Paid",
    player: "Amine Adli"
},
{
    date: cleanDate("21-08-2025"),
    country: "ALG",
    amount: cleanAmount(0),
    toClubId: getClubId("Charleroi"),
    fromClubId: getClubId("Metz"),
    id: 1291,
    position: "Defender",
    type: "Loan",
    player: "Kevin van den Kerkhof"
},
{
    date: cleanDate("21-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Grasshopper"),
    fromClubId: getClubId("Levante"),
    id: 1292,
    position: "Midfielder",
    type: "Free",
    player: "Óscar Clemente"
},
{
    date: cleanDate("21-08-2025"),
    country: "PAR",
    amount: cleanAmount(2160000),
    toClubId: getClubId("Cremonese"),
    fromClubId: getClubId("Torino"),
    id: 1293,
    position: "Forward",
    type: "Paid",
    player: "Antonio Sanabria"
},
{
    date: cleanDate("21-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Levante"),
    fromClubId: getClubId("Real Betis"),
    id: 1294,
    position: "Forward",
    type: "Loan",
    player: "Iker Losada"
},
{
    date: cleanDate("21-08-2025"),
    country: "FRA",
    amount: cleanAmount(21600000),
    toClubId: getClubId("Bayer Leverkusen"),
    fromClubId: getClubId("Sevilla"),
    id: 1295,
    position: "Defender",
    type: "Paid",
    player: "Loïc Badé"
},
{
    date: cleanDate("21-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Espanyol"),
    fromClubId: getClubId("Burnley"),
    id: 1296,
    position: "Winger",
    type: "Loan",
    player: "Luca Koleosho"
},
{
    date: cleanDate("21-08-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Ternana"),
    fromClubId: getClubId("Como"),
    id: 1297,
    position: "Winger",
    type: "Loan",
    player: "Liam Kerrigan"
},
{
    date: cleanDate("21-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Padova"),
    fromClubId: getClubId("Verona"),
    id: 1298,
    position: "Forward",
    type: "Undisclosed Paid",
    player: "Kevin Lasagna"
},
{
    date: cleanDate("21-08-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Bayer Leverkusen"),
    fromClubId: getClubId("Manchester City"),
    id: 1299,
    position: "Midfielder",
    type: "Loan",
    player: "Claudio Echeverri"
},
{
    date: cleanDate("21-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Sampdoria"),
    fromClubId: getClubId("Roma"),
    id: 1300,
    position: "Winger",
    type: "Loan",
    player: "Luigi Cherubini"
},
{
    date: cleanDate("21-08-2025"),
    country: "SWE",
    amount: cleanAmount(0),
    toClubId: getClubId("Verona"),
    fromClubId: getClubId("Galatasaray"),
    id: 1301,
    position: "Defender",
    type: "Loan",
    player: "Victor Nelsson"
},
{
    date: cleanDate("20-08-2025"),
    country: "NGR",
    amount: cleanAmount(0),
    toClubId: getClubId("Wolfsberger AC"),
    fromClubId: getClubId("Hoffenheim"),
    id: 1302,
    position: "Defender",
    type: "Loan",
    player: "Emmanuel Chukwu"
},
{
    date: cleanDate("21-08-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Nottingham Forest"),
    fromClubId: getClubId("Juventus"),
    id: 1303,
    position: "Midfielder",
    type: "Loan",
    player: "Douglas Luiz"
},
{
    date: cleanDate("21-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Mantova"),
    fromClubId: getClubId("Pisa"),
    id: 1304,
    position: "Forward",
    type: "Loan",
    player: "Nicholas Bonfanti"
},
{
    date: cleanDate("21-08-2025"),
    country: "GER",
    amount: cleanAmount(100000),
    toClubId: getClubId("Vancouver Whitecaps"),
    fromClubId: getClubId("Hamburg"),
    id: 1305,
    position: "Defender",
    type: "Paid",
    player: "Sebastian Schonlau"
},
{
    date: cleanDate("21-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Charleroi"),
    fromClubId: getClubId("Paris FC"),
    id: 1306,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Jules Gaudin"
},
{
    date: cleanDate("21-08-2025"),
    country: "USA",
    amount: cleanAmount(5600000),
    toClubId: getClubId("Colorado Rapids"),
    fromClubId: getClubId("Eintracht Frankfurt"),
    id: 1307,
    position: "Midfielder",
    type: "Paid",
    player: "Paxten Aaronson"
},
{
    date: cleanDate("21-08-2025"),
    country: "ARG",
    amount: cleanAmount(7200000),
    toClubId: getClubId("Parma"),
    fromClubId: getClubId("Club Atlético Belgrano"),
    id: 1308,
    position: "Defender",
    type: "Paid",
    player: "Mariano Troilo"
},
{
    date: cleanDate("21-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Bari"),
    fromClubId: getClubId("Lazio"),
    id: 1309,
    position: "Midfielder",
    type: "Free",
    player: "Gaetano Castrovilli"
},
{
    date: cleanDate("21-08-2025"),
    country: "IRL",
    amount: cleanAmount(0),
    toClubId: getClubId("Los Angeles FC"),
    fromClubId: getClubId("Brighton"),
    id: 1310,
    position: "Midfielder",
    type: "Loan",
    player: "Andrew Moran"
},
{
    date: cleanDate("21-08-2025"),
    country: "CRO",
    amount: cleanAmount(0),
    toClubId: getClubId("Real Oviedo"),
    fromClubId: getClubId("Fiorentina"),
    id: 1311,
    position: "Winger",
    type: "Free",
    player: "Josip Brekalo"
},
{
    date: cleanDate("21-08-2025"),
    country: "ENG",
    amount: cleanAmount(7500000),
    toClubId: getClubId("Wrexham"),
    fromClubId: getClubId("Manchester City"),
    id: 1312,
    position: "Defender",
    type: "Paid",
    player: "Callum Doyle"
},
{
    date: cleanDate("22-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Palermo"),
    fromClubId: getClubId("Cagliari"),
    id: 1313,
    position: "Defender",
    type: "Loan",
    player: "Davide Veroli"
},
{
    date: cleanDate("21-08-2025"),
    country: "DEN",
    amount: cleanAmount(0),
    toClubId: getClubId("Southampton"),
    fromClubId: getClubId("Brentford"),
    id: 1314,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Mads Roerslev"
},
{
    date: cleanDate("22-08-2025"),
    country: "GER",
    amount: cleanAmount(4800000),
    toClubId: getClubId("Lecce"),
    fromClubId: getClubId("Fortuna Düsseldorf"),
    id: 1315,
    position: "Defender",
    type: "Paid",
    player: "Jamil Siebert"
},
{
    date: cleanDate("22-08-2025"),
    country: "JPN",
    amount: cleanAmount(0),
    toClubId: getClubId("Karlsruher SC"),
    fromClubId: getClubId("Borussia Mönchengladbach"),
    id: 1316,
    position: "Forward",
    type: "Loan",
    player: "Shio Fukuda"
},
{
    date: cleanDate("22-08-2025"),
    country: "GER",
    amount: cleanAmount(13000000),
    toClubId: getClubId("PSV Eindhoven"),
    fromClubId: getClubId("Bayern Munich"),
    id: 1317,
    position: "Midfielder",
    type: "Paid",
    player: "Paul Wanner"
},
{
    date: cleanDate("22-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Sheffield United"),
    fromClubId: getClubId("Atalanta"),
    id: 1318,
    position: "Defender",
    type: "Loan",
    player: "Ben Godfrey"
},
{
    date: cleanDate("22-08-2025"),
    country: "POR",
    amount: cleanAmount(25600000),
    toClubId: getClubId("Villarreal"),
    fromClubId: getClubId("Chelsea"),
    id: 1319,
    position: "Defender",
    type: "Paid",
    player: "Renato Veiga"
},
{
    date: cleanDate("22-08-2025"),
    country: "COL",
    amount: cleanAmount(0),
    toClubId: getClubId("Cruzeiro"),
    fromClubId: getClubId("Bournemouth"),
    id: 1320,
    position: "Winger",
    type: "Loan",
    player: "Luis Sinisterra"
},
{
    date: cleanDate("22-08-2025"),
    country: "ARG",
    amount: cleanAmount(5000000),
    toClubId: getClubId("Alavés"),
    fromClubId: getClubId("Granada"),
    id: 1321,
    position: "Forward",
    type: "Paid",
    player: "Lucas Boyé"
},
{
    date: cleanDate("22-08-2025"),
    country: "ARG",
    amount: cleanAmount(0),
    toClubId: getClubId("Cremonese"),
    fromClubId: getClubId("Udinese"),
    id: 1322,
    position: "Midfielder",
    type: "Loan",
    player: "Martín Payero"
},
{
    date: cleanDate("22-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Bromley"),
    fromClubId: getClubId("Crystal Palace"),
    id: 1323,
    position: "Forward",
    type: "Loan",
    player: "Jemiah Umolu"
},
{
    date: cleanDate("22-08-2025"),
    country: "EST",
    amount: cleanAmount(0),
    toClubId: getClubId("Werder Bremen"),
    fromClubId: getClubId("Arsenal"),
    id: 1324,
    position: "Goalkeeper",
    type: "Loan",
    player: "Karl Hein"
},
{
    date: cleanDate("22-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Sampdoria"),
    fromClubId: getClubId("Udinese"),
    id: 1325,
    position: "Midfielder",
    type: "Loan",
    player: "Simone Pafundi"
},
{
    date: cleanDate("22-08-2025"),
    country: "BEL",
    amount: cleanAmount(0),
    toClubId: getClubId("Sassuolo"),
    fromClubId: getClubId("Wolfsburg"),
    id: 1326,
    position: "Midfielder",
    type: "Loan",
    player: "Aster Vranckx"
},
{
    date: cleanDate("22-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Preston"),
    fromClubId: getClubId("Aston Villa"),
    id: 1327,
    position: "Forward",
    type: "Loan",
    player: "Lewis Dobbin"
},
{
    date: cleanDate("22-08-2025"),
    country: "FRA",
    amount: cleanAmount(17000000),
    toClubId: getClubId("Inter"),
    fromClubId: getClubId("Lens"),
    id: 1328,
    position: "Midfielder",
    type: "Paid",
    player: "Andy Diouf"
},
{
    date: cleanDate("22-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Girona"),
    fromClubId: getClubId("Aston Villa"),
    id: 1329,
    position: "Defender",
    type: "Undisclosed Paid",
    player: "Àlex Moreno"
},
{
    date: cleanDate("23-08-2025"),
    country: "MEX",
    amount: cleanAmount(0),
    toClubId: getClubId("Fenerbahçe"),
    fromClubId: getClubId("West Ham"),
    id: 1330,
    position: "Midfielder",
    type: "Loan",
    player: "Edson Álvarez"
},
{
    date: cleanDate("23-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Brest"),
    fromClubId: getClubId("Montpellier"),
    id: 1331,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Joris Chotard"
},
{
    date: cleanDate("23-08-2025"),
    country: "USA",
    amount: cleanAmount(6000000),
    toClubId: getClubId("Borussia Mönchengladbach"),
    fromClubId: getClubId("Borussia Dortmund"),
    id: 1332,
    position: "Midfielder",
    type: "Paid",
    player: "Giovanni Reyna"
},
{
    date: cleanDate("23-08-2025"),
    country: "ENG",
    amount: cleanAmount(67500000),
    toClubId: getClubId("Arsenal"),
    fromClubId: getClubId("Crystal Palace"),
    id: 1333,
    position: "Midfielder",
    type: "Paid",
    player: "Eberechi Eze"
},
{
    date: cleanDate("24-08-2025"),
    country: "ESP",
    amount: cleanAmount(1300000),
    toClubId: getClubId("Lecce"),
    fromClubId: getClubId("Córdoba"),
    id: 1334,
    position: "Midfielder",
    type: "Paid",
    player: "Álex Sala"
},
{
    date: cleanDate("22-08-2025"),
    country: "WAL",
    amount: cleanAmount(0),
    toClubId: getClubId("Birmingham City"),
    fromClubId: getClubId("Liverpool"),
    id: 1335,
    position: "Winger",
    type: "Loan",
    player: "Lewis Koumas"
},
{
    date: cleanDate("22-08-2025"),
    country: "ITA",
    amount: cleanAmount(0),
    toClubId: getClubId("Modena"),
    fromClubId: getClubId("Juventus"),
    id: 1336,
    position: "Midfielder",
    type: "Loan",
    player: "Alessandro Sersanti"
},
{
    date: cleanDate("24-08-2025"),
    country: "ENG",
    amount: cleanAmount(17000000),
    toClubId: getClubId("Bologna"),
    fromClubId: getClubId("Marseille"),
    id: 1337,
    position: "Winger",
    type: "Paid",
    player: "Jonathan Rowe"
},
{
    date: cleanDate("24-08-2025"),
    country: "POR",
    amount: cleanAmount(0),
    toClubId: getClubId("Panathinaikos"),
    fromClubId: getClubId("Paris Saint-Germain"),
    id: 1338,
    position: "Midfielder",
    type: "Loan",
    player: "Renato Sanches"
},
{
    date: cleanDate("24-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Red Star"),
    fromClubId: getClubId("Lyon"),
    id: 1339,
    position: "Midfielder",
    type: "Undisclosed Paid",
    player: "Islamdine Halifa"
},
{
    date: cleanDate("25-08-2025"),
    country: "ESP",
    amount: cleanAmount(0),
    toClubId: getClubId("Alavés"),
    fromClubId: getClubId("Real Sociedad"),
    id: 1340,
    position: "Defender",
    type: "Loan",
    player: "Jon Pacheco"
},
{
    date: cleanDate("25-08-2025"),
    country: "ALB",
    amount: cleanAmount(0),
    toClubId: getClubId("Torino"),
    fromClubId: getClubId("Inter"),
    id: 1341,
    position: "Midfielder",
    type: "Loan",
    player: "Kristjan Asllani"
},
{
    date: cleanDate("25-08-2025"),
    country: "FRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Angers"),
    fromClubId: getClubId("Lens"),
    id: 1342,
    position: "Forward",
    type: "Loan",
    player: "Rémy Labeau Lascary"
},
{
    date: cleanDate("25-08-2025"),
    country: "JAM",
    amount: cleanAmount(0),
    toClubId: getClubId("QPR"),
    fromClubId: getClubId("Newcastle"),
    id: 1343,
    position: "Midfielder",
    type: "Free",
    player: "Isaac Hayden"
},
{
    date: cleanDate("25-08-2025"),
    country: "GER",
    amount: cleanAmount(1700000),
    toClubId: getClubId("Espanyol"),
    fromClubId: getClubId("Darmstadt"),
    id: 1344,
    position: "Defender",
    type: "Paid",
    player: "Clemens Riedel"
},
{
    date: cleanDate("25-08-2025"),
    country: "SWE",
    amount: cleanAmount(0),
    toClubId: getClubId("Basel"),
    fromClubId: getClubId("Lens"),
    id: 1345,
    position: "Winger",
    type: "Loan",
    player: "Jeremy Agbonifo"
},
{
    date: cleanDate("25-08-2025"),
    country: "ENG",
    amount: cleanAmount(10000000),
    toClubId: getClubId("Leeds United"),
    fromClubId: getClubId("Leicester City"),
    id: 1346,
    position: "Defender",
    type: "Paid",
    player: "James Justin"
},
{
    date: cleanDate("25-08-2025"),
    country: "ENG",
    amount: cleanAmount(42000000),
    toClubId: getClubId("Everton"),
    fromClubId: getClubId("Southampton"),
    id: 1347,
    position: "Winger",
    type: "Paid",
    player: "Tyler Dibling"
},
{
    date: cleanDate("25-08-2025"),
    country: "ITA",
    amount: cleanAmount(21500000),
    toClubId: getClubId("Fiorentina"),
    fromClubId: getClubId("Cagliari"),
    id: 1348,
    position: "Forward",
    type: "Paid",
    player: "Roberto Piccoli"
},
{
    date: cleanDate("25-08-2025"),
    country: "SUI",
    amount: cleanAmount(4300000),
    toClubId: getClubId("Hoffenheim"),
    fromClubId: getClubId("Lugano"),
    id: 1349,
    position: "Defender",
    type: "Paid",
    player: "Albian Hajdari"
},
{
    date: cleanDate("25-08-2025"),
    country: "GER",
    amount: cleanAmount(2000000),
    toClubId: getClubId("Augsburg"),
    fromClubId: getClubId("Basel"),
    id: 1350,
    position: "Winger",
    type: "Paid",
    player: "Anton Kade"
},
{
    date: cleanDate("25-08-2025"),
    country: "BRA",
    amount: cleanAmount(0),
    toClubId: getClubId("Atlético Mineiro"),
    fromClubId: getClubId("Sassuolo"),
    id: 1351,
    position: "Defender",
    type: "Loan",
    player: "Ruan Tressoldi"
},
{
    date: cleanDate("25-08-2025"),
    country: "NZL",
    amount: cleanAmount(0),
    toClubId: getClubId("Lechia Gdansk"),
    fromClubId: getClubId("Bournemouth"),
    id: 1352,
    position: "Goalkeeper",
    type: "Loan",
    player: "Alex Paulsen"
},
{
    date: cleanDate("25-08-2025"),
    country: "ENG",
    amount: cleanAmount(0),
    toClubId: getClubId("Stoke City"),
    fromClubId: getClubId("Manchester City"),
    id: 1353,
    position: "Goalkeeper",
    type: "Undisclosed Paid",
    player: "True Grant"
}  
];
